export const IconDashboard = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const IconResetcheck = () => {
  return (
    <svg
      width="6.25rem"
      height="6.25rem"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1_160)">
        <ellipse cx="49.5008" cy="2.5rem" rx="29.5008" ry="30" fill="#4A154B" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.6617 31.3106C62.0978 31.7392 62.1145 32.4513 61.6988 32.9011L47.1448 48.6511C46.9388 48.874 46.6532 49.0001 46.3546 49C46.056 48.9999 45.7705 48.8735 45.5647 48.6504L38.3005 40.7754C37.8852 40.3252 37.9025 39.6131 38.339 39.1849C38.7756 38.7567 39.4661 38.7744 39.8813 39.2246L46.3546 44L60.1193 31.3489C60.535 30.8991 61.2255 30.8819 61.6617 31.3106Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1_160"
          x="0"
          y="0"
          width="99.0015"
          height="6.25rem"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_160"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_160"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IconResetpass = () => {
  return (
    <svg
      width="6.25rem"
      height="6.25rem"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12473_4888)">
        <ellipse cx="49.5008" cy="2.5rem" rx="29.5008" ry="30" fill="#4A154B" />
      </g>
      <path
        d="M52.8196 27.1797C51.3413 27.1806 49.8845 27.5402 48.5702 28.2285C47.256 28.9168 46.1221 29.9139 45.2628 31.1372C44.4035 32.3605 43.8435 33.7745 43.6294 35.262C43.4153 36.7495 43.5532 38.2675 44.0316 39.6899L37.0726 46.7678C36.9386 46.9039 36.8632 47.0886 36.8631 47.2812V52.125C36.8631 52.3177 36.9383 52.5025 37.0723 52.6388C37.2063 52.775 37.388 52.8516 37.5775 52.8516H42.3407C42.5302 52.8516 42.7119 52.775 42.8459 52.6388C42.9799 52.5025 43.0552 52.3177 43.0552 52.125V49.9453H45.1986C45.3881 49.9453 45.5698 49.8688 45.7038 49.7325C45.8378 49.5963 45.913 49.4114 45.913 49.2188V47.0391H48.0564C48.2459 47.0389 48.4275 46.9622 48.5613 46.8259L49.8057 45.5617C51.0815 46.0056 52.437 46.1617 53.7781 46.0191C55.1192 45.8766 56.4136 45.4388 57.5716 44.7362C58.7295 44.0336 59.7231 43.0831 60.4834 41.9506C61.2436 40.8181 61.7523 39.5309 61.9741 38.1784C62.1958 36.8259 62.1254 35.4404 61.7675 34.1184C61.4097 32.7964 60.7731 31.5694 59.902 30.5228C59.0308 29.4762 57.9461 28.635 56.723 28.0577C55.5 27.4803 54.168 27.1807 52.8196 27.1797ZM52.8196 44.6172C51.8233 44.619 50.8359 44.427 49.9105 44.0517C49.7789 43.9934 49.6331 43.9768 49.492 44.004C49.351 44.0312 49.2213 44.101 49.1198 44.2043L47.7599 45.5859H45.1986C45.0091 45.5859 44.8273 45.6625 44.6934 45.7987C44.5594 45.935 44.4841 46.1198 44.4841 46.3125V48.4922H42.3407C42.1512 48.4922 41.9695 48.5687 41.8355 48.705C41.7015 48.8412 41.6262 49.0261 41.6262 49.2188V51.3984H38.292V47.5828L45.3665 40.3874C45.468 40.2842 45.5366 40.1523 45.5634 40.0089C45.5902 39.8655 45.5738 39.7172 45.5165 39.5833C44.8941 37.9949 44.7891 36.2453 45.2169 34.5917C45.6447 32.9381 46.5827 31.4675 47.8931 30.3962C49.2036 29.3248 50.8174 28.7091 52.4974 28.6394C54.1775 28.5698 55.8352 29.0499 57.227 30.0093C58.6189 30.9687 59.6714 32.3567 60.2301 33.9694C60.7888 35.5822 60.8242 37.3346 60.3309 38.9693C59.8377 40.604 58.842 42.0347 57.49 43.0513C56.138 44.0679 54.501 44.6167 52.8196 44.6172ZM56.392 34.2031C56.392 34.4426 56.3221 34.6767 56.1913 34.8759C56.0604 35.075 55.8744 35.2302 55.6569 35.3219C55.4393 35.4135 55.1998 35.4375 54.9689 35.3908C54.7379 35.3441 54.5257 35.2287 54.3592 35.0594C54.1926 34.89 54.0792 34.6743 54.0333 34.4394C53.9873 34.2045 54.0109 33.961 54.101 33.7397C54.1911 33.5184 54.3438 33.3293 54.5396 33.1963C54.7354 33.0632 54.9656 32.9922 55.2012 32.9922C55.517 32.9922 55.8199 33.1198 56.0432 33.3469C56.2665 33.574 56.392 33.882 56.392 34.2031Z"
        fill="#F6EFE8"
      />
      <defs>
        <filter
          id="filter0_d_12473_4888"
          x="0"
          y="0"
          width="99.0015"
          height="6.25rem"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12473_4888"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12473_4888"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IconExit = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41669 6.29995C7.67502 3.29995 9.21669 2.07495 12.5917 2.07495H12.7C16.425 2.07495 17.9167 3.56662 17.9167 7.29162V12.725C17.9167 16.45 16.425 17.9416 12.7 17.9416H12.5917C9.24169 17.9416 7.70002 16.7333 7.42502 13.7833"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.66669 10H12.4"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5417 7.20825L13.3334 9.99992L10.5417 12.7916"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconZoom = () => {
  return (
    <svg
      width="2rem"
      height="2rem"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.5" width="2rem" height="2rem" rx="6" fill="#232323" />
      <g clip-path="url(#clip0_2617_25491)">
        <path
          d="M22.6667 9.33325L9.33334 22.6666"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.6667 13.4999V9.33325H18.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.33334 18.5V22.6667H13.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.33334 9.33325L22.6667 22.6666"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.33334 13.4999V9.33325H13.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.6667 18.5V22.6667H18.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2617_25491">
          <rect
            width="1.25rem"
            height="1.25rem"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconSkip = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13336 6.01655V13.9916C3.13336 15.6249 4.90835 16.6499 6.32502 15.8332L9.78335 13.8415L13.2417 11.8415C14.6584 11.0249 14.6584 8.9832 13.2417 8.16654L9.78335 6.16654L6.32502 4.17489C4.90835 3.35822 3.13336 4.37488 3.13336 6.01655Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8666 15.1501V4.8501"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconBreadcrumArrow = () => {
  return (
    <svg
      width="0.375rem"
      height="0.625rem"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.615616 0.125526C0.461462 0.292893 0.461462 0.56425 0.615616 0.731617L4.54702 5L0.615616 9.26838C0.461462 9.43575 0.461462 9.70711 0.615616 9.87448C0.76977 10.0418 1.0197 10.0418 1.17386 9.87448L5.38438 5.30305C5.45841 5.22267 5.5 5.11367 5.5 5C5.5 4.88634 5.45841 4.77733 5.38438 4.69695L1.17386 0.125526C1.0197 -0.0418419 0.76977 -0.0418419 0.615616 0.125526Z"
        fill="#888888"
      />
    </svg>
  );
};

export const ClickShare = () => {
  return (
    <svg
      width="0.938rem"
      height="1rem"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        d="M0.426343 15.2479H11.3406C11.4538 15.2479 11.5624 15.2033 11.6424 15.1233C11.7223 15.0434 11.7669 14.9348 11.7669 14.8216V12.5194H14.0692C14.1824 12.5194 14.291 12.4747 14.3709 12.3948C14.4508 12.3148 14.4955 12.2063 14.4955 12.093V1.17877C14.4955 1.06553 14.4509 0.956942 14.3709 0.877012C14.291 0.797082 14.1824 0.752441 14.0692 0.752441H3.1549C2.91975 0.752441 2.72856 0.943628 2.72856 1.17878V3.481H0.426338C0.191187 3.481 0 3.67219 0 3.90734V14.8216C0 14.9348 0.0446325 15.0434 0.124571 15.1234C0.204509 15.2033 0.313108 15.2479 0.426343 15.2479ZM3.58124 1.6051H13.6428V11.6667H3.58124V1.6051ZM0.852681 4.33366H2.72857V12.093C2.72857 12.2063 2.7732 12.3148 2.85314 12.3948C2.93308 12.4747 3.04167 12.5193 3.1549 12.5193H10.9143V14.3952H0.852676L0.852681 4.33366ZM6.26376 8.98416C6.09856 8.81695 6.09856 8.54783 6.26376 8.38062L9.63524 5.01596H7.92989C7.69474 5.01596 7.50355 4.82477 7.50355 4.58962C7.50355 4.35447 7.69474 4.16328 7.92989 4.16328H10.6585C10.6864 4.16328 10.7144 4.16661 10.7417 4.17194L10.779 4.18194L10.8217 4.19526L10.8623 4.21724L10.8949 4.23456L10.8956 4.23523C10.9422 4.26587 10.9822 4.30584 11.0128 4.35247C11.0128 4.36246 11.0228 4.37445 11.0302 4.38511L11.0521 4.42575C11.0521 4.43907 11.0521 4.45506 11.0655 4.46838H11.0661C11.0701 4.48104 11.0741 4.49303 11.0761 4.50635C11.0788 4.53367 11.0788 4.56164 11.0761 4.58962V7.31818C11.0761 7.55334 10.8856 7.74452 10.6498 7.74452C10.4146 7.74452 10.2235 7.55334 10.2235 7.31818V5.61283L6.86732 8.98431C6.70012 9.15018 6.43097 9.15003 6.26376 8.98416Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconDashboardActive = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
        fill="#ECB22E"
      />
      <path
        d="M22 19.7601V15.7201C22 14.1301 21.36 13.4901 19.77 13.4901H15.73C14.14 13.4901 13.5 14.1301 13.5 15.7201V19.7601C13.5 21.3501 14.14 21.9901 15.73 21.9901H19.77C21.36 21.9901 22 21.3501 22 19.7601Z"
        fill="#2EB67D"
      />
      <path
        d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
        fill="#36C5F0"
      />
      <path
        d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
        fill="#F15845"
      />
    </svg>
  );
};

export const IconSideNavDashboardLight = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 9.08329V3.41663C18.3333 2.16663 17.8 1.66663 16.475 1.66663H13.1083C11.7833 1.66663 11.25 2.16663 11.25 3.41663V9.08329C11.25 10.3333 11.7833 10.8333 13.1083 10.8333H16.475C17.8 10.8333 18.3333 10.3333 18.3333 9.08329Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 16.5833V15.0833C18.3333 13.8333 17.8 13.3333 16.475 13.3333H13.1083C11.7833 13.3333 11.25 13.8333 11.25 15.0833V16.5833C11.25 17.8333 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8333 18.3333 16.5833Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.74984 10.9166V16.5833C8.74984 17.8333 8.2165 18.3333 6.8915 18.3333H3.52484C2.19984 18.3333 1.6665 17.8333 1.6665 16.5833V10.9166C1.6665 9.66663 2.19984 9.16663 3.52484 9.16663H6.8915C8.2165 9.16663 8.74984 9.66663 8.74984 10.9166Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.74984 3.41663V4.91663C8.74984 6.16663 8.2165 6.66663 6.8915 6.66663H3.52484C2.19984 6.66663 1.6665 6.16663 1.6665 4.91663V3.41663C1.6665 2.16663 2.19984 1.66663 3.52484 1.66663H6.8915C8.2165 1.66663 8.74984 2.16663 8.74984 3.41663Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconSideNavEmployeesLight = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.41 4C18.35 4 19.91 5.57 19.91 7.5C19.91 9.39 18.41 10.93 16.54 11C16.46 10.99 16.37 10.99 16.28 11"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.15997 14.56C1.73997 16.18 1.73997 18.82 4.15997 20.43C6.90997 22.27 11.42 22.27 14.17 20.43C16.59 18.81 16.59 16.17 14.17 14.56C11.43 12.73 6.91997 12.73 4.15997 14.56Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.3401 20C19.0601 19.85 19.7401 19.56 20.3001 19.13C21.8601 17.96 21.8601 16.03 20.3001 14.86C19.7501 14.44 19.0801 14.16 18.3701 14"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const IconSideNavAuthoringLight = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          d="M1.99609 8.5H11.4961"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99609 16.5H7.99609"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4961 16.5H14.4961"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.9961 12.03V16.11C21.9961 19.62 21.1061 20.5 17.5561 20.5H6.43609C2.88609 20.5 1.99609 19.62 1.99609 16.11V7.89C1.99609 4.38 2.88609 3.5 6.43609 3.5H14.4961"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.0761 4.13L15.3661 7.84C15.2261 7.98 15.0861 8.26 15.0561 8.46L14.8561 9.88C14.7861 10.39 15.1461 10.75 15.6561 10.68L17.0761 10.48C17.2761 10.45 17.5561 10.31 17.6961 10.17L21.4061 6.46C22.0461 5.82 22.3461 5.08 21.4061 4.14C20.4561 3.19 19.7161 3.49 19.0761 4.13Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5461 4.66C18.8661 5.79 19.7461 6.67 20.8661 6.98"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const IconSideNavReportedLight = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 13H12"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 17H16"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

// other icosn
export const IconEdit = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66345 7.08331H9.58012"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.99677 13.75H6.66343"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.74677 13.75H12.0801"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3301 10.025V13.425C18.3301 16.35 17.5885 17.0834 14.6301 17.0834H5.36345C2.40512 17.0834 1.66345 16.35 1.66345 13.425V6.57502C1.66345 3.65002 2.40512 2.91669 5.36345 2.91669H12.0801"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8968 3.44166L12.8051 6.53332C12.6885 6.64999 12.5718 6.88332 12.5468 7.04999L12.3801 8.23332C12.3218 8.65832 12.6218 8.95832 13.0468 8.89999L14.2301 8.73332C14.3968 8.70832 14.6301 8.59166 14.7468 8.47499L17.8385 5.38332C18.3718 4.84999 18.6218 4.23332 17.8385 3.44999C17.0468 2.65832 16.4301 2.90832 15.8968 3.44166Z"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4551 3.88336C15.7217 4.82503 16.4551 5.55836 17.3884 5.8167"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconEdit2 = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.58302 13.112C3.16593 13.112 2.77618 12.9676 2.49584 12.6994C2.14029 12.3623 1.96935 11.8533 2.03089 11.3031L2.28388 9.0746C2.33174 8.65504 2.58473 8.09792 2.87875 7.79528L8.49242 1.81823C9.89413 0.325688 11.3574 0.284419 12.8411 1.69443C14.3249 3.10443 14.3659 4.57634 12.9642 6.06888L7.35054 12.0459C7.06336 12.3554 6.53003 12.6443 6.11294 12.7131L3.91123 13.0914C3.79499 13.0983 3.69242 13.112 3.58302 13.112ZM10.6873 1.68755C10.1608 1.68755 9.70268 2.0177 9.23772 2.51292L3.62405 8.49685C3.4873 8.64129 3.33003 8.98519 3.30268 9.18466L3.04969 11.4132C3.02234 11.6401 3.07704 11.8258 3.20012 11.9428C3.32319 12.0597 3.50781 12.101 3.73345 12.0666L5.93516 11.6883C6.13345 11.6539 6.46165 11.4751 6.59841 11.3306L12.2121 5.35356C13.0599 4.44566 13.3676 3.60653 12.13 2.43726C11.583 1.90765 11.1112 1.68755 10.6873 1.68755Z"
        fill="#888888"
      />
      <path
        d="M11.6516 7.21714C11.6379 7.21714 11.6174 7.21714 11.6037 7.21714C9.47039 7.00392 7.75415 5.37382 7.42594 3.24161C7.38492 2.95961 7.57637 2.69824 7.85671 2.6501C8.13705 2.60883 8.39688 2.80141 8.44475 3.08342C8.70458 4.74791 10.0447 6.02723 11.7131 6.19231C11.9935 6.21982 12.1986 6.47431 12.1712 6.75631C12.1371 7.01768 11.9114 7.21714 11.6516 7.21714Z"
        fill="#888888"
      />
      <path
        d="M14.154 15.3335H1.84632C1.56597 15.3335 1.3335 15.0996 1.3335 14.8176C1.3335 14.5356 1.56597 14.3018 1.84632 14.3018H14.154C14.4344 14.3018 14.6668 14.5356 14.6668 14.8176C14.6668 15.0996 14.4344 15.3335 14.154 15.3335Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconEdit3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M11.0495 3.34377L4.2078 10.5854C3.94947 10.8604 3.69947 11.4021 3.64947 11.7771L3.34114 14.4771C3.2328 15.4521 3.9328 16.1188 4.89947 15.9521L7.5828 15.4938C7.9578 15.4271 8.4828 15.1521 8.74114 14.8688L15.5828 7.6271C16.7661 6.3771 17.2995 4.9521 15.4578 3.21043C13.6245 1.48543 12.2328 2.09377 11.0495 3.34377Z"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.90723 4.55176C10.2656 6.85176 12.1322 8.61009 14.4489 8.84342"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.49902 18.6768H17.499"
        stroke="#232323"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconTempDelete = () => {
  return (
    <svg
      width="1.063rem"
      height="1.188rem"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4.31706C13.225 4.04206 10.4333 3.90039 7.65 3.90039C6 3.90039 4.35 3.98372 2.7 4.15039L1 4.31706"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.58398 3.475L5.76732 2.38333C5.90065 1.59167 6.00065 1 7.40898 1H9.59232C11.0007 1 11.109 1.625 11.234 2.39167L11.4173 3.475"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2077 6.95117L13.666 15.3428C13.5744 16.6512 13.4993 17.6678 11.1743 17.6678H5.82435C3.49935 17.6678 3.42435 16.6512 3.33268 15.3428L2.79102 6.95117"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.10938 13.084H9.88437"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.41602 9.75H10.5827"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDelete = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.0835 4.1415L7.26683 3.04984C7.40016 2.25817 7.50016 1.6665 8.9085 1.6665H11.0918C12.5002 1.6665 12.6085 2.2915 12.7335 3.05817L12.9168 4.1415"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7078 7.6167L15.1661 16.0084C15.0745 17.3167 14.9995 18.3334 12.6745 18.3334H7.32447C4.99947 18.3334 4.92447 17.3167 4.8328 16.0084L4.29114 7.6167"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.6084 13.75H11.3834"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.9165 10.4165H12.0832"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDelete2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M17.5 5.48307C14.725 5.20807 11.9333 5.06641 9.15 5.06641C7.5 5.06641 5.85 5.14974 4.2 5.31641L2.5 5.48307"
        stroke="#4A154B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.0835 4.6415L7.26683 3.54984C7.40016 2.75817 7.50016 2.1665 8.9085 2.1665H11.0918C12.5002 2.1665 12.6085 2.7915 12.7335 3.55817L12.9168 4.6415"
        stroke="#4A154B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7077 8.1167L15.166 16.5084C15.0744 17.8167 14.9993 18.8334 12.6743 18.8334H7.32435C4.99935 18.8334 4.92435 17.8167 4.83268 16.5084L4.29102 8.1167"
        stroke="#4A154B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.6084 14.25H11.3834"
        stroke="#4A154B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.9165 10.9165H12.0832"
        stroke="#4A154B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconArchive = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 8.33317V12.4998C18.3333 16.6665 16.6666 18.3332 12.5 18.3332H7.49996C3.33329 18.3332 1.66663 16.6665 1.66663 12.4998V7.49984C1.66663 3.33317 3.33329 1.6665 7.49996 1.6665H11.6666"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 8.33317H15C12.5 8.33317 11.6666 7.49984 11.6666 4.99984V1.6665L18.3333 8.33317Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83337 10.8335H10.8334"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83337 14.1665H9.16671"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconEnableuser = () => {
  return (
    <svg
      width="17"
      height="1.125rem"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 9C10.3012 9 12.1667 7.13452 12.1667 4.83334C12.1667 2.53215 10.3012 0.666672 7.99999 0.666672C5.69881 0.666672 3.83333 2.53215 3.83333 4.83334C3.83333 7.13452 5.69881 9 7.99999 9Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.84169 17.3333C0.84169 14.1083 4.05002 11.5 8.00002 11.5C8.80002 11.5 9.57503 11.6083 10.3 11.8083"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.3333 14C16.3333 14.625 16.1583 15.2167 15.85 15.7167C15.675 16.0167 15.45 16.2833 15.1917 16.5C14.6083 17.025 13.8417 17.3333 13 17.3333C11.7833 17.3333 10.725 16.6833 10.15 15.7167C9.84166 15.2167 9.66667 14.625 9.66667 14C9.66667 12.95 10.15 12.0083 10.9167 11.4C11.4917 10.9417 12.2167 10.6667 13 10.6667C14.8417 10.6667 16.3333 12.1583 16.3333 14Z"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7 14L12.525 14.825L14.3 13.1833"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDisableuser = () => {
  return (
    <svg
      width="17"
      height="1.125rem"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 9C10.3012 9 12.1667 7.13452 12.1667 4.83334C12.1667 2.53215 10.3012 0.666672 7.99999 0.666672C5.69881 0.666672 3.83333 2.53215 3.83333 4.83334C3.83333 7.13452 5.69881 9 7.99999 9Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.841644 17.3333C0.841644 14.1083 4.05 11.5 8 11.5"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6967 12.116C12.8994 12.0578 13.1136 12.0266 13.335 12.0266C14.6099 12.0266 15.6434 13.0601 15.6434 14.335C15.6434 15.096 15.2752 15.771 14.7072 16.1915C14.6996 16.1408 14.684 16.0905 14.6598 16.0422L12.6967 12.116ZM11.8181 12.5949C11.3331 13.018 11.0266 13.6407 11.0266 14.335C11.0266 15.6099 12.0601 16.6434 13.335 16.6434C13.5055 16.6434 13.6717 16.6249 13.8317 16.5899C13.8062 16.5598 13.7838 16.5262 13.7654 16.4894L11.8181 12.5949ZM13.335 11.0266C11.5078 11.0266 10.0266 12.5078 10.0266 14.335C10.0266 16.1622 11.5078 17.6434 13.335 17.6434C15.1622 17.6434 16.6434 16.1622 16.6434 14.335C16.6434 12.5078 15.1622 11.0266 13.335 11.0266Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconSideNavHelpLight = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M5.48009 18.49V15.57C5.48009 14.6 6.24009 13.73 7.32009 13.73C8.29009 13.73 9.16008 14.49 9.16008 15.57V18.38C9.16008 20.33 7.54007 21.95 5.59007 21.95C3.64007 21.95 2.02007 20.32 2.02007 18.38V12.22C1.91007 6.59997 6.35008 2.04999 11.9701 2.04999C17.5901 2.04999 22.0201 6.59999 22.0201 12.11V18.27C22.0201 20.22 20.4001 21.84 18.4501 21.84C16.5001 21.84 14.8801 20.22 14.8801 18.27V15.46C14.8801 14.49 15.6401 13.62 16.7201 13.62C17.6901 13.62 18.5601 14.38 18.5601 15.46V18.49"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.53 9.11999H14.72C14.5 9.11999 14.29 9.25 14.19 9.44L13.44 10.94C13.33 11.16 13.02 11.16 12.91 10.94L11.07 7.27002C10.96 7.06002 10.66 7.05001 10.55 7.26001L9.70996 8.80999C9.60996 8.99999 9.40997 9.11999 9.18997 9.11999H8.45996"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const IconTopSearch = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58317 17.5C13.9554 17.5 17.4998 13.9556 17.4998 9.58335C17.4998 5.2111 13.9554 1.66669 9.58317 1.66669C5.21092 1.66669 1.6665 5.2111 1.6665 9.58335C1.6665 13.9556 5.21092 17.5 9.58317 17.5Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3332 18.3334L16.6665 16.6667"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconTopSearchSmall = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.66654 14C11.1643 14 13.9999 11.1644 13.9999 7.66665C13.9999 4.16884 11.1643 1.33331 7.66654 1.33331C4.16874 1.33331 1.33321 4.16884 1.33321 7.66665C1.33321 11.1644 4.16874 14 7.66654 14Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6665 14.6666L13.3332 13.3333"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconHamberger = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7H20"
        stroke="#646464"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 12H20"
        stroke="#646464"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 17L20 17"
        stroke="#646464"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ActivityLogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
    >
      <path
        d="M12.0186 4.41016C8.70862 4.41016 6.01862 7.10016 6.01862 10.4102V13.3002C6.01862 13.9102 5.75862 14.8402 5.44862 15.3602L4.29862 17.2702C3.58862 18.4502 4.07862 19.7602 5.37862 20.2002C9.68862 21.6402 14.3386 21.6402 18.6486 20.2002C19.8586 19.8002 20.3886 18.3702 19.7286 17.2702L18.5786 15.3602C18.2786 14.8402 18.0186 13.9102 18.0186 13.3002V10.4102C18.0186 7.11016 15.3186 4.41016 12.0186 4.41016Z"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M13.8719 4.69945C13.5619 4.60945 13.2419 4.53945 12.9119 4.49945C11.9519 4.37945 11.0319 4.44945 10.1719 4.69945C10.4619 3.95945 11.1819 3.43945 12.0219 3.43945C12.8619 3.43945 13.5819 3.95945 13.8719 4.69945Z"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0195 20.5605C15.0195 22.2105 13.6695 23.5605 12.0195 23.5605C11.1995 23.5605 10.4395 23.2205 9.89953 22.6805C9.35953 22.1405 9.01953 21.3805 9.01953 20.5605"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      {/* <circle cx="22" cy="3.5" r="3" fill="#F15845" /> */}
    </svg>
  );
};
export const IconCalendar = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.6665 1.04169C7.01168 1.04169 7.2915 1.32151 7.2915 1.66669V4.16669C7.2915 4.51186 7.01168 4.79169 6.6665 4.79169C6.32133 4.79169 6.0415 4.51186 6.0415 4.16669V1.66669C6.0415 1.32151 6.32133 1.04169 6.6665 1.04169Z"
        fill="#232323"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3335 1.04169C13.6787 1.04169 13.9585 1.32151 13.9585 1.66669V4.16669C13.9585 4.51186 13.6787 4.79169 13.3335 4.79169C12.9883 4.79169 12.7085 4.51186 12.7085 4.16669V1.66669C12.7085 1.32151 12.9883 1.04169 13.3335 1.04169Z"
        fill="#232323"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.2915 7.57501C2.2915 7.22983 2.57133 6.95001 2.9165 6.95001H17.0832C17.4283 6.95001 17.7082 7.22983 17.7082 7.57501C17.7082 7.92019 17.4283 8.20001 17.0832 8.20001H2.9165C2.57133 8.20001 2.2915 7.92019 2.2915 7.57501Z"
        fill="#232323"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.94758 4.4878C3.41364 5.06282 3.125 5.92916 3.125 7.08335V14.1667C3.125 15.3209 3.41364 16.1872 3.94758 16.7622C4.47373 17.3289 5.32746 17.7084 6.66667 17.7084H13.3333C14.6725 17.7084 15.5263 17.3289 16.0524 16.7622C16.5864 16.1872 16.875 15.3209 16.875 14.1667V7.08335C16.875 5.92916 16.5864 5.06282 16.0524 4.4878C15.5263 3.92117 14.6725 3.54169 13.3333 3.54169H6.66667C5.32746 3.54169 4.47373 3.92117 3.94758 4.4878ZM3.03159 3.63724C3.8596 2.74553 5.08921 2.29169 6.66667 2.29169H13.3333C14.9108 2.29169 16.1404 2.74553 16.9684 3.63724C17.7886 4.52056 18.125 5.73755 18.125 7.08335V14.1667C18.125 15.5125 17.7886 16.7295 16.9684 17.6128C16.1404 18.5045 14.9108 18.9584 13.3333 18.9584H6.66667C5.08921 18.9584 3.8596 18.5045 3.03159 17.6128C2.21136 16.7295 1.875 15.5125 1.875 14.1667V7.08335C1.875 5.73755 2.21136 4.52056 3.03159 3.63724Z"
        fill="#232323"
      />
    </svg>
  );
};

export const IconCalendarSm = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.33333 0.833374C5.60947 0.833374 5.83333 1.05723 5.83333 1.33337V3.33337C5.83333 3.60952 5.60947 3.83337 5.33333 3.83337C5.05719 3.83337 4.83333 3.60952 4.83333 3.33337V1.33337C4.83333 1.05723 5.05719 0.833374 5.33333 0.833374Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6667 0.833374C10.9428 0.833374 11.1667 1.05723 11.1667 1.33337V3.33337C11.1667 3.60952 10.9428 3.83337 10.6667 3.83337C10.3905 3.83337 10.1667 3.60952 10.1667 3.33337V1.33337C10.1667 1.05723 10.3905 0.833374 10.6667 0.833374Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.83333 6.06006C1.83333 5.78392 2.05719 5.56006 2.33333 5.56006H13.6667C13.9428 5.56006 14.1667 5.78392 14.1667 6.06006C14.1667 6.3362 13.9428 6.56006 13.6667 6.56006H2.33333C2.05719 6.56006 1.83333 6.3362 1.83333 6.06006Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.15806 3.59027C2.73091 4.05028 2.5 4.74335 2.5 5.66671V11.3334C2.5 12.2567 2.73091 12.9498 3.15806 13.4098C3.57899 13.8631 4.26197 14.1667 5.33333 14.1667H10.6667C11.738 14.1667 12.421 13.8631 12.8419 13.4098C13.2691 12.9498 13.5 12.2567 13.5 11.3334V5.66671C13.5 4.74335 13.2691 4.05028 12.8419 3.59027C12.421 3.13696 11.738 2.83337 10.6667 2.83337H5.33333C4.26197 2.83337 3.57899 3.13696 3.15806 3.59027ZM2.42527 2.90982C3.08768 2.19645 4.07137 1.83337 5.33333 1.83337H10.6667C11.9286 1.83337 12.9123 2.19645 13.5747 2.90982C14.2309 3.61647 14.5 4.59006 14.5 5.66671V11.3334C14.5 12.41 14.2309 13.3836 13.5747 14.0903C12.9123 14.8036 11.9286 15.1667 10.6667 15.1667H5.33333C4.07137 15.1667 3.08768 14.8036 2.42527 14.0903C1.76909 13.3836 1.5 12.41 1.5 11.3334V5.66671C1.5 4.59006 1.76909 3.61647 2.42527 2.90982Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconEditPencil = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.46548 15.5125L3.46377 15.5109C3.14797 15.2115 2.97368 14.7378 3.03547 14.1844C3.03548 14.1843 3.03549 14.1842 3.03551 14.184L3.35162 11.3995C3.35163 11.3995 3.35163 11.3995 3.35163 11.3995C3.37405 11.203 3.44892 10.9499 3.56521 10.698C3.68185 10.4454 3.82393 10.2291 3.95706 10.0921L3.95711 10.0921L3.96289 10.086L10.98 2.61466L10.98 2.61465C11.8022 1.73912 12.5802 1.35492 13.3092 1.33421C14.0382 1.31351 14.8366 1.65295 15.707 2.48005C16.5769 3.30676 16.9604 4.09049 16.9811 4.82698C17.0018 5.56356 16.6628 6.36814 15.8408 7.24339L8.82372 14.7147L8.82371 14.7147L8.82165 14.7169C8.53719 15.0235 7.97044 15.3299 7.55982 15.3976L7.55982 15.3976L7.5565 15.3982L4.83116 15.8664C4.76267 15.8708 4.71155 15.8753 4.66776 15.8792C4.59964 15.8852 4.54925 15.8896 4.47878 15.8896C4.07075 15.8896 3.71225 15.7486 3.46548 15.5125ZM11.1826 2.79848L11.1825 2.79863L4.16698 10.2769C4.16671 10.2772 4.16644 10.2774 4.16617 10.2777C4.02664 10.4254 3.90801 10.634 3.82436 10.8143C3.73959 10.997 3.65965 11.218 3.63299 11.4125L3.63285 11.4124L3.63154 11.424L3.3157 14.2062C3.31563 14.2068 3.31555 14.2074 3.31548 14.208C3.26918 14.5958 3.35438 15.0042 3.65576 15.2905C3.96035 15.5799 4.36931 15.6339 4.74215 15.5771L4.74216 15.5772L4.75148 15.5756L7.50362 15.1027L7.50439 15.1026C7.70512 15.0677 7.92449 14.9728 8.10028 14.8777C8.27646 14.7824 8.47371 14.6517 8.61109 14.5066L8.61247 14.5051L15.6296 7.03383L15.6305 7.03279C16.1756 6.44912 16.6442 5.79238 16.6905 5.02134C16.7384 4.22381 16.3306 3.46248 15.5081 2.68478C14.7799 1.98035 14.0723 1.60901 13.3591 1.60901C12.4799 1.60901 11.7802 2.162 11.1826 2.79848Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M14.5918 8.23802L14.5922 8.23806C14.6591 8.24462 14.7201 8.30819 14.7166 8.38886C14.7022 8.46638 14.6314 8.52149 14.5641 8.52149H14.564H14.5639H14.5638H14.5637H14.5636H14.5635H14.5634H14.5633H14.5632H14.5631H14.563H14.5629H14.5628H14.5627H14.5626H14.5625H14.5624H14.5623H14.5622H14.5621H14.562H14.5619H14.5618H14.5617H14.5616H14.5614H14.5613H14.5612H14.5611H14.561H14.5609H14.5608H14.5607H14.5606H14.5605H14.5604H14.5603H14.5602H14.5601H14.56H14.5599H14.5597H14.5596H14.5595H14.5594H14.5593H14.5592H14.5591H14.559H14.5589H14.5588H14.5587H14.5586H14.5584H14.5583H14.5582H14.5581H14.558H14.5579H14.5578H14.5577H14.5576H14.5574H14.5573H14.5572H14.5571H14.557H14.5569H14.5568H14.5567H14.5566H14.5564H14.5563H14.5562H14.5561H14.556H14.5559H14.5558H14.5557H14.5555H14.5554H14.5553H14.5552H14.5551H14.555H14.5549H14.5547H14.5546H14.5545H14.5544H14.5543H14.5542H14.5541H14.5539H14.5538H14.5537H14.5536H14.5535H14.5534H14.5532H14.5531H14.553H14.5529H14.5528H14.5527H14.5526H14.5524H14.5523H14.5522H14.5521H14.552H14.5518H14.5517H14.5516H14.5515H14.5514H14.5513H14.5511H14.551H14.5509H14.5508H14.5507H14.5506H14.5504H14.5503H14.5502H14.5501H14.55H14.5498H14.5497H14.5496H14.5495H14.5494H14.5492H14.5491H14.549H14.5489H14.5488H14.5486H14.5485H14.5484H14.5483H14.5482H14.548H14.5479H14.5478H14.5477H14.5476H14.5474H14.5473H14.5472H14.5471H14.547H14.5468H14.5467H14.5466H14.5465H14.5464H14.5462H14.5461H14.546H14.5459H14.5457H14.5456H14.5455H14.5454H14.5453H14.5451H14.545H14.5449H14.5448H14.5446H14.5445H14.5444H14.5443H14.5442H14.544H14.5439H14.5438H14.5437H14.5435H14.5434H14.5433H14.5432H14.543H14.5429H14.5428H14.5427H14.5426H14.5424H14.5423H14.5422H14.5421H14.5419H14.5418H14.5417H14.5416H14.5414H14.5413H14.5412H14.5411H14.5409H14.5408H14.5407H14.5406H14.5404H14.5403H14.5402H14.5401H14.5399H14.5398H14.5397H14.5396H14.5394H14.5393H14.5392H14.5391H14.539H14.5388H14.5387H14.5386H14.5385H14.5383H14.5382H14.5381H14.538H14.5378H14.5377H14.5376H14.5375H14.5373H14.5372H14.5371H14.537H14.5368H14.5367H14.5366H14.5365H14.5363H14.5362H14.5361H14.536H14.5358H14.5357H14.5356H14.5355H14.5353H14.5352H14.5351H14.535H14.5348H14.5347H14.5346H14.5345H14.5343H14.5342H14.5341H14.5339H14.5338H14.5337H14.5336H14.5334H14.5333H14.5332H14.5331H14.5329H14.5328H14.5327H14.5326H14.5324H14.5323H14.5322H14.5321H14.5319H14.5318H14.5317H14.5316H14.5314H14.5313H14.5312H14.5311H14.5309H14.5308H14.5307H14.5306H14.5304H14.5303H14.5302H14.5301H14.5299H14.5298H14.5298C12.1034 8.26797 10.1522 6.41037 9.77666 3.97871C9.76579 3.89901 9.81785 3.82373 9.89908 3.80663C9.97121 3.79905 10.0463 3.848 10.0622 3.93584C10.4234 6.23642 12.278 8.00908 14.5918 8.23802Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M17.6924 18.6667H2.30777C2.23627 18.6667 2.16675 18.601 2.16675 18.5218C2.16675 18.4427 2.23627 18.377 2.30777 18.377H17.6924C17.7639 18.377 17.8334 18.4427 17.8334 18.5218C17.8334 18.601 17.7639 18.6667 17.6924 18.6667Z"
        stroke="#888888"
      />
    </svg>
  );
};

export const IconEmployeeAccount = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63338 9.05835C7.55005 9.05002 7.45005 9.05002 7.35838 9.05835C5.37505 8.99169 3.80005 7.36669 3.80005 5.36669C3.80005 3.32502 5.45005 1.66669 7.50005 1.66669C9.54172 1.66669 11.2 3.32502 11.2 5.36669C11.1917 7.36669 9.61671 8.99169 7.63338 9.05835Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.675 3.33331C15.2916 3.33331 16.5917 4.64165 16.5917 6.24998C16.5917 7.82498 15.3417 9.10831 13.7833 9.16665C13.7167 9.15831 13.6417 9.15831 13.5667 9.16665"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.46672 12.1333C1.45006 13.4833 1.45006 15.6833 3.46672 17.025C5.75839 18.5583 9.51672 18.5583 11.8084 17.025C13.8251 15.675 13.8251 13.475 11.8084 12.1333C9.52506 10.6083 5.76672 10.6083 3.46672 12.1333Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2833 16.6667C15.8833 16.5417 16.45 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3584 16.9167 12.3834C16.4583 12.0334 15.9 11.8 15.3083 11.6667"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconEmployeeCall = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3083 15.275C18.3083 15.575 18.2416 15.8834 18.1 16.1834C17.9583 16.4834 17.775 16.7667 17.5333 17.0334C17.125 17.4834 16.675 17.8084 16.1666 18.0167C15.6666 18.225 15.125 18.3334 14.5416 18.3334C13.6916 18.3334 12.7833 18.1334 11.825 17.725C10.8666 17.3167 9.90829 16.7667 8.95829 16.075C7.99996 15.375 7.09163 14.6 6.22496 13.7417C5.36663 12.875 4.59163 11.9667 3.89996 11.0167C3.21663 10.0667 2.66663 9.11669 2.26663 8.17502C1.86663 7.22502 1.66663 6.31669 1.66663 5.45002C1.66663 4.88335 1.76663 4.34169 1.96663 3.84169C2.16663 3.33335 2.48329 2.86669 2.92496 2.45002C3.45829 1.92502 4.04163 1.66669 4.65829 1.66669C4.89163 1.66669 5.12496 1.71669 5.33329 1.81669C5.54996 1.91669 5.74163 2.06669 5.89163 2.28335L7.82496 5.00835C7.97496 5.21669 8.08329 5.40835 8.15829 5.59169C8.23329 5.76669 8.27496 5.94169 8.27496 6.10002C8.27496 6.30002 8.21663 6.50002 8.09996 6.69169C7.99163 6.88335 7.83329 7.08335 7.63329 7.28335L6.99996 7.94169C6.90829 8.03335 6.86663 8.14169 6.86663 8.27502C6.86663 8.34169 6.87496 8.40002 6.89163 8.46669C6.91663 8.53335 6.94163 8.58335 6.95829 8.63335C7.10829 8.90835 7.36663 9.26669 7.73329 9.70002C8.10829 10.1334 8.50829 10.575 8.94163 11.0167C9.39163 11.4584 9.82496 11.8667 10.2666 12.2417C10.7 12.6084 11.0583 12.8584 11.3416 13.0084C11.3833 13.025 11.4333 13.05 11.4916 13.075C11.5583 13.1 11.625 13.1084 11.7 13.1084C11.8416 13.1084 11.95 13.0584 12.0416 12.9667L12.675 12.3417C12.8833 12.1334 13.0833 11.975 13.275 11.875C13.4666 11.7584 13.6583 11.7 13.8666 11.7C14.025 11.7 14.1916 11.7334 14.375 11.8084C14.5583 11.8834 14.75 11.9917 14.9583 12.1334L17.7166 14.0917C17.9333 14.2417 18.0833 14.4167 18.175 14.625C18.2583 14.8334 18.3083 15.0417 18.3083 15.275Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M15.4167 7.50004C15.4167 7.00004 15.025 6.23337 14.4417 5.60837C13.9083 5.03337 13.2 4.58337 12.5 4.58337"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 7.50002C18.3333 4.27502 15.725 1.66669 12.5 1.66669"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconEmployeeMail = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1667 17.0834H5.83341C3.33341 17.0834 1.66675 15.8334 1.66675 12.9167V7.08335C1.66675 4.16669 3.33341 2.91669 5.83341 2.91669H14.1667C16.6667 2.91669 18.3334 4.16669 18.3334 7.08335V12.9167C18.3334 15.8334 16.6667 17.0834 14.1667 17.0834Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1666 7.5L11.5582 9.58333C10.6999 10.2667 9.29158 10.2667 8.43325 9.58333L5.83325 7.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconEmployeeDate = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66675 1.04169C7.01193 1.04169 7.29175 1.32151 7.29175 1.66669V4.16669C7.29175 4.51186 7.01193 4.79169 6.66675 4.79169C6.32157 4.79169 6.04175 4.51186 6.04175 4.16669V1.66669C6.04175 1.32151 6.32157 1.04169 6.66675 1.04169Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3333 1.04169C13.6784 1.04169 13.9583 1.32151 13.9583 1.66669V4.16669C13.9583 4.51186 13.6784 4.79169 13.3333 4.79169C12.9881 4.79169 12.7083 4.51186 12.7083 4.16669V1.66669C12.7083 1.32151 12.9881 1.04169 13.3333 1.04169Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.29175 7.57501C2.29175 7.22983 2.57157 6.95001 2.91675 6.95001H17.0834C17.4286 6.95001 17.7084 7.22983 17.7084 7.57501C17.7084 7.92019 17.4286 8.20001 17.0834 8.20001H2.91675C2.57157 8.20001 2.29175 7.92019 2.29175 7.57501Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.94758 4.4878C3.41364 5.06282 3.125 5.92916 3.125 7.08335V14.1667C3.125 15.3209 3.41364 16.1872 3.94758 16.7622C4.47373 17.3289 5.32746 17.7084 6.66667 17.7084H13.3333C14.6725 17.7084 15.5263 17.3289 16.0524 16.7622C16.5864 16.1872 16.875 15.3209 16.875 14.1667V7.08335C16.875 5.92916 16.5864 5.06282 16.0524 4.4878C15.5263 3.92117 14.6725 3.54169 13.3333 3.54169H6.66667C5.32746 3.54169 4.47373 3.92117 3.94758 4.4878ZM3.03159 3.63724C3.8596 2.74553 5.08921 2.29169 6.66667 2.29169H13.3333C14.9108 2.29169 16.1404 2.74553 16.9684 3.63724C17.7886 4.52056 18.125 5.73755 18.125 7.08335V14.1667C18.125 15.5125 17.7886 16.7295 16.9684 17.6128C16.1404 18.5045 14.9108 18.9584 13.3333 18.9584H6.66667C5.08921 18.9584 3.8596 18.5045 3.03159 17.6128C2.21136 16.7295 1.875 15.5125 1.875 14.1667V7.08335C1.875 5.73755 2.21136 4.52056 3.03159 3.63724Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconChecked = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20Z"
        fill="#2EB67D"
      ></path>
      <path
        d="M5.75037 10.0001L8.58037 12.8301L14.2504 7.1701"
        fill="#2EB67D"
      ></path>
      <path
        d="M5.75037 10.0001L8.58037 12.8301L14.2504 7.1701"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};

export const IconCross = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0307 3.03033C14.3236 2.73744 14.3236 2.26256 14.0307 1.96967C13.7378 1.67678 13.263 1.67678 12.9701 1.96967L8.00014 6.93961L3.03021 1.96967C2.73731 1.67678 2.26244 1.67678 1.96955 1.96967C1.67665 2.26256 1.67665 2.73744 1.96955 3.03033L6.93948 8.00027L1.96955 12.9702C1.67665 13.2631 1.67665 13.738 1.96955 14.0309C2.26244 14.3238 2.73731 14.3238 3.03021 14.0309L8.00014 9.06093L12.9701 14.0309C13.263 14.3238 13.7378 14.3238 14.0307 14.0309C14.3236 13.738 14.3236 13.2631 14.0307 12.9702L9.0608 8.00027L14.0307 3.03033Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconRestrict = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12V18.6667"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0001 28.547H7.92007C3.29341 28.547 1.36007 25.2404 3.60007 21.2004L7.76007 13.707L11.6801 6.66703C14.0534 2.38703 17.9467 2.38703 20.3201 6.66703L24.2401 13.7204L28.4001 21.2137C30.6401 25.2537 28.6934 28.5604 24.0801 28.5604H16.0001V28.547Z"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9927 22.666H16.0047"
        stroke="#E01E1E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconModule = () => {
  return (
    <svg
      width="2.58rem"
      height="2.25rem"
      viewBox="0 0 2.25rem 2.25rem"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H32C33.933 0.5 35.5 2.067 35.5 4V32C35.5 33.933 33.933 35.5 32 35.5H4C2.067 35.5 0.5 33.933 0.5 32V4Z"
        fill="white"
        stroke="#D9D9D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.72 11.833C20.2598 11.833 19.8867 12.2061 19.8867 12.6663C19.8867 13.1266 20.2598 13.4997 20.72 13.4997C21.1803 13.4997 21.5534 13.1266 21.5534 12.6663C21.5534 12.2061 21.1803 11.833 20.72 11.833ZM18.8867 12.6663C18.8867 11.6538 19.7075 10.833 20.72 10.833C21.7326 10.833 22.5534 11.6538 22.5534 12.6663C22.5534 13.6789 21.7326 14.4997 20.72 14.4997C19.7075 14.4997 18.8867 13.6789 18.8867 12.6663Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.72 22.5C20.2598 22.5 19.8867 22.8731 19.8867 23.3333C19.8867 23.7936 20.2598 24.1667 20.72 24.1667C21.1803 24.1667 21.5534 23.7936 21.5534 23.3333C21.5534 22.8731 21.1803 22.5 20.72 22.5ZM18.8867 23.3333C18.8867 22.3208 19.7075 21.5 20.72 21.5C21.7326 21.5 22.5534 22.3208 22.5534 23.3333C22.5534 24.3459 21.7326 25.1667 20.72 25.1667C19.7075 25.1667 18.8867 24.3459 18.8867 23.3333Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6667 11.833C14.2065 11.833 13.8334 12.2061 13.8334 12.6663C13.8334 13.1266 14.2065 13.4997 14.6667 13.4997C15.1269 13.4997 15.5 13.1266 15.5 12.6663C15.5 12.2061 15.1269 11.833 14.6667 11.833ZM12.8334 12.6663C12.8334 11.6538 13.6542 10.833 14.6667 10.833C15.6792 10.833 16.5 11.6538 16.5 12.6663C16.5 13.6789 15.6792 14.4997 14.6667 14.4997C13.6542 14.4997 12.8334 13.6789 12.8334 12.6663Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6667 22.5C14.2065 22.5 13.8334 22.8731 13.8334 23.3333C13.8334 23.7936 14.2065 24.1667 14.6667 24.1667C15.1269 24.1667 15.5 23.7936 15.5 23.3333C15.5 22.8731 15.1269 22.5 14.6667 22.5ZM12.8334 23.3333C12.8334 22.3208 13.6542 21.5 14.6667 21.5C15.6792 21.5 16.5 22.3208 16.5 23.3333C16.5 24.3459 15.6792 25.1667 14.6667 25.1667C13.6542 25.1667 12.8334 24.3459 12.8334 23.3333Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.72 17.166C20.2598 17.166 19.8867 17.5391 19.8867 17.9993C19.8867 18.4596 20.2598 18.8327 20.72 18.8327C21.1803 18.8327 21.5534 18.4596 21.5534 17.9993C21.5534 17.5391 21.1803 17.166 20.72 17.166ZM18.8867 17.9993C18.8867 16.9868 19.7075 16.166 20.72 16.166C21.7326 16.166 22.5534 16.9868 22.5534 17.9993C22.5534 19.0119 21.7326 19.8327 20.72 19.8327C19.7075 19.8327 18.8867 19.0119 18.8867 17.9993Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6667 17.166C14.2065 17.166 13.8334 17.5391 13.8334 17.9993C13.8334 18.4596 14.2065 18.8327 14.6667 18.8327C15.1269 18.8327 15.5 18.4596 15.5 17.9993C15.5 17.5391 15.1269 17.166 14.6667 17.166ZM12.8334 17.9993C12.8334 16.9868 13.6542 16.166 14.6667 16.166C15.6792 16.166 16.5 16.9868 16.5 17.9993C16.5 19.0119 15.6792 19.8327 14.6667 19.8327C13.6542 19.8327 12.8334 19.0119 12.8334 17.9993Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconModule2 = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7466 6.41333H8.24658C7.97325 6.41333 7.74658 6.18666 7.74658 5.91333C7.74658 5.64 7.97325 5.41333 8.24658 5.41333H11.7466C12.0199 5.41333 12.2466 5.64 12.2466 5.91333C12.2466 6.18666 12.0266 6.41333 11.7466 6.41333Z"
        fill="#646464"
      />
      <path
        d="M4.74658 6.92003C4.61992 6.92003 4.49325 6.87336 4.39325 6.77336L3.89325 6.27336C3.69992 6.08003 3.69992 5.76003 3.89325 5.56669C4.08658 5.37336 4.40658 5.37336 4.59992 5.56669L4.74658 5.71336L5.89325 4.56669C6.08658 4.37336 6.40658 4.37336 6.59992 4.56669C6.79325 4.76003 6.79325 5.08003 6.59992 5.27336L5.09992 6.77336C5.00658 6.86669 4.87992 6.92003 4.74658 6.92003Z"
        fill="#646464"
      />
      <path
        d="M11.7466 11.08H8.24658C7.97325 11.08 7.74658 10.8534 7.74658 10.58C7.74658 10.3067 7.97325 10.08 8.24658 10.08H11.7466C12.0199 10.08 12.2466 10.3067 12.2466 10.58C12.2466 10.8534 12.0266 11.08 11.7466 11.08Z"
        fill="#646464"
      />
      <path
        d="M4.74658 11.5866C4.61992 11.5866 4.49325 11.54 4.39325 11.44L3.89325 10.94C3.69992 10.7467 3.69992 10.4267 3.89325 10.2333C4.08658 10.04 4.40658 10.04 4.59992 10.2333L4.74658 10.38L5.89325 9.23332C6.08658 9.03998 6.40658 9.03998 6.59992 9.23332C6.79325 9.42665 6.79325 9.74665 6.59992 9.93998L5.09992 11.44C5.00658 11.5333 4.87992 11.5866 4.74658 11.5866Z"
        fill="#646464"
      />
      <path
        d="M9.99992 15.1666H5.99992C2.37991 15.1666 0.833248 13.62 0.833248 9.99998V5.99998C0.833248 2.37998 2.37991 0.833313 5.99992 0.833313H9.99992C13.6199 0.833313 15.1666 2.37998 15.1666 5.99998V9.99998C15.1666 13.62 13.6199 15.1666 9.99992 15.1666ZM5.99992 1.83331C2.92658 1.83331 1.83325 2.92665 1.83325 5.99998V9.99998C1.83325 13.0733 2.92658 14.1666 5.99992 14.1666H9.99992C13.0732 14.1666 14.1666 13.0733 14.1666 9.99998V5.99998C14.1666 2.92665 13.0732 1.83331 9.99992 1.83331H5.99992Z"
        fill="#646464"
      />
    </svg>
  );
};

export const IconCreatePage = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2697_9589)">
        <path
          d="M7.96667 14.9997V10.833"
          stroke="#4A154B"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 12.917H5.83337"
          stroke="#4A154B"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66663 1.66699V4.16699"
          stroke="#4A154B"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3334 1.66699V4.16699"
          stroke="#4A154B"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.175 2.84961C15.9583 2.94961 17.3667 3.97461 17.45 7.89128L17.5583 13.0329C17.625 16.4663 16.8333 18.1913 12.6667 18.2829L7.66665 18.3829C3.49998 18.4663 2.63332 16.7663 2.56665 13.3413L2.44998 8.19128C2.36665 4.27461 3.74165 3.19128 6.50832 2.98294L13.175 2.84961Z"
          stroke="#4A154B"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2697_9589">
          <rect width="1.25rem" height="1.25rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconCreateForm = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6834 7.5166H10.3083C10.2782 7.5166 10.2469 7.50432 10.2213 7.47867C10.1956 7.45303 10.1833 7.42175 10.1833 7.3916C10.1833 7.36145 10.1956 7.33017 10.2213 7.30453C10.2469 7.27889 10.2782 7.2666 10.3083 7.2666H14.6834C14.7135 7.2666 14.7448 7.27889 14.7704 7.30453C14.7961 7.33017 14.8084 7.36145 14.8084 7.3916C14.8084 7.46148 14.7529 7.5166 14.6834 7.5166Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
      <path
        d="M5.57979 7.49548L5.93334 7.84903L6.28689 7.49548L7.72023 6.06215C7.74176 6.04062 7.77249 6.02734 7.80834 6.02734C7.84419 6.02734 7.87493 6.04062 7.89645 6.06215C7.91798 6.08367 7.93126 6.11441 7.93126 6.15026C7.93126 6.18611 7.91798 6.21685 7.89645 6.23837L6.02145 8.11337C5.99749 8.13734 5.96589 8.15026 5.93334 8.15026C5.91566 8.15026 5.90014 8.14704 5.88681 8.14168C5.87396 8.1365 5.85991 8.12806 5.84523 8.11337L5.22023 7.48837C5.1987 7.46685 5.18542 7.43611 5.18542 7.40026C5.18542 7.36441 5.1987 7.33367 5.22023 7.31215C5.24176 7.29062 5.27249 7.27734 5.30834 7.27734C5.34419 7.27734 5.37493 7.29062 5.39645 7.31215L5.75001 6.95859L5.39646 7.31215L5.57979 7.49548Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
      <path
        d="M14.6834 13.3496H10.3083C10.2782 13.3496 10.2469 13.3373 10.2213 13.3117C10.1956 13.286 10.1833 13.2548 10.1833 13.2246C10.1833 13.1945 10.1956 13.1632 10.2213 13.1375C10.2469 13.1119 10.2782 13.0996 10.3083 13.0996H14.6834C14.7135 13.0996 14.7448 13.1119 14.7704 13.1375C14.7961 13.1632 14.8084 13.1945 14.8084 13.2246C14.8084 13.2945 14.7529 13.3496 14.6834 13.3496Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
      <path
        d="M5.57979 13.3285L5.93334 13.682L6.28689 13.3285L7.72023 11.8952C7.74176 11.8736 7.77249 11.8604 7.80834 11.8604C7.84419 11.8604 7.87493 11.8736 7.89645 11.8952C7.91798 11.9167 7.93126 11.9474 7.93126 11.9833C7.93126 12.0191 7.91798 12.0499 7.89645 12.0714L6.02145 13.9464C5.99749 13.9703 5.9659 13.9833 5.93334 13.9833C5.91566 13.9833 5.90014 13.98 5.88681 13.9747C5.87396 13.9695 5.85991 13.9611 5.84523 13.9464L5.22023 13.3214C5.1987 13.2999 5.18542 13.2691 5.18542 13.2333C5.18542 13.1974 5.1987 13.1667 5.22023 13.1452C5.24176 13.1236 5.27249 13.1104 5.30834 13.1104C5.34419 13.1104 5.37493 13.1236 5.39645 13.1452L5.75001 12.7916L5.39646 13.1452L5.57979 13.3285Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
      <path
        d="M12.5 18.9587H7.49996C2.97496 18.9587 1.04163 17.0253 1.04163 12.5003V7.50033C1.04163 2.97533 2.97496 1.04199 7.49996 1.04199H12.5C17.025 1.04199 18.9583 2.97533 18.9583 7.50033V12.5003C18.9583 17.0253 17.025 18.9587 12.5 18.9587ZM7.49996 2.29199C3.65829 2.29199 2.29163 3.65866 2.29163 7.50033V12.5003C2.29163 16.342 3.65829 17.7087 7.49996 17.7087H12.5C16.3416 17.7087 17.7083 16.342 17.7083 12.5003V7.50033C17.7083 3.65866 16.3416 2.29199 12.5 2.29199H7.49996Z"
        fill="#4A154B"
      />
    </svg>
  );
};
export const IconPipe = () => {
  return (
    <svg
      width="1"
      height="1.25rem"
      viewBox="0 0 1 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.5"
        y1="2.18557e-08"
        x2="0.499999"
        y2="1.25rem"
        stroke="#D9D9D9"
      />
    </svg>
  );
};
export const IconPageContent = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1.5rem" height="1.5rem" rx="12" fill="#62BB8D" />
      <path
        d="M14.5333 5.47268C14.26 5.19934 13.7866 5.38601 13.7866 5.76601V8.09268C13.7866 9.06601 14.6133 9.87268 15.62 9.87268C16.2533 9.87934 17.1333 9.87934 17.8866 9.87934C18.2666 9.87934 18.4666 9.43268 18.2 9.16601C17.24 8.19934 15.52 6.45934 14.5333 5.47268Z"
        fill="white"
      />
      <path
        d="M17.6665 10.793H15.7398C14.1598 10.793 12.8732 9.50634 12.8732 7.92634V5.99967C12.8732 5.63301 12.5732 5.33301 12.2065 5.33301H9.37984C7.3265 5.33301 5.6665 6.66634 5.6665 9.04634V14.953C5.6665 17.333 7.3265 18.6663 9.37984 18.6663H14.6198C16.6732 18.6663 18.3332 17.333 18.3332 14.953V11.4597C18.3332 11.093 18.0332 10.793 17.6665 10.793ZM11.6665 15.833H8.99984C8.7265 15.833 8.49984 15.6063 8.49984 15.333C8.49984 15.0597 8.7265 14.833 8.99984 14.833H11.6665C11.9398 14.833 12.1665 15.0597 12.1665 15.333C12.1665 15.6063 11.9398 15.833 11.6665 15.833ZM12.9998 13.1663H8.99984C8.7265 13.1663 8.49984 12.9397 8.49984 12.6663C8.49984 12.393 8.7265 12.1663 8.99984 12.1663H12.9998C13.2732 12.1663 13.4998 12.393 13.4998 12.6663C13.4998 12.9397 13.2732 13.1663 12.9998 13.1663Z"
        fill="white"
      />
    </svg>
  );
};
export const IconPlus = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.88843 10H16.1107"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 16.1109V3.88867"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconUploadFile = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.5rem" cy="1.5rem" r="1.5rem" fill="white" />
      <path
        d="M30.1473 34.6666C31.934 34.6799 33.654 34.0133 34.974 32.8133C39.334 28.9999 37.0006 21.3466 31.254 20.6266C29.2006 8.17326 11.2406 12.8933 15.494 24.7466"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.7065 25.2928C16.9998 24.9328 16.2132 24.7461 15.4265 24.7595C9.21315 25.1995 9.22649 34.2395 15.4265 34.6795"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.0928 21.1863C29.7861 20.8396 30.5328 20.653 31.3061 20.6396"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.604 28.8403L23.9996 23.4448L29.3951 28.8403"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.9995 38.5562V23.5962"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconStar = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
    </svg>
  );
};

export const IconemptyStar = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const IconhalfStar = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13 18.3404L19.0534 21.7082L17.5009 13.7874L23.4127 8.29183L15.3997 7.32068L13 2.15332V18.3404Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const IconStarOne = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3997 7.32065L12 0L8.60025 7.32065L3 7.99938V10.5346L6.49909 13.7874L4.94658 21.7082L12 17.784L19.0534 21.7082L17.5009 13.7874L23.4127 8.2918L15.3997 7.32065Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarTwo = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3995 7.32065L11.9997 0L8.59996 7.32065L5.05313 7.75051V12.4435L6.4988 13.7874L4.94629 21.7082L11.9997 17.784L19.0531 21.7082L17.5006 13.7874L23.4124 8.2918L15.3995 7.32065Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarThree = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3997 7.32065L12 0L8.60025 7.32065L6 7.63579V13.3234L6.49909 13.7874L6 16.3337V21.1221L12 17.784L19.0534 21.7082L17.5009 13.7874L23.4127 8.2918L15.3997 7.32065Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarFour = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3997 7.32065L12 0L9 6.45987V19.4531L12 17.784L19.0534 21.7082L17.5009 13.7874L23.4127 8.2918L15.3997 7.32065Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const IconStarSix = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13 18.3404L19.0534 21.7082L17.5009 13.7874L23.4127 8.29183L15.3997 7.32068L13 2.15332V18.3404Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarSeven = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2507 0.540131L11.9999 0L11.749 0.540131H12.2507ZM14.9999 6.45987V19.4531L19.0533 21.7082L17.5008 13.7874L23.4125 8.2918L15.3996 7.32065L14.9999 6.45987Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarEight = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 20.5658L19.0534 21.7083L17.5009 13.7874L23.4127 8.29185L17 7.51465V20.5658Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarNine = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 10.5352L23.4127 8.29241L21 8V10.5352Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const IconStarGray = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export const IconStarLg = () => {
  return (
    <svg
      width="1.5rem"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
        fill="#ECB22E"
      />
    </svg>
  );
};

export const IconEye = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99995 6.11328C6.95609 6.11328 6.11328 6.95609 6.11328 7.99995C6.11328 9.04381 6.95609 9.88661 7.99995 9.88661C9.04381 9.88661 9.88661 9.04381 9.88661 7.99995C9.88661 6.95609 9.04381 6.11328 7.99995 6.11328ZM5.11328 7.99995C5.11328 6.40381 6.40381 5.11328 7.99995 5.11328C9.59609 5.11328 10.8866 6.40381 10.8866 7.99995C10.8866 9.59609 9.59609 10.8866 7.99995 10.8866C6.40381 10.8866 5.11328 9.59609 5.11328 7.99995Z"
        fill="#888888"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.50489 5.99747C3.09884 3.49189 5.43458 1.97949 7.9999 1.97949C10.5653 1.97949 12.9012 3.49202 14.4951 5.9978C14.8584 6.56736 15.0232 7.29693 15.0232 7.99616C15.0232 8.69552 14.8584 9.42524 14.4949 9.99485C12.901 12.5004 10.5652 14.0128 7.9999 14.0128C5.43446 14.0128 3.09863 12.5003 1.50468 9.99452L1.92656 9.72616L1.5051 9.99518C1.14149 9.42552 0.976562 8.69566 0.976562 7.99616C0.976562 7.2968 1.14143 6.56708 1.50489 5.99747ZM7.9999 2.97949C5.85866 2.97949 3.80783 4.24029 2.34844 6.53452L2.34802 6.53518C2.11163 6.90552 1.97656 7.43566 1.97656 7.99616C1.97656 8.55666 2.11163 9.0868 2.34802 9.45714L2.34844 9.4578C3.80783 11.752 5.85866 13.0128 7.9999 13.0128C10.1411 13.0128 12.192 11.752 13.6514 9.4578L13.6518 9.45714C13.8882 9.0868 14.0232 8.55666 14.0232 7.99616C14.0232 7.43566 13.8882 6.90552 13.6518 6.53518L13.6514 6.53452C12.192 4.24029 10.1411 2.97949 7.9999 2.97949Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconEyeColored = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99993 7.64166C8.69511 7.64166 7.6416 8.69517 7.6416 10C7.6416 11.3048 8.69511 12.3583 9.99993 12.3583C11.3048 12.3583 12.3583 11.3048 12.3583 10C12.3583 8.69517 11.3048 7.64166 9.99993 7.64166ZM6.3916 10C6.3916 8.00482 8.00476 6.39166 9.99993 6.39166C11.9951 6.39166 13.6083 8.00482 13.6083 10C13.6083 11.9952 11.9951 13.6083 9.99993 13.6083C8.00476 13.6083 6.3916 11.9952 6.3916 10Z"
        fill="#4A154B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.88112 7.49739C3.87355 4.36541 6.79322 2.47491 9.99987 2.47491C13.2067 2.47491 16.1264 4.36558 18.1189 7.4978C18.573 8.20974 18.779 9.12171 18.779 9.99575C18.779 10.87 18.573 11.7821 18.1186 12.4941C16.1262 15.6261 13.2065 17.5166 9.99987 17.5166C6.79308 17.5166 3.87329 15.6259 1.88085 12.4937L2.4082 12.1582L1.88138 12.4945C1.42686 11.7825 1.2207 10.8701 1.2207 9.99575C1.2207 9.12154 1.42679 8.20939 1.88112 7.49739ZM9.99987 3.72491C7.32333 3.72491 4.75978 5.30092 2.93555 8.1687L2.93503 8.16952C2.63954 8.63245 2.4707 9.29512 2.4707 9.99575C2.4707 10.6964 2.63954 11.359 2.93503 11.822L2.93555 11.8228C4.75978 14.6906 7.32333 16.2666 9.99987 16.2666C12.6764 16.2666 15.24 14.6906 17.0642 11.8228L17.0647 11.822C17.3602 11.359 17.529 10.6964 17.529 9.99575C17.529 9.29512 17.3602 8.63245 17.0647 8.16952L17.0642 8.1687C15.24 5.30092 12.6764 3.72491 9.99987 3.72491Z"
        fill="#4A154B"
      />
    </svg>
  );
};

export const IconEyeDefault = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      height="1rem"
      fill="currentColor"
      class="bi bi-eye"
      viewBox="0 0 16 16"
    >
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
    </svg>
  );
};
export const IconEyeSlash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      height="1rem"
      fill="currentColor"
      class="bi bi-eye-slash"
      viewBox="0 0 16 16"
    >
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />{" "}
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
    </svg>
  );
};

export const IconTick = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16Z"
        fill="#2EB67D"
      />
      <path d="M4.6001 8.00033L6.8641 10.2643L11.4001 5.73633" fill="#2EB67D" />
      <path
        d="M4.6001 8.00033L6.8641 10.2643L11.4001 5.73633"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconExclamation = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6V9.33333"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99979 14.2734H3.95979C1.64646 14.2734 0.679793 12.6201 1.79979 10.6001L3.87979 6.85339L5.83979 3.33339C7.02646 1.19339 8.97313 1.19339 10.1598 3.33339L12.1198 6.86006L14.1998 10.6067C15.3198 12.6267 14.3465 14.2801 12.0398 14.2801H7.99979V14.2734Z"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99609 11.3334H8.00208"
        stroke="#E01E1E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconExclamationLg = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9V14"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9999 21.41H5.93993C2.46993 21.41 1.01993 18.93 2.69993 15.9L5.81993 10.28L8.75993 5C10.5399 1.79 13.4599 1.79 15.2399 5L18.1799 10.29L21.2999 15.91C22.9799 18.94 21.5199 21.42 18.0599 21.42H11.9999V21.41Z"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9946 17H12.0036"
        stroke="#E01E1E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconMicrosoft = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1941_14282)">
        <path
          d="M8.5 7.5H16V0.5C16 0.224 15.776 0 15.5 0H8.5V7.5Z"
          fill="#4CAF50"
        />
        <path
          d="M7.5 7.5V0H0.5C0.224 0 0 0.224 0 0.5V7.5H7.5Z"
          fill="#F44336"
        />
        <path
          d="M7.5 8.5H0V15.5C0 15.776 0.224 16 0.5 16H7.5V8.5Z"
          fill="#2196F3"
        />
        <path
          d="M8.5 8.5V16H15.5C15.776 16 16 15.776 16 15.5V8.5H8.5Z"
          fill="#FFC107"
        />
      </g>
      <defs>
        <clipPath id="clip0_1941_14282">
          <rect width="1rem" height="1rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconCrossSm = () => {
  return (
    <svg
      width="0.625rem"
      height="0.625rem"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.96816 2.09283C9.26106 1.79994 9.26106 1.32506 8.96816 1.03217C8.67527 0.739277 8.2004 0.739277 7.9075 1.03217L5.00017 3.93951L2.09283 1.03217C1.79994 0.739277 1.32506 0.739277 1.03217 1.03217C0.739277 1.32506 0.739277 1.79994 1.03217 2.09283L3.93951 5.00017L1.03217 7.9075C0.739277 8.2004 0.739277 8.67527 1.03217 8.96816C1.32506 9.26105 1.79994 9.26105 2.09283 8.96816L5.00017 6.06083L7.9075 8.96816C8.2004 9.26105 8.67527 9.26105 8.96816 8.96816C9.26106 8.67527 9.26106 8.2004 8.96816 7.9075L6.06083 5.00017L8.96816 2.09283Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconDuplicate = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 10.7498V14.2498C13.3333 17.1665 12.1666 18.3332 9.24996 18.3332H5.74996C2.83329 18.3332 1.66663 17.1665 1.66663 14.2498V10.7498C1.66663 7.83317 2.83329 6.6665 5.74996 6.6665H9.24996C12.1666 6.6665 13.3333 7.83317 13.3333 10.7498Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 5.74984V9.24984C18.3333 12.1665 17.1666 13.3332 14.25 13.3332H13.3333V10.7498C13.3333 7.83317 12.1666 6.6665 9.24996 6.6665H6.66663V5.74984C6.66663 2.83317 7.83329 1.6665 10.75 1.6665H14.25C17.1666 1.6665 18.3333 2.83317 18.3333 5.74984Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconPPT = () => {
  return (
    <svg
      width="2rem"
      height="2rem"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="2rem" height="2rem" rx="1rem" fill="#2EB67D" />
      <path
        d="M19.1664 7.84158C18.8248 7.49991 18.2331 7.73325 18.2331 8.20825V11.1166C18.2331 12.3332 19.2664 13.3416 20.5248 13.3416C21.3164 13.3499 22.4164 13.3499 23.3581 13.3499C23.8331 13.3499 24.0831 12.7916 23.7498 12.4582C22.5498 11.2499 20.3998 9.07491 19.1664 7.84158Z"
        fill="white"
      />
      <path
        d="M23.0833 14.4917H20.675C18.7 14.4917 17.0916 12.8834 17.0916 10.9084V8.50008C17.0916 8.04175 16.7166 7.66675 16.2583 7.66675H12.725C10.1583 7.66675 8.08331 9.33341 8.08331 12.3084V19.6917C8.08331 22.6667 10.1583 24.3334 12.725 24.3334H19.275C21.8416 24.3334 23.9166 22.6667 23.9166 19.6917V15.3251C23.9166 14.8667 23.5416 14.4917 23.0833 14.4917ZM15.5833 20.7917H12.25C11.9083 20.7917 11.625 20.5084 11.625 20.1667C11.625 19.8251 11.9083 19.5417 12.25 19.5417H15.5833C15.925 19.5417 16.2083 19.8251 16.2083 20.1667C16.2083 20.5084 15.925 20.7917 15.5833 20.7917ZM17.25 17.4584H12.25C11.9083 17.4584 11.625 17.1751 11.625 16.8334C11.625 16.4917 11.9083 16.2084 12.25 16.2084H17.25C17.5916 16.2084 17.875 16.4917 17.875 16.8334C17.875 17.1751 17.5916 17.4584 17.25 17.4584Z"
        fill="white"
      />
    </svg>
  );
};

export const IconDownload = ({ className = "" }) => {
  return (
    <svg
      className={`${className ? className : ""}`}
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1743 20.0001H6.82571C2.04479 20.0001 0 18.0001 0 13.3239V13.2001C0 8.97155 1.70399 6.93345 5.52093 6.58107C5.91042 6.5525 6.28043 6.83821 6.31938 7.22869C6.35832 7.61917 6.06621 7.97155 5.65725 8.00964C2.5998 8.28583 1.46056 9.69536 1.46056 13.2096V13.3335C1.46056 17.2096 2.86271 18.5811 6.82571 18.5811H13.1743C17.1373 18.5811 18.5394 17.2096 18.5394 13.3335V13.2096C18.5394 9.67631 17.3807 8.26678 14.2648 8.00964C13.8656 7.97155 13.5638 7.62869 13.6027 7.23821C13.6417 6.84774 13.9825 6.5525 14.3914 6.59059C18.2668 6.9144 20 8.96202 20 13.2192V13.343C20 18.0001 17.9552 20.0001 13.1743 20.0001Z"
        fill="#888888"
      />
      <path
        d="M10 13.6952C9.60078 13.6952 9.26971 13.3714 9.26971 12.981V0.714286C9.26971 0.32381 9.60078 0 10 0C10.3992 0 10.7303 0.32381 10.7303 0.714286V12.981C10.7303 13.381 10.3992 13.6952 10 13.6952Z"
        fill="#888888"
      />
      <path
        d="M10 14.7619C9.81503 14.7619 9.63002 14.6953 9.48396 14.5524L6.22204 11.3619C5.93966 11.0857 5.93966 10.6286 6.22204 10.3524C6.50441 10.0762 6.97179 10.0762 7.25417 10.3524L10 13.0381L12.7459 10.3524C13.0283 10.0762 13.4956 10.0762 13.778 10.3524C14.0604 10.6286 14.0604 11.0857 13.778 11.3619L10.5161 14.5524C10.37 14.6953 10.185 14.7619 10 14.7619Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IssueType = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 7.5H13.5C11.25 7.5 10.5 6.75 10.5 4.5V1.5L16.5 7.5Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 9.75H9.75"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 12.75H8.25"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const RequestSent = () => {
  return (
    <svg
      width="1.125rem"
      height="1.063rem"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7691 14.1923H4.84606C2.76914 14.1923 1.38452 13.1539 1.38452 10.7308V5.88463C1.38452 3.46156 2.76914 2.4231 4.84606 2.4231H11.7691C13.8461 2.4231 15.2307 3.46156 15.2307 5.88463V10.7308C15.2307 13.1539 13.8461 14.1923 11.7691 14.1923Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7693 6.23077L9.60234 7.96154C8.88927 8.52924 7.71927 8.52924 7.00619 7.96154L4.84619 6.23077"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8463 15.923C15.7502 15.923 17.3078 14.3653 17.3078 12.4615C17.3078 10.5576 15.7502 8.99994 13.8463 8.99994C11.9425 8.99994 10.3848 10.5576 10.3848 12.4615C10.3848 14.3653 11.9425 15.923 13.8463 15.923Z"
        fill="#F8F8F8"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.375 12.4614L13.3546 13.441L15.3173 11.4818"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDownloadBlue = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3451 7.08846L14.3498 7.08886C16.21 7.24429 17.4651 7.80483 18.2673 8.75286C19.0767 9.70944 19.5 11.1478 19.5 13.2192V13.343C19.5 15.611 19.0006 17.1136 18.0308 18.0601C17.0581 19.0094 15.5096 19.5001 13.1743 19.5001H6.82571C4.49034 19.5001 2.94217 19.0094 1.96963 18.0581C0.999638 17.1094 0.5 15.602 0.5 13.3239V13.2001C0.5 11.1424 0.916227 9.7121 1.71299 8.75739C2.50137 7.81274 3.73389 7.24914 5.56102 7.0795C5.70209 7.07108 5.81217 7.18127 5.82185 7.27832C5.83226 7.38272 5.75381 7.49822 5.6114 7.51175C4.02213 7.65544 2.81265 8.10355 2.02332 9.08128C1.24672 10.0432 0.960565 11.4181 0.960565 13.2096V13.3335C0.960565 15.3083 1.31273 16.7954 2.30739 17.7683C3.29897 18.7381 4.81162 19.0811 6.82571 19.0811H13.1743C15.1884 19.0811 16.701 18.7381 17.6926 17.7683C18.6873 16.7954 19.0394 15.3083 19.0394 13.3335V13.2096C19.0394 11.4081 18.7483 10.0264 17.9568 9.06356C17.1539 8.08685 15.925 7.64551 14.31 7.51167C14.1642 7.49656 14.0912 7.37893 14.1003 7.28784C14.1125 7.16494 14.2157 7.07639 14.3451 7.08846Z"
        fill="#232323"
        stroke="#0080FF"
      />
      <path
        d="M10 13.1952C9.86644 13.1952 9.76974 13.0849 9.76974 12.981V0.714286C9.76974 0.610334 9.86644 0.5 10 0.5C10.1336 0.5 10.2303 0.610334 10.2303 0.714286V12.981C10.2303 13.0901 10.138 13.1952 10 13.1952Z"
        fill="#232323"
        stroke="#0080FF"
      />
      <path
        d="M10 14.7622C9.815 14.7622 9.63 14.6955 9.48394 14.5527L6.22201 11.3622C5.93964 11.086 5.93964 10.6288 6.22201 10.3527C6.50439 10.0765 6.97177 10.0765 7.25415 10.3527L10 13.0384L12.7459 10.3527C13.0282 10.0765 13.4956 10.0765 13.778 10.3527C14.0604 10.6288 14.0604 11.086 13.778 11.3622L10.5161 14.5527C10.37 14.6955 10.185 14.7622 10 14.7622Z"
        fill="#0080FF"
      />
    </svg>
  );
};
export const IconReportIssue = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29169 18.4582C4.26154 18.4582 4.23026 18.4459 4.20462 18.4202C4.17897 18.3946 4.16669 18.3633 4.16669 18.3332V1.6665C4.16669 1.63636 4.17897 1.60508 4.20462 1.57943C4.23026 1.55379 4.26154 1.5415 4.29169 1.5415C4.32183 1.5415 4.35311 1.55379 4.37876 1.57943C4.4044 1.60508 4.41669 1.63636 4.41669 1.6665V18.3332C4.41669 18.3633 4.4044 18.3946 4.37876 18.4202C4.35312 18.4459 4.32183 18.4582 4.29169 18.4582Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
      <path
        d="M13.7036 9.58828L13.6921 9.57676L13.6798 9.56602C13.3836 9.30607 13.1863 8.89764 13.1663 8.42171C13.1471 7.93241 13.3407 7.44161 13.7036 7.07872L14.7036 6.07872C15.0385 5.74383 15.2779 5.42141 15.422 5.13047C15.494 4.98513 15.5481 4.83583 15.5731 4.68825C15.5973 4.54534 15.5998 4.36871 15.5272 4.19701C15.3945 3.88336 15.0735 3.7131 14.8002 3.6204C14.4945 3.51675 14.0996 3.4585 13.625 3.4585H4.29169C4.22216 3.4585 4.16669 3.40338 4.16669 3.3335C4.16669 3.30335 4.17897 3.27207 4.20462 3.24642C4.23026 3.22078 4.26154 3.2085 4.29169 3.2085H13.625C14.469 3.2085 14.9742 3.38359 15.2747 3.56928C15.569 3.75106 15.7008 3.96366 15.7635 4.10914C15.8214 4.25312 15.8791 4.49524 15.799 4.83257C15.7171 5.17745 15.4817 5.6614 14.8798 6.26328L13.8798 7.26328C13.5753 7.56781 13.4046 7.99209 13.4169 8.42278L13.417 8.42515C13.4293 8.79584 13.5781 9.14854 13.8551 9.40396L14.8798 10.4204C14.88 10.4206 14.8803 10.4209 14.8805 10.4211C15.4681 11.0088 15.6972 11.4853 15.7765 11.8276C15.8537 12.1612 15.7978 12.4062 15.7385 12.5577C15.6754 12.7002 15.5406 12.9132 15.2479 13.0957C14.9483 13.2825 14.4494 13.4585 13.625 13.4585H4.29169C4.26154 13.4585 4.23026 13.4462 4.20462 13.4206C4.17897 13.3949 4.16669 13.3636 4.16669 13.3335C4.16669 13.3033 4.17897 13.2721 4.20462 13.2464C4.23026 13.2208 4.26154 13.2085 4.29169 13.2085H13.625C14.1193 13.2085 14.516 13.1433 14.8185 13.0297C15.0994 12.9242 15.3869 12.7419 15.5059 12.4442C15.6216 12.155 15.5519 11.8306 15.4255 11.5545C15.2911 11.2611 15.0556 10.9359 14.7025 10.5872C14.7021 10.5868 14.7017 10.5864 14.7013 10.586L13.7036 9.58828Z"
        fill="#4A154B"
        stroke="#4A154B"
      />
    </svg>
  );
};

export const IconReportIssue2 = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.43325 15.1666C3.15992 15.1666 2.93325 14.94 2.93325 14.6666V1.33331C2.93325 1.05998 3.15992 0.833313 3.43325 0.833313C3.70658 0.833313 3.93325 1.05998 3.93325 1.33331V14.6666C3.93325 14.94 3.70658 15.1666 3.43325 15.1666Z"
        fill="#646464"
      />
      <path
        d="M10.8999 11.1667H3.43325C3.15992 11.1667 2.93325 10.94 2.93325 10.6667C2.93325 10.3934 3.15992 10.1667 3.43325 10.1667H10.8999C11.6266 10.1667 11.9666 9.97335 12.0333 9.80669C12.0999 9.64002 11.9999 9.26669 11.4799 8.75335L10.6799 7.95335C10.3533 7.66669 10.1533 7.23335 10.1333 6.75335C10.1133 6.24669 10.3133 5.74669 10.6799 5.38002L11.4799 4.58002C11.9733 4.08669 12.1266 3.68669 12.0533 3.51335C11.9799 3.34002 11.5999 3.16669 10.8999 3.16669H3.43325C3.15325 3.16669 2.93325 2.94002 2.93325 2.66669C2.93325 2.39335 3.15992 2.16669 3.43325 2.16669H10.8999C12.3599 2.16669 12.8266 2.77335 12.9799 3.13335C13.1266 3.49335 13.2266 4.25335 12.1866 5.29335L11.3866 6.09335C11.2199 6.26002 11.1266 6.49335 11.1333 6.72669C11.1399 6.92669 11.2199 7.10669 11.3599 7.23335L12.1866 8.05335C13.2066 9.07335 13.1066 9.83335 12.9599 10.2C12.8066 10.5534 12.3333 11.1667 10.8999 11.1667Z"
        fill="#646464"
      />
    </svg>
  );
};

export const IconTeams = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.87 8.1525C6.795 8.145 6.705 8.145 6.6225 8.1525C4.8375 8.0925 3.42 6.63 3.42 4.83C3.42 2.9925 4.905 1.5 6.75 1.5C8.5875 1.5 10.08 2.9925 10.08 4.83C10.0725 6.63 8.655 8.0925 6.87 8.1525Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3075 3C13.7625 3 14.9325 4.1775 14.9325 5.625C14.9325 7.0425 13.8075 8.1975 12.405 8.25C12.345 8.2425 12.2775 8.2425 12.21 8.25"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.12 10.92C1.305 12.135 1.305 14.115 3.12 15.3225C5.1825 16.7025 8.565 16.7025 10.6275 15.3225C12.4425 14.1075 12.4425 12.1275 10.6275 10.92C8.5725 9.5475 5.19 9.5475 3.12 10.92Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.755 15C14.295 14.8875 14.805 14.67 15.225 14.3475C16.395 13.47 16.395 12.0225 15.225 11.145C14.8125 10.83 14.31 10.62 13.7775 10.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconRole = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3237_33325)">
        <path
          d="M13.5 14.145H12.93C12.33 14.145 11.76 14.3775 11.34 14.7975L10.0575 16.065C9.47248 16.6425 8.52001 16.6425 7.93501 16.065L6.6525 14.7975C6.2325 14.3775 5.655 14.145 5.0625 14.145H4.5C3.255 14.145 2.25 13.1475 2.25 11.9175V3.7275C2.25 2.4975 3.255 1.5 4.5 1.5H13.5C14.745 1.5 15.75 2.4975 15.75 3.7275V11.91C15.75 13.14 14.745 14.145 13.5 14.145Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.05251 6.71248C9.02251 6.71248 8.97749 6.71248 8.93999 6.71248C8.15249 6.68248 7.52998 6.04498 7.52998 5.24998C7.52998 4.43998 8.18249 3.78748 8.99249 3.78748C9.80249 3.78748 10.455 4.44748 10.455 5.24998C10.4625 6.04498 9.84001 6.68998 9.05251 6.71248Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.9375 8.96997C5.94 9.63747 5.94 10.725 6.9375 11.3925C8.07 12.15 9.93 12.15 11.0625 11.3925C12.06 10.725 12.06 9.63747 11.0625 8.96997C9.93 8.21997 8.0775 8.21997 6.9375 8.96997Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3237_33325">
          <rect width="1.125rem" height="1.125rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconStatus = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3237_33337)">
        <path
          d="M6.9825 11.025L8.1075 12.15L11.1075 9.15002"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 4.5H10.5C12 4.5 12 3.75 12 3C12 1.5 11.25 1.5 10.5 1.5H7.5C6.75 1.5 6 1.5 6 3C6 4.5 6.75 4.5 7.5 4.5Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 3.01501C14.4975 3.15001 15.75 4.07251 15.75 7.50002V12C15.75 15 15 16.5 11.25 16.5H6.75C3 16.5 2.25 15 2.25 12V7.50002C2.25 4.08001 3.5025 3.15001 6 3.01501"
          stroke="#888888"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3237_33337">
          <rect width="1.125rem" height="1.125rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IconError = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7.16406V10.9141"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99958 16.4725H4.45458C1.85208 16.4725 0.764583 14.6125 2.02458 12.34L4.36458 8.125L6.56958 4.165C7.90458 1.7575 10.0946 1.7575 11.4296 4.165L13.6346 8.1325L15.9746 12.3475C17.2346 14.62 16.1396 16.48 13.5446 16.48H8.99958V16.4725Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99609 13.1641H9.00283"
        stroke="#888888"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconSort = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 5.25H15.75"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.5 9H13.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.5 12.75H10.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const IconRequest = () => {
  return (
    <svg
      width="1.125rem"
      height="1.063rem"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7692 14.1923H4.84615C2.76923 14.1923 1.38461 13.1539 1.38461 10.7308V5.88463C1.38461 3.46156 2.76923 2.4231 4.84615 2.4231H11.7692C13.8462 2.4231 15.2308 3.46156 15.2308 5.88463V10.7308C15.2308 13.1539 13.8462 14.1923 11.7692 14.1923Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7692 6.23071L9.60231 7.96148C8.88923 8.52917 7.71923 8.52917 7.00616 7.96148L4.84616 6.23071"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8462 15.9231C15.75 15.9231 17.3077 14.3654 17.3077 12.4615C17.3077 10.5577 15.75 9 13.8462 9C11.9423 9 10.3846 10.5577 10.3846 12.4615C10.3846 14.3654 11.9423 15.9231 13.8462 15.9231Z"
        fill="#F8F8F8"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.375 12.4613L13.3546 13.4409L15.3173 11.4817"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconSequence = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3237_33319)">
        <path
          d="M15 5.2125V12.7875C14.88 12.765 14.7525 12.75 14.625 12.75C13.59 12.75 12.75 13.59 12.75 14.625C12.75 14.7525 12.765 14.88 12.7875 15H5.2125C5.235 14.88 5.25 14.7525 5.25 14.625C5.25 13.59 4.41 12.75 3.375 12.75C3.2475 12.75 3.12 12.765 3 12.7875V5.2125C3.12 5.235 3.2475 5.25 3.375 5.25C4.41 5.25 5.25 4.41 5.25 3.375C5.25 3.2475 5.235 3.12 5.2125 3H12.7875C12.765 3.12 12.75 3.2475 12.75 3.375C12.75 4.41 13.59 5.25 14.625 5.25C14.7525 5.25 14.88 5.235 15 5.2125Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 3.375C5.25 4.41 4.41 5.25 3.375 5.25C3.2475 5.25 3.12 5.235 3 5.2125C2.145 5.04 1.5 4.2825 1.5 3.375C1.5 2.34 2.34 1.5 3.375 1.5C4.2825 1.5 5.04 2.145 5.2125 3C5.235 3.12 5.25 3.2475 5.25 3.375Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 3.375C16.5 4.2825 15.855 5.04 15 5.2125C14.88 5.235 14.7525 5.25 14.625 5.25C13.59 5.25 12.75 4.41 12.75 3.375C12.75 3.2475 12.765 3.12 12.7875 3C12.96 2.145 13.7175 1.5 14.625 1.5C15.66 1.5 16.5 2.34 16.5 3.375Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 14.625C5.25 14.7525 5.235 14.88 5.2125 15C5.04 15.855 4.2825 16.5 3.375 16.5C2.34 16.5 1.5 15.66 1.5 14.625C1.5 13.7175 2.145 12.96 3 12.7875C3.12 12.765 3.2475 12.75 3.375 12.75C4.41 12.75 5.25 13.59 5.25 14.625Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 14.625C16.5 15.66 15.66 16.5 14.625 16.5C13.7175 16.5 12.96 15.855 12.7875 15C12.765 14.88 12.75 14.7525 12.75 14.625C12.75 13.59 13.59 12.75 14.625 12.75C14.7525 12.75 14.88 12.765 15 12.7875C15.855 12.96 16.5 13.7175 16.5 14.625Z"
          stroke="#888888"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3237_33319">
          <rect width="1.125rem" height="1.125rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconSequence2 = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99992 15.1666H5.99992C2.37991 15.1666 0.833248 13.62 0.833248 9.99998V5.99998C0.833248 2.37998 2.37991 0.833313 5.99992 0.833313H7.33325C7.60658 0.833313 7.83325 1.05998 7.83325 1.33331C7.83325 1.60665 7.60658 1.83331 7.33325 1.83331H5.99992C2.92658 1.83331 1.83325 2.92665 1.83325 5.99998V9.99998C1.83325 13.0733 2.92658 14.1666 5.99992 14.1666H9.99992C13.0732 14.1666 14.1666 13.0733 14.1666 9.99998V8.66665C14.1666 8.39331 14.3932 8.16665 14.6666 8.16665C14.9399 8.16665 15.1666 8.39331 15.1666 8.66665V9.99998C15.1666 13.62 13.6199 15.1666 9.99992 15.1666Z"
        fill="#646464"
      />
      <path
        d="M5.66658 11.7933C5.25991 11.7933 4.88658 11.6466 4.61325 11.38C4.28658 11.0533 4.14658 10.58 4.21991 10.08L4.50658 8.07331C4.55991 7.68664 4.81325 7.18664 5.08658 6.91331L10.3399 1.65998C11.6666 0.333311 13.0132 0.333311 14.3399 1.65998C15.0666 2.38664 15.3932 3.12664 15.3266 3.86664C15.2666 4.46665 14.9466 5.05331 14.3399 5.65331L9.08658 10.9066C8.81325 11.18 8.31325 11.4333 7.92658 11.4866L5.91991 11.7733C5.83325 11.7933 5.74658 11.7933 5.66658 11.7933ZM11.0466 2.36664L5.79325 7.61998C5.66658 7.74664 5.51991 8.03998 5.49325 8.21331L5.20658 10.22C5.17991 10.4133 5.21991 10.5733 5.31991 10.6733C5.41991 10.7733 5.57991 10.8133 5.77325 10.7866L7.77991 10.5C7.95325 10.4733 8.25325 10.3266 8.37325 10.2L13.6266 4.94664C14.0599 4.51331 14.2866 4.12664 14.3199 3.76664C14.3599 3.33331 14.1332 2.87331 13.6266 2.35998C12.5599 1.29331 11.8266 1.59331 11.0466 2.36664Z"
        fill="#646464"
      />
      <path
        d="M13.2333 6.55331C13.1866 6.55331 13.1399 6.54664 13.0999 6.53331C11.3466 6.03998 9.95325 4.64664 9.45992 2.89331C9.38658 2.62664 9.53992 2.35331 9.80658 2.27331C10.0733 2.19998 10.3466 2.35331 10.4199 2.61998C10.8199 4.03998 11.9466 5.16664 13.3666 5.56664C13.6333 5.63998 13.7866 5.91998 13.7133 6.18664C13.6533 6.41331 13.4533 6.55331 13.2333 6.55331Z"
        fill="#646464"
      />
    </svg>
  );
};

export const IconModules = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.215 6.71497H9.2775C9.26444 6.71497 9.24878 6.70976 9.23449 6.69547C9.2202 6.68119 9.215 6.66553 9.215 6.65247C9.215 6.6394 9.2202 6.62375 9.23449 6.60946C9.24878 6.59517 9.26444 6.58997 9.2775 6.58997H13.215C13.2281 6.58997 13.2437 6.59517 13.258 6.60946C13.2723 6.62375 13.2775 6.6394 13.2775 6.65247C13.2775 6.68818 13.2495 6.71497 13.215 6.71497Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M4.82145 6.61604L5.175 6.26249L4.82145 6.61604L4.98645 6.78104L5.34 7.1346L5.69355 6.78104L6.98355 5.49104C6.993 5.4816 7.00769 5.47437 7.0275 5.47437C7.04731 5.47437 7.062 5.4816 7.07145 5.49104C7.08089 5.50049 7.08812 5.51518 7.08812 5.53499C7.08812 5.5548 7.08089 5.56949 7.07145 5.57894L5.38395 7.26644C5.37164 7.27874 5.35589 7.28499 5.34 7.28499C5.33023 7.28499 5.32263 7.28323 5.31681 7.28089C5.31145 7.27873 5.30449 7.27487 5.29605 7.26644L4.73355 6.70394C4.72411 6.69449 4.71688 6.6798 4.71688 6.65999C4.71688 6.64018 4.72411 6.62549 4.73355 6.61604C4.743 6.6066 4.75769 6.59937 4.7775 6.59937C4.79731 6.59937 4.812 6.6066 4.82145 6.61604Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M13.215 11.965H9.2775C9.26444 11.965 9.24878 11.9598 9.23449 11.9455C9.2202 11.9312 9.215 11.9155 9.215 11.9025C9.215 11.8894 9.2202 11.8737 9.23449 11.8595C9.24878 11.8452 9.26444 11.84 9.2775 11.84H13.215C13.2281 11.84 13.2437 11.8452 13.258 11.8595C13.2723 11.8737 13.2775 11.8894 13.2775 11.9025C13.2775 11.9382 13.2495 11.965 13.215 11.965Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M5.34 12.3846L5.69355 12.031L6.98355 10.741C6.993 10.7316 7.00769 10.7244 7.0275 10.7244C7.04731 10.7244 7.062 10.7316 7.07145 10.741C7.08089 10.7505 7.08812 10.7652 7.08812 10.785C7.08812 10.8048 7.08089 10.8195 7.07145 10.8289L5.38395 12.5164C5.37165 12.5287 5.35589 12.535 5.34 12.535C5.33023 12.535 5.32263 12.5332 5.3168 12.5309C5.31145 12.5287 5.30448 12.5249 5.29605 12.5164L4.73355 11.9539C4.72411 11.9445 4.71688 11.9298 4.71688 11.91C4.71688 11.8902 4.72411 11.8755 4.73355 11.866C4.743 11.8566 4.75769 11.8494 4.7775 11.8494C4.79731 11.8494 4.812 11.8566 4.82145 11.866L5.175 11.5125L4.82145 11.866L4.98645 12.031L5.34 12.3846Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H11.25C15.3225 0.9375 17.0625 2.6775 17.0625 6.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625ZM6.75 2.0625C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V6.75C15.9375 3.2925 14.7075 2.0625 11.25 2.0625H6.75Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconAssignment = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 16.5625H2.25C2.23694 16.5625 2.22128 16.5573 2.20699 16.543C2.1927 16.5287 2.1875 16.5131 2.1875 16.5C2.1875 16.4869 2.1927 16.4713 2.20699 16.457C2.22128 16.4427 2.23694 16.4375 2.25 16.4375H15.75C15.7631 16.4375 15.7787 16.4427 15.793 16.457C15.8073 16.4713 15.8125 16.4869 15.8125 16.5C15.8125 16.5131 15.8073 16.5287 15.793 16.543C15.7787 16.5573 15.7631 16.5625 15.75 16.5625Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M3.5 6.34753V6.34003H3C2.61886 6.34003 2.3125 6.64638 2.3125 7.02753V13.5C2.3125 13.8812 2.61886 14.1875 3 14.1875H4.19998C4.58112 14.1875 4.88748 13.8812 4.88748 13.5V7.03503C4.88748 6.65389 4.58112 6.34753 4.19998 6.34753H3.5ZM4.19998 14.3125H3C2.55614 14.3125 2.1875 13.9439 2.1875 13.5V7.03503C2.1875 6.59118 2.55614 6.22253 3 6.22253H4.19998C4.64384 6.22253 5.01248 6.59118 5.01248 7.03503V13.5C5.01248 13.9439 4.64384 14.3125 4.19998 14.3125Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M9.60013 14.3125H8.40015C7.95629 14.3125 7.58765 13.9438 7.58765 13.5V4.64246C7.58765 4.1986 7.95629 3.82996 8.40015 3.82996H9.60013C10.044 3.82996 10.4126 4.1986 10.4126 4.64246V13.5C10.4126 13.9438 10.044 14.3125 9.60013 14.3125ZM8.40015 3.95496C8.019 3.95496 7.71265 4.26131 7.71265 4.64246V13.5C7.71265 13.8811 8.019 14.1875 8.40015 14.1875H9.60013C9.98127 14.1875 10.2876 13.8811 10.2876 13.5V4.64246C10.2876 4.26131 9.98127 3.95496 9.60013 3.95496H8.40015Z"
        fill="#888888"
        stroke="#888888"
      />
      <path
        d="M14.9999 14.3125H13.7999C13.3561 14.3125 12.9874 13.9439 12.9874 13.5V2.25C12.9874 1.80614 13.3561 1.4375 13.7999 1.4375H14.9999C15.4438 1.4375 15.8124 1.80614 15.8124 2.25V13.5C15.8124 13.9439 15.4438 14.3125 14.9999 14.3125ZM13.7999 1.5625C13.4188 1.5625 13.1124 1.86886 13.1124 2.25V13.5C13.1124 13.8811 13.4188 14.1875 13.7999 14.1875H14.9999C15.381 14.1875 15.6874 13.8811 15.6874 13.5V2.25C15.6874 1.86886 15.381 1.5625 14.9999 1.5625H13.7999Z"
        fill="#888888"
        stroke="#888888"
      />
    </svg>
  );
};

export const IconAssign = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69882 1.66663 5.83334 3.53211 5.83334 5.83329C5.83334 8.13448 7.69882 9.99996 10 9.99996Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.84171 18.3333C2.84171 15.1083 6.05004 12.5 10 12.5C10.8 12.5 11.575 12.6083 12.3 12.8083"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 15C18.3333 15.625 18.1583 16.2166 17.85 16.7166C17.675 17.0166 17.45 17.2833 17.1917 17.5C16.6083 18.025 15.8417 18.3333 15 18.3333C13.7833 18.3333 12.725 17.6833 12.15 16.7166C11.8416 16.2166 11.6667 15.625 11.6667 15C11.6667 13.95 12.15 13.0083 12.9167 12.4C13.4917 11.9416 14.2167 11.6666 15 11.6666C16.8417 11.6666 18.3333 13.1583 18.3333 15Z"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7 15L14.525 15.825L16.3 14.1833"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconJoinDate = () => {
  return (
    <svg
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1.5V3.75"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 1.5V3.75"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.625 6.8175H15.375"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 14.25C16.5 14.8125 16.3425 15.345 16.065 15.795C15.5475 16.665 14.595 17.25 13.5 17.25C12.7425 17.25 12.0525 16.9725 11.5275 16.5C11.295 16.305 11.0925 16.065 10.935 15.795C10.6575 15.345 10.5 14.8125 10.5 14.25C10.5 12.5925 11.8425 11.25 13.5 11.25C14.4 11.25 15.2025 11.6475 15.75 12.27C16.215 12.8025 16.5 13.4925 16.5 14.25Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.33 14.25L13.0725 14.9925L14.67 13.515"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 6.375V12.27C15.2025 11.6475 14.4 11.25 13.5 11.25C11.8425 11.25 10.5 12.5925 10.5 14.25C10.5 14.8125 10.6575 15.345 10.935 15.795C11.0925 16.065 11.295 16.305 11.5275 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99661 10.275H9.00335"
        stroke="#888888"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.22073 10.275H6.22747"
        stroke="#888888"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.22073 12.525H6.22747"
        stroke="#888888"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconFiltersBack = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9751 4.94165L2.91677 9.99998L7.9751 15.0583"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0835 10H3.0585"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconFiltersMenu = () => {
  return (
    <svg
      width="1rem"
      height="0.625rem"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8753 0.875C15.2895 0.875 15.6253 1.21079 15.6253 1.625C15.6253 2.03921 15.2895 2.375 14.8753 2.375H1.12494C0.710726 2.375 0.374939 2.03921 0.374939 1.625C0.374939 1.21079 0.710726 0.875 1.12494 0.875H14.8753ZM15.6253 5.19667C15.6253 4.78246 15.2895 4.44667 14.8753 4.44667H1.12494C0.710726 4.44667 0.374939 4.78246 0.374939 5.19667C0.374939 5.61088 0.710726 5.94667 1.12494 5.94667H14.8753C15.2895 5.94667 15.6253 5.61088 15.6253 5.19667ZM15.6253 8.76833C15.6253 8.35411 15.2895 8.01833 14.8753 8.01833H1.12494C0.710726 8.01833 0.374939 8.35411 0.374939 8.76833C0.374939 9.18254 0.710726 9.51833 1.12494 9.51833H14.8753C15.2895 9.51833 15.6253 9.18254 15.6253 8.76833Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconPlanUpgrade = () => {
  return (
    <svg
      width="6.25rem"
      height="6.25rem"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" fill="#EFEFEF" />
      <path
        d="M82.667 34.9997V41.453C82.667 45.6663 80.0003 48.333 75.787 48.333H66.667V29.693C66.667 26.733 69.0937 24.333 72.0537 24.333C74.9603 24.3597 77.627 25.533 79.547 27.453C81.467 29.3997 82.667 32.0663 82.667 34.9997Z"
        fill="white"
        stroke="#888888"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.333 37.6663V74.9997C29.333 77.213 31.8397 78.4664 33.5997 77.133L38.1597 73.7197C39.2263 72.9197 40.7197 73.0263 41.6797 73.9863L46.1063 78.4397C47.1463 79.4797 48.853 79.4797 49.893 78.4397L54.373 73.9597C55.3063 73.0263 56.7997 72.9197 57.8397 73.7197L62.3997 77.133C64.1597 78.4397 66.6663 77.1863 66.6663 74.9997V29.6663C66.6663 26.733 69.0663 24.333 71.9997 24.333H42.6663H39.9997C31.9997 24.333 29.333 29.1063 29.333 34.9997V37.6663Z"
        fill="white"
        stroke="#888888"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48 63.6934H56"
        stroke="#D9D9D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48 53.0254H56"
        stroke="#D9D9D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.9883 63.666H40.0122Z"
        fill="white"
      />
      <path
        d="M39.9883 63.666H40.0122"
        stroke="#D9D9D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.9883 53H40.0122Z"
        fill="white"
      />
      <path
        d="M39.9883 53H40.0122"
        stroke="#D9D9D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.0653 45.8182V27.6364H54.2301V45.8182H53.0653ZM56.1548 33.6378C56.098 33.0649 55.8542 32.6198 55.4233 32.3026C54.9924 31.9853 54.4077 31.8267 53.669 31.8267C53.1671 31.8267 52.7434 31.8977 52.3977 32.0398C52.0521 32.1771 51.7869 32.3688 51.6023 32.6151C51.4223 32.8613 51.3324 33.1406 51.3324 33.4531C51.3229 33.7135 51.3774 33.9408 51.4957 34.1349C51.6188 34.3291 51.7869 34.4972 52 34.6392C52.2131 34.7765 52.4593 34.8973 52.7386 35.0014C53.018 35.1009 53.3163 35.1861 53.6335 35.2571L54.9403 35.5696C55.5748 35.7116 56.1572 35.901 56.6875 36.1378C57.2178 36.3745 57.6771 36.6657 58.0653 37.0114C58.4536 37.357 58.7543 37.7642 58.9673 38.233C59.1851 38.7017 59.2964 39.2391 59.3011 39.8452C59.2964 40.7353 59.0691 41.5071 58.6193 42.1605C58.1742 42.8092 57.5303 43.3134 56.6875 43.6733C55.8494 44.0284 54.8385 44.206 53.6548 44.206C52.4806 44.206 51.4579 44.026 50.5866 43.6662C49.7202 43.3063 49.0431 42.7737 48.5554 42.0682C48.0724 41.358 47.8191 40.4796 47.7955 39.4332H50.7713C50.8045 39.9209 50.9441 40.3281 51.1903 40.6548C51.4413 40.9768 51.7751 41.2206 52.1918 41.3864C52.6132 41.5473 53.089 41.6278 53.6193 41.6278C54.1402 41.6278 54.5923 41.5521 54.9759 41.4006C55.3641 41.2491 55.6648 41.0384 55.8778 40.7685C56.0909 40.4986 56.1974 40.1884 56.1974 39.8381C56.1974 39.5114 56.1004 39.2367 55.9062 39.0142C55.7169 38.7917 55.4375 38.6023 55.0682 38.446C54.7036 38.2898 54.2562 38.1477 53.7259 38.0199L52.142 37.6222C50.9157 37.3239 49.9474 36.8575 49.2372 36.223C48.527 35.5885 48.1742 34.7339 48.179 33.6591C48.1742 32.7784 48.4086 32.009 48.8821 31.3509C49.3603 30.6927 50.0161 30.179 50.8494 29.8097C51.6828 29.4403 52.6297 29.2557 53.6903 29.2557C54.7699 29.2557 55.7121 29.4403 56.517 29.8097C57.3267 30.179 57.9564 30.6927 58.4062 31.3509C58.8561 32.009 59.0881 32.7713 59.1023 33.6378H56.1548Z"
        fill="#4A154B"
      />
      <path
        d="M21.66 57.2578H38.325C43.665 57.2578 45 58.5778 45 63.8428V76.1578C45 81.4228 43.665 82.7428 38.34 82.7428H21.66C16.335 82.7578 15 81.4378 15 76.1728V63.8428C15 58.5778 16.335 57.2578 21.66 57.2578Z"
        fill="#D9D9D9"
        stroke="#D9D9D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 64.7598H43.5"
        stroke="#4A154B"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M15 78L33 78"
        stroke="white"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M17.25 72.0398C17.036 72.0398 16.8537 71.9815 16.7031 71.8651C16.5526 71.7476 16.4375 71.5777 16.358 71.3551C16.2784 71.1316 16.2386 70.8617 16.2386 70.5455C16.2386 70.2311 16.2784 69.9626 16.358 69.7401C16.4384 69.5166 16.554 69.3461 16.7045 69.2287C16.8561 69.1103 17.0379 69.0511 17.25 69.0511C17.4621 69.0511 17.6435 69.1103 17.794 69.2287C17.9455 69.3461 18.0611 69.5166 18.1406 69.7401C18.2211 69.9626 18.2614 70.2311 18.2614 70.5455C18.2614 70.8617 18.2216 71.1316 18.142 71.3551C18.0625 71.5777 17.9474 71.7476 17.7969 71.8651C17.6463 71.9815 17.464 72.0398 17.25 72.0398ZM17.25 71.7273C17.4621 71.7273 17.6269 71.625 17.7443 71.4205C17.8617 71.2159 17.9205 70.9242 17.9205 70.5455C17.9205 70.2936 17.8935 70.0791 17.8395 69.902C17.7865 69.7249 17.7098 69.59 17.6094 69.4972C17.5099 69.4044 17.3902 69.358 17.25 69.358C17.0398 69.358 16.8755 69.4616 16.7571 69.669C16.6387 69.8755 16.5795 70.1676 16.5795 70.5455C16.5795 70.7973 16.6061 71.0114 16.6591 71.1875C16.7121 71.3636 16.7884 71.4976 16.8878 71.5895C16.9882 71.6813 17.1089 71.7273 17.25 71.7273Z"
        fill="#232323"
      />
      <path
        d="M20.25 72.0398C20.036 72.0398 19.8537 71.9815 19.7031 71.8651C19.5526 71.7476 19.4375 71.5777 19.358 71.3551C19.2784 71.1316 19.2386 70.8617 19.2386 70.5455C19.2386 70.2311 19.2784 69.9626 19.358 69.7401C19.4384 69.5166 19.554 69.3461 19.7045 69.2287C19.8561 69.1103 20.0379 69.0511 20.25 69.0511C20.4621 69.0511 20.6435 69.1103 20.794 69.2287C20.9455 69.3461 21.0611 69.5166 21.1406 69.7401C21.2211 69.9626 21.2614 70.2311 21.2614 70.5455C21.2614 70.8617 21.2216 71.1316 21.142 71.3551C21.0625 71.5777 20.9474 71.7476 20.7969 71.8651C20.6463 71.9815 20.464 72.0398 20.25 72.0398ZM20.25 71.7273C20.4621 71.7273 20.6269 71.625 20.7443 71.4205C20.8617 71.2159 20.9205 70.9242 20.9205 70.5455C20.9205 70.2936 20.8935 70.0791 20.8395 69.902C20.7865 69.7249 20.7098 69.59 20.6094 69.4972C20.5099 69.4044 20.3902 69.358 20.25 69.358C20.0398 69.358 19.8755 69.4616 19.7571 69.669C19.6387 69.8755 19.5795 70.1676 19.5795 70.5455C19.5795 70.7973 19.6061 71.0114 19.6591 71.1875C19.7121 71.3636 19.7884 71.4976 19.8878 71.5895C19.9882 71.6813 20.1089 71.7273 20.25 71.7273Z"
        fill="#232323"
      />
      <path
        d="M23.25 72.0398C23.036 72.0398 22.8537 71.9815 22.7031 71.8651C22.5526 71.7476 22.4375 71.5777 22.358 71.3551C22.2784 71.1316 22.2386 70.8617 22.2386 70.5455C22.2386 70.2311 22.2784 69.9626 22.358 69.7401C22.4384 69.5166 22.554 69.3461 22.7045 69.2287C22.8561 69.1103 23.0379 69.0511 23.25 69.0511C23.4621 69.0511 23.6435 69.1103 23.794 69.2287C23.9455 69.3461 24.0611 69.5166 24.1406 69.7401C24.2211 69.9626 24.2614 70.2311 24.2614 70.5455C24.2614 70.8617 24.2216 71.1316 24.142 71.3551C24.0625 71.5777 23.9474 71.7476 23.7969 71.8651C23.6463 71.9815 23.464 72.0398 23.25 72.0398ZM23.25 71.7273C23.4621 71.7273 23.6269 71.625 23.7443 71.4205C23.8617 71.2159 23.9205 70.9242 23.9205 70.5455C23.9205 70.2936 23.8935 70.0791 23.8395 69.902C23.7865 69.7249 23.7098 69.59 23.6094 69.4972C23.5099 69.4044 23.3902 69.358 23.25 69.358C23.0398 69.358 22.8755 69.4616 22.7571 69.669C22.6387 69.8755 22.5795 70.1676 22.5795 70.5455C22.5795 70.7973 22.6061 71.0114 22.6591 71.1875C22.7121 71.3636 22.7884 71.4976 22.8878 71.5895C22.9882 71.6813 23.1089 71.7273 23.25 71.7273Z"
        fill="#232323"
      />
      <path
        d="M26.25 72.0398C26.036 72.0398 25.8537 71.9815 25.7031 71.8651C25.5526 71.7476 25.4375 71.5777 25.358 71.3551C25.2784 71.1316 25.2386 70.8617 25.2386 70.5455C25.2386 70.2311 25.2784 69.9626 25.358 69.7401C25.4384 69.5166 25.554 69.3461 25.7045 69.2287C25.8561 69.1103 26.0379 69.0511 26.25 69.0511C26.4621 69.0511 26.6435 69.1103 26.794 69.2287C26.9455 69.3461 27.0611 69.5166 27.1406 69.7401C27.2211 69.9626 27.2614 70.2311 27.2614 70.5455C27.2614 70.8617 27.2216 71.1316 27.142 71.3551C27.0625 71.5777 26.9474 71.7476 26.7969 71.8651C26.6463 71.9815 26.464 72.0398 26.25 72.0398ZM26.25 71.7273C26.4621 71.7273 26.6269 71.625 26.7443 71.4205C26.8617 71.2159 26.9205 70.9242 26.9205 70.5455C26.9205 70.2936 26.8935 70.0791 26.8395 69.902C26.7865 69.7249 26.7098 69.59 26.6094 69.4972C26.5099 69.4044 26.3902 69.358 26.25 69.358C26.0398 69.358 25.8755 69.4616 25.7571 69.669C25.6387 69.8755 25.5795 70.1676 25.5795 70.5455C25.5795 70.7973 25.6061 71.0114 25.6591 71.1875C25.7121 71.3636 25.7884 71.4976 25.8878 71.5895C25.9882 71.6813 26.1089 71.7273 26.25 71.7273Z"
        fill="#232323"
      />
      <path
        d="M72 35C77.5 35 82 30.5 82 25C82 19.5 77.5 15 72 15C66.5 15 62 19.5 62 25C62 30.5 66.5 35 72 35Z"
        fill="#2EB67D"
      />
      <path
        d="M67.75 24.9999L70.58 27.8299L76.25 22.1699"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconBulkActions = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66344 7.08301H9.5801"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.99677 13.75H6.66344"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.74677 13.75H12.0801"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3301 10.0253V13.4253C18.3301 16.3503 17.5884 17.0837 14.6301 17.0837H5.36344C2.4051 17.0837 1.66344 16.3503 1.66344 13.4253V6.57533C1.66344 3.65033 2.4051 2.91699 5.36344 2.91699H12.0801"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8968 3.44208L12.8051 6.53375C12.6884 6.65042 12.5718 6.88375 12.5468 7.05042L12.3801 8.23375C12.3218 8.65875 12.6218 8.95875 13.0468 8.90042L14.2301 8.73375C14.3968 8.70875 14.6301 8.59208 14.7468 8.47542L17.8384 5.38375C18.3718 4.85042 18.6218 4.23375 17.8384 3.45042C17.0468 2.65875 16.4301 2.90875 15.8968 3.44208Z"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4551 3.88379C15.7218 4.82546 16.4551 5.55879 17.3884 5.81712"
        stroke="#888888"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconPlanUpgrade1 = () => {
  return (
    <svg
      width="1.75rem"
      height="1.75rem"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="100%" fill="white" />
      <g clip-path="url(#clip0_14185_65759)">
        <path
          d="M12.8676 6.67193L9.12512 8.08193C8.26262 8.40443 7.55762 9.42443 7.55762 10.3394V15.9119C7.55762 16.7969 8.14262 17.9594 8.85512 18.4919L12.0801 20.8994C13.1376 21.6944 14.8776 21.6944 15.9351 20.8994L19.1601 18.4919C19.8726 17.9594 20.4576 16.7969 20.4576 15.9119V10.3394C20.4576 9.41693 19.7526 8.39693 18.8901 8.07443L15.1476 6.67193C14.5101 6.43943 13.4901 6.43943 12.8676 6.67193Z"
          stroke="#F15845"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.7871 13.9018L12.9946 15.1093L16.2196 11.8843"
          stroke="#F15845"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14185_65759">
          <rect
            width="1.125rem"
            height="1.125rem"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IconPlanUpgrade2 = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#2EB67D" />
      <path
        d="M10.9214 5.02154L7.35713 6.3644C6.5357 6.67154 5.86427 7.64297 5.86427 8.5144V13.8215C5.86427 14.6644 6.42142 15.7715 7.09999 16.2787L10.1714 18.5715C11.1786 19.3287 12.8357 19.3287 13.8428 18.5715L16.9143 16.2787C17.5928 15.7715 18.15 14.6644 18.15 13.8215V8.5144C18.15 7.63583 17.4786 6.6644 16.6571 6.35725L13.0928 5.02154C12.4857 4.80011 11.5143 4.80011 10.9214 5.02154Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.89278 11.9068L11.0428 13.0568L14.1142 9.98535"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconDots = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="6" r="2" fill="#888888" />
      <circle cx="12" cy="12" r="2" fill="#888888" />
      <circle cx="12" cy="18" r="2" fill="#888888" />
    </svg>
  );
};

export const IconTimer = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 7.99998C14.6666 11.68 11.68 14.6666 7.99998 14.6666C4.31998 14.6666 1.33331 11.68 1.33331 7.99998C1.33331 4.31998 4.31998 1.33331 7.99998 1.33331C11.68 1.33331 14.6666 4.31998 14.6666 7.99998Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.4734 10.12L8.40669 8.88665C8.04669 8.67332 7.75336 8.15999 7.75336 7.73999V5.00665"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconGo = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49996 18.3334H12.5C16.6666 18.3334 18.3333 16.6667 18.3333 12.5V7.50002C18.3333 3.33335 16.6666 1.66669 12.5 1.66669H7.49996C3.33329 1.66669 1.66663 3.33335 1.66663 7.50002V12.5C1.66663 16.6667 3.33329 18.3334 7.49996 18.3334Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.78174 6.66669H13.5999V12.4985"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.6 6.66669L5.83337 14.4334"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconFilter = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50004 1.75H15.5C16.4167 1.75 17.1667 2.5 17.1667 3.41667V5.25C17.1667 5.91667 16.75 6.75 16.3334 7.16667L12.75 10.3333C12.25 10.75 11.9167 11.5833 11.9167 12.25V15.8333C11.9167 16.3333 11.5834 17 11.1667 17.25L10 18C8.91671 18.6667 7.41671 17.9167 7.41671 16.5833V12.1667C7.41671 11.5833 7.08337 10.8333 6.75004 10.4167L3.58337 7.08333C3.16671 6.66667 2.83337 5.91667 2.83337 5.41667V3.5C2.83337 2.5 3.58337 1.75 4.50004 1.75Z"
        stroke="#232323"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconleftArrow = () => {
  return (
    <svg
      width="0.313rem"
      height="0.625rem"
      viewBox="0 0 5 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.88438 9.87447C5.03854 9.70711 5.03854 9.43575 4.88438 9.26838L0.952979 5L4.88438 0.731617C5.03854 0.564249 5.03854 0.292892 4.88438 0.125525C4.73023 -0.0418422 4.4803 -0.0418422 4.32614 0.125525L0.115616 4.69695C0.0415882 4.77733 0 4.88633 0 5C0 5.11366 0.0415882 5.22267 0.115616 5.30305L4.32614 9.87447C4.4803 10.0418 4.73023 10.0418 4.88438 9.87447Z"
        fill="#232323"
      />
    </svg>
  );
};
export const IconrightArrow = () => {
  return (
    <svg
      width="0.313rem"
      height="0.625rem"
      viewBox="0 0 5 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.115616 0.125526C-0.0385386 0.292893 -0.0385386 0.56425 0.115616 0.731617L4.04702 5L0.115616 9.26838C-0.0385386 9.43575 -0.0385386 9.70711 0.115616 9.87448C0.26977 10.0418 0.519704 10.0418 0.673858 9.87448L4.88438 5.30305C4.95841 5.22267 5 5.11367 5 5C5 4.88634 4.95841 4.77733 4.88438 4.69695L0.673858 0.125526C0.519704 -0.0418419 0.26977 -0.0418419 0.115616 0.125526Z"
        fill="#232323"
      />
    </svg>
  );
};

export const IconSeqarrow = () => {
  return (
    <svg
      width="0.938rem"
      height="0.938rem"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        d="M0.426343 14.4955H11.3406C11.4538 14.4955 11.5624 14.4508 11.6424 14.3709C11.7223 14.291 11.7669 14.1824 11.7669 14.0691V11.7669H14.0692C14.1824 11.7669 14.291 11.7223 14.3709 11.6423C14.4508 11.5624 14.4955 11.4538 14.4955 11.3406V0.426333C14.4955 0.313087 14.4509 0.204501 14.3709 0.124571C14.291 0.044641 14.1824 0 14.0692 0H3.1549C2.91975 0 2.72856 0.191187 2.72856 0.426338V2.72856H0.426338C0.191187 2.72856 0 2.91975 0 3.1549V14.0692C0 14.1824 0.0446325 14.291 0.124571 14.3709C0.204509 14.4508 0.313108 14.4955 0.426343 14.4955ZM3.58124 0.85266H13.6428V10.9142H3.58124V0.85266ZM0.852681 3.58122H2.72857V11.3406C2.72857 11.4538 2.7732 11.5624 2.85314 11.6423C2.93308 11.7223 3.04167 11.7669 3.1549 11.7669H10.9143V13.6428H0.852676L0.852681 3.58122ZM6.26376 8.23172C6.09856 8.06451 6.09856 7.79539 6.26376 7.62818L9.63524 4.26352H7.92989C7.69474 4.26352 7.50355 4.07233 7.50355 3.83718C7.50355 3.60203 7.69474 3.41084 7.92989 3.41084H10.6585C10.6864 3.41084 10.7144 3.41417 10.7417 3.4195L10.779 3.42949L10.8217 3.44282L10.8623 3.4648L10.8949 3.48212L10.8956 3.48279C10.9422 3.51343 10.9822 3.5534 11.0128 3.60003C11.0128 3.61002 11.0228 3.62201 11.0302 3.63267L11.0521 3.67331C11.0521 3.68663 11.0521 3.70262 11.0655 3.71594H11.0661C11.0701 3.7286 11.0741 3.74059 11.0761 3.75391C11.0788 3.78122 11.0788 3.8092 11.0761 3.83718V6.56574C11.0761 6.80089 10.8856 6.99208 10.6498 6.99208C10.4146 6.99208 10.2235 6.80089 10.2235 6.56574V4.86039L6.86732 8.23187C6.70012 8.39774 6.43097 8.39759 6.26376 8.23172Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconArrow = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0249 4.94165L17.0832 9.99998L12.0249 15.0583"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.9165 10H16.9415"
        stroke="#4A154B"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SideArrow = () => {
  return (
    <svg
      width="0.625rem"
      height="1.125rem"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.02605 0.875896C0.769122 1.15484 0.769122 1.6071 1.02605 1.88605L7.57839 9.00002L1.02605 16.114C0.769122 16.3929 0.769122 16.8452 1.02605 17.1241C1.28297 17.4031 1.69953 17.4031 1.95645 17.1241L8.97399 9.5051C9.09737 9.37114 9.16669 9.18946 9.16669 9.00002C9.16669 8.81058 9.09737 8.6289 8.97399 8.49495L1.95645 0.875896C1.69953 0.596951 1.28297 0.596951 1.02605 0.875896Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconAddEmployee = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 8.49998C5.88658 8.49998 4.16658 6.77998 4.16658 4.66665C4.16658 2.55331 5.88658 0.833313 7.99992 0.833313C10.1133 0.833313 11.8333 2.55331 11.8333 4.66665C11.8333 6.77998 10.1133 8.49998 7.99992 8.49998ZM7.99992 1.83331C6.43992 1.83331 5.16658 3.10665 5.16658 4.66665C5.16658 6.22665 6.43992 7.49998 7.99992 7.49998C9.55992 7.49998 10.8333 6.22665 10.8333 4.66665C10.8333 3.10665 9.55992 1.83331 7.99992 1.83331Z"
        fill="#646464"
      />
      <path
        d="M2.27335 15.1667C2.00002 15.1667 1.77335 14.94 1.77335 14.6667C1.77335 11.82 4.56668 9.5 8.00002 9.5C8.67335 9.5 9.33335 9.58668 9.97335 9.76668C10.24 9.84002 10.3934 10.1133 10.32 10.38C10.2467 10.6467 9.97335 10.8 9.70668 10.7267C9.16002 10.5734 8.58668 10.5 8.00002 10.5C5.12002 10.5 2.77335 12.3667 2.77335 14.6667C2.77335 14.94 2.54669 15.1667 2.27335 15.1667Z"
        fill="#646464"
      />
      <path
        d="M11.9999 15.1666C11.2132 15.1666 10.4666 14.8733 9.88657 14.3467C9.65324 14.1467 9.44658 13.9 9.28658 13.6266C8.99324 13.1466 8.83325 12.58 8.83325 12C8.83325 11.1666 9.15325 10.3866 9.72658 9.79331C10.3266 9.17331 11.1332 8.83331 11.9999 8.83331C12.9066 8.83331 13.7666 9.21999 14.3532 9.88666C14.8732 10.4667 15.1666 11.2133 15.1666 12C15.1666 12.2533 15.1333 12.5066 15.0666 12.7466C14.9999 13.0466 14.8732 13.36 14.6999 13.6333C14.1466 14.58 13.1066 15.1666 11.9999 15.1666ZM11.9999 9.83331C11.4066 9.83331 10.8599 10.0666 10.4466 10.4866C10.0533 10.8933 9.83325 11.4266 9.83325 12C9.83325 12.3933 9.93992 12.78 10.1466 13.1133C10.2532 13.3 10.3932 13.4666 10.5532 13.6066C10.9532 13.9733 11.4666 14.1733 11.9999 14.1733C12.7532 14.1733 13.4666 13.7733 13.8532 13.1266C13.9666 12.94 14.0532 12.7267 14.0999 12.52C14.1466 12.3467 14.1666 12.18 14.1666 12.0067C14.1666 11.4733 13.9666 10.96 13.6066 10.56C13.2066 10.0933 12.6199 9.83331 11.9999 9.83331Z"
        fill="#646464"
      />
      <path
        d="M10.6434 12.3451C10.5538 12.2556 10.4973 12.133 10.4973 11.9916C10.4973 11.7182 10.7235 11.4919 10.9969 11.4919L12.9863 11.4919C13.2597 11.4919 13.486 11.7182 13.486 11.9916C13.486 12.265 13.2597 12.4913 12.9863 12.4913L10.9969 12.4913C10.8555 12.4913 10.733 12.4347 10.6434 12.3451Z"
        fill="#646464"
      />
      <path
        d="M11.6425 13.3636C11.5529 13.274 11.4964 13.1515 11.4964 13.01L11.4964 11.0207C11.4964 10.7473 11.7227 10.521 11.9961 10.521C12.2695 10.521 12.4958 10.7473 12.4958 11.0207L12.4958 13.01C12.4958 13.2835 12.2695 13.5097 11.9961 13.5097C11.8546 13.5097 11.7321 13.4532 11.6425 13.3636Z"
        fill="#646464"
      />
    </svg>
  );
};

export const IconDashboardMostPopular1 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6757 3.78783L13.7207 1L10 3.64474L13.951 6.43257C14.0554 6.50794 14.1417 6.61556 14.2013 6.74462C14.2609 6.87368 14.2916 7.01962 14.2903 7.16776V13L17.6555 10.6217C17.7592 10.5486 17.8454 10.4437 17.9057 10.3173C17.9659 10.1909 17.998 10.0475 17.9989 9.90132V4.5477C18.0059 4.39726 17.9795 4.24731 17.9227 4.1136C17.8658 3.97989 17.7805 3.86736 17.6757 3.78783Z"
        fill="#E3828D"
      />

      <path
        d="M15.392 5.41406L7.97631 1L1 5.1875L8.40808 9.60156C8.60389 9.7209 8.76578 9.8913 8.87747 10.0956C8.98916 10.3 9.04672 10.5311 9.04435 10.7656V20L15.3541 16.2344C15.5485 16.1186 15.7102 15.9525 15.8231 15.7524C15.9361 15.5523 15.9963 15.3253 15.9979 15.0938V6.61719C16.011 6.379 15.9616 6.14158 15.855 5.92987C15.7484 5.71816 15.5884 5.53998 15.392 5.41406Z"
        fill="#9269F7"
      />
    </svg>
  );
};

export const IconDashboardMostPopular2 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9.70352V4L12.4751 6.41658C12.7985 6.59118 13 6.92903 13 7.29649V13L8.52485 10.5834C8.20153 10.4088 8 10.071 8 9.70352Z"
        fill="#9269F7"
      />

      <path
        d="M16 12.7849L9.60456 8.97505C9.43402 8.87343 9.29272 8.72683 9.19515 8.55028C9.09758 8.37373 9.04724 8.17358 9.04929 7.97033L9.08848 0L3.58801 3.28389C3.42122 3.38481 3.28249 3.52845 3.18521 3.70091C3.08794 3.87337 3.03542 4.06883 3.03274 4.26838L3.00008 11.5577C2.99769 11.7677 3.05126 11.9744 3.15495 12.1551C3.25863 12.3359 3.40844 12.4838 3.58801 12.5826L16 20V12.7849Z"
        fill="#E3828D"
      />
    </svg>
  );
};

export const IconDashboardMostPopular3 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75165 1.5593L0.818441 6.15155L1.19422 14.7862L9.12356 10.201C9.33565 10.0812 9.57844 10.0192 9.8275 10.0214C10.0766 10.0235 10.3231 10.0897 10.5424 10.2132L19.222 14.9904L18.9026 7.192C18.893 6.95187 18.8193 6.716 18.6889 6.50778C18.5585 6.29956 18.3758 6.12622 18.159 6.00496L10.1917 1.61984C9.97453 1.48449 9.72617 1.40745 9.47277 1.39679C9.21936 1.38614 8.97027 1.44228 8.75165 1.5593Z"
        fill="#E3828D"
      />

      <circle cx="10" cy="13" r="4" fill="#9269F7" />
    </svg>
  );
};

export const CreateProcess = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 10.6667V4.33333C12.6667 3.6 12.0667 3 11.3334 3H8.33337"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 1.33325L8 2.99992L10 4.66659"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33337 6V10.6667"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.50004 5.66659C4.69666 5.66659 5.66671 4.69654 5.66671 3.49992C5.66671 2.3033 4.69666 1.33325 3.50004 1.33325C2.30342 1.33325 1.33337 2.3033 1.33337 3.49992C1.33337 4.69654 2.30342 5.66659 3.50004 5.66659Z"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33337 14.6667C4.43794 14.6667 5.33337 13.7713 5.33337 12.6667C5.33337 11.5622 4.43794 10.6667 3.33337 10.6667C2.2288 10.6667 1.33337 11.5622 1.33337 12.6667C1.33337 13.7713 2.2288 14.6667 3.33337 14.6667Z"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6666 14.6667C13.7712 14.6667 14.6666 13.7713 14.6666 12.6667C14.6666 11.5622 13.7712 10.6667 12.6666 10.6667C11.5621 10.6667 10.6666 11.5622 10.6666 12.6667C10.6666 13.7713 11.5621 14.6667 12.6666 14.6667Z"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconDashboardMostPopular4 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="8" r="4" fill="#9269F7" />

      <path
        d="M16 12.7849L10.0965 8.97505C9.9391 8.87343 9.80867 8.72683 9.7186 8.55028C9.62853 8.37373 9.58207 8.17358 9.58396 7.97033L9.62014 0L4.54278 3.28389C4.38882 3.38481 4.26076 3.52845 4.17096 3.70091C4.08117 3.87337 4.0327 4.06883 4.03022 4.26838L4.00007 11.5577C3.99787 11.7677 4.04732 11.9744 4.14303 12.1551C4.23874 12.3359 4.37702 12.4838 4.54278 12.5826L16 20V12.7849Z"
        fill="#E3828D"
      />
    </svg>
  );
};

export const IconDashboardMostPopular5 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 11.7345V1L9.98602 5.52541C10.6127 5.88052 11 6.54517 11 7.26546V18L3.01397 13.4746C2.38731 13.1195 2 12.4548 2 11.7345Z"
        fill="#9269F7"
      />

      <path
        d="M8 12.7345V2L15.986 6.52541C16.6127 6.88052 17 7.54517 17 8.26546V19L9.01397 14.4746C8.38731 14.1195 8 13.4548 8 12.7345Z"
        fill="#E3828D"
      />
    </svg>
  );
};

export const IconDashboardMostPopular6 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.04561 2.46667H17.7802L13.2547 10.4527C12.8996 11.0794 12.235 11.4667 11.5147 11.4667H0.780151L5.30557 3.48064C5.66068 2.85398 6.32533 2.46667 7.04561 2.46667Z"
        fill="#9269F7"
      />

      <path
        d="M7.48531 8.53332H18.2198L13.6944 16.5193C13.3393 17.146 12.6747 17.5333 11.9544 17.5333H1.21985L5.74526 9.54729C6.10037 8.92063 6.76502 8.53332 7.48531 8.53332Z"
        fill="#E3828D"
      />
    </svg>
  );
};

export const ImageUpload = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49984 18.3337H12.4998C16.6665 18.3337 18.3332 16.667 18.3332 12.5003V7.50033C18.3332 3.33366 16.6665 1.66699 12.4998 1.66699H7.49984C3.33317 1.66699 1.6665 3.33366 1.6665 7.50033V12.5003C1.6665 16.667 3.33317 18.3337 7.49984 18.3337Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.50016 8.33333C8.42064 8.33333 9.16683 7.58714 9.16683 6.66667C9.16683 5.74619 8.42064 5 7.50016 5C6.57969 5 5.8335 5.74619 5.8335 6.66667C5.8335 7.58714 6.57969 8.33333 7.50016 8.33333Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.2251 15.7918L6.33343 13.0335C6.99176 12.5918 7.94176 12.6418 8.53343 13.1501L8.80843 13.3918C9.45843 13.9501 10.5084 13.9501 11.1584 13.3918L14.6251 10.4168C15.2751 9.85846 16.3251 9.85846 16.9751 10.4168L18.3334 11.5835"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const VideoUpload = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4415 17.0167H5.17484C2.5415 17.0167 1.6665 15.2667 1.6665 13.5084V6.49173C1.6665 3.8584 2.5415 2.9834 5.17484 2.9834H10.4415C13.0748 2.9834 13.9498 3.8584 13.9498 6.49173V13.5084C13.9498 16.1417 13.0665 17.0167 10.4415 17.0167Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.2669 14.2501L13.9502 12.6251V7.36678L16.2669 5.74178C17.4002 4.95011 18.3335 5.43344 18.3335 6.82511V13.1751C18.3335 14.5668 17.4002 15.0501 16.2669 14.2501Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5835 9.16699C10.2739 9.16699 10.8335 8.60735 10.8335 7.91699C10.8335 7.22664 10.2739 6.66699 9.5835 6.66699C8.89314 6.66699 8.3335 7.22664 8.3335 7.91699C8.3335 8.60735 8.89314 9.16699 9.5835 9.16699Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResourcesEmployee = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3337 13.95V3.89168C18.3337 2.89168 17.517 2.15001 16.5253 2.23335H16.4753C14.7253 2.38335 12.067 3.27502 10.5837 4.20835L10.442 4.30001C10.2003 4.45001 9.80033 4.45001 9.55866 4.30001L9.35033 4.17502C7.86699 3.25002 5.21699 2.36668 3.46699 2.22501C2.47533 2.14168 1.66699 2.89168 1.66699 3.88335V13.95C1.66699 14.75 2.31699 15.5 3.11699 15.6L3.35866 15.6333C5.16699 15.875 7.95866 16.7917 9.55866 17.6667L9.59199 17.6833C9.81699 17.8083 10.1753 17.8083 10.392 17.6833C11.992 16.8 14.792 15.875 16.6087 15.6333L16.8837 15.6C17.6837 15.5 18.3337 14.75 18.3337 13.95Z"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 4.57501V17.075"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.45801 7.07501H4.58301"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08301 9.57501H4.58301"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const HomeEmployeeWhite = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15V12.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.39172 2.34998L2.61672 6.97498C1.96672 7.49164 1.55006 8.58331 1.69172 9.39998L2.80006 16.0333C3.00006 17.2166 4.13339 18.175 5.33339 18.175H14.6667C15.8584 18.175 17.0001 17.2083 17.2001 16.0333L18.3084 9.39998C18.4417 8.58331 18.0251 7.49164 17.3834 6.97498L11.6084 2.35831C10.7167 1.64164 9.27506 1.64164 8.39172 2.34998Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const HomeEmployeeGrey = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15V12.5"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.39172 2.35004L2.61672 6.97504C1.96672 7.4917 1.55006 8.58337 1.69172 9.40004L2.80006 16.0334C3.00006 17.2167 4.13339 18.175 5.33339 18.175H14.6667C15.8584 18.175 17.0001 17.2084 17.2001 16.0334L18.3084 9.40004C18.4417 8.58337 18.0251 7.4917 17.3834 6.97504L11.6084 2.35837C10.7167 1.6417 9.27506 1.6417 8.39172 2.35004Z"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ImageUploadPreview = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.67004 18.9501L7.60004 15.6401C8.39004 15.1101 9.53004 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const VideoUploadPreview = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.1001 12V10.52C9.1001 8.60999 10.4501 7.83999 12.1001 8.78999L13.3801 9.52999L14.6601 10.27C16.3101 11.22 16.3101 12.78 14.6601 13.73L13.3801 14.47L12.1001 15.21C10.4501 16.16 9.1001 15.38 9.1001 13.48V12Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PDFUploadPreview = () => {
  return (
    <svg
      width="2.5rem"
      height="2.5rem"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6693_36171)">
        <rect width="2.5rem" height="2.5rem" rx="6" fill="#D76859" />
        <path
          opacity="0.3"
          d="M28 0H35C37.7614 0 40 2.23858 40 5V12H34C30.6863 12 28 9.31371 28 6V0Z"
          fill="white"
        />
        <path
          d="M11.8926 21.2881H9.30176V19.9277H11.8926C12.3438 19.9277 12.7083 19.8548 12.9863 19.709C13.2643 19.5632 13.4671 19.3626 13.5947 19.1074C13.7269 18.8477 13.793 18.5514 13.793 18.2188C13.793 17.9043 13.7269 17.6104 13.5947 17.3369C13.4671 17.0589 13.2643 16.8356 12.9863 16.667C12.7083 16.4984 12.3438 16.4141 11.8926 16.4141H9.82812V25H8.1123V15.0469H11.8926C12.6628 15.0469 13.3167 15.1836 13.8545 15.457C14.3968 15.7259 14.8092 16.0996 15.0918 16.5781C15.3743 17.0521 15.5156 17.5944 15.5156 18.2051C15.5156 18.8477 15.3743 19.3991 15.0918 19.8594C14.8092 20.3197 14.3968 20.6729 13.8545 20.9189C13.3167 21.165 12.6628 21.2881 11.8926 21.2881Z"
          fill="white"
        />
        <path
          d="M19.9453 25H17.8193L17.833 23.6396H19.9453C20.5605 23.6396 21.0755 23.5052 21.4902 23.2363C21.9095 22.9674 22.224 22.5824 22.4336 22.0811C22.6478 21.5798 22.7549 20.9827 22.7549 20.29V19.75C22.7549 19.2122 22.6934 18.736 22.5703 18.3213C22.4518 17.9066 22.2741 17.5579 22.0371 17.2754C21.8047 16.9928 21.5176 16.7786 21.1758 16.6328C20.8385 16.487 20.4489 16.4141 20.0068 16.4141H17.7783V15.0469H20.0068C20.6676 15.0469 21.2715 15.1585 21.8184 15.3818C22.3652 15.6006 22.8369 15.9173 23.2334 16.332C23.6344 16.7467 23.9421 17.2435 24.1562 17.8223C24.3704 18.401 24.4775 19.0482 24.4775 19.7637V20.29C24.4775 21.0055 24.3704 21.6527 24.1562 22.2314C23.9421 22.8102 23.6344 23.307 23.2334 23.7217C22.8324 24.1318 22.3538 24.4486 21.7979 24.6719C21.2464 24.8906 20.6289 25 19.9453 25ZM18.7695 15.0469V25H17.0537V15.0469H18.7695Z"
          fill="white"
        />
        <path
          d="M27.916 15.0469V25H26.2002V15.0469H27.916ZM31.9766 19.4014V20.7617H27.4785V19.4014H31.9766ZM32.5439 15.0469V16.4141H27.4785V15.0469H32.5439Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6693_36171">
          <rect width="2.5rem" height="2.5rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PDFicon = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8877_51826)">
        <rect width="1.5rem" height="1.5rem" rx="4" fill="#D76859" />
        <path
          opacity="0.3"
          d="M16.8 0H19C21.7615 0 24 2.23858 24 5V7.2H22.8001C19.4863 7.2 16.8 4.51371 16.8 1.2V0Z"
          fill="white"
        />
        <path
          d="M7.1356 12.7728H5.5811V11.9566H7.1356C7.4063 11.9566 7.62505 11.9128 7.79185 11.8253C7.95864 11.7378 8.08032 11.6175 8.15688 11.4644C8.23618 11.3085 8.27583 11.1308 8.27583 10.9312C8.27583 10.7425 8.23618 10.5662 8.15688 10.4021C8.08032 10.2353 7.95864 10.1013 7.79185 10.0001C7.62505 9.89897 7.4063 9.84839 7.1356 9.84839H5.89692V15H4.86743V9.02808H7.1356C7.5977 9.02808 7.99009 9.11011 8.31274 9.27417C8.63813 9.4355 8.8856 9.65972 9.05513 9.94683C9.22466 10.2312 9.30942 10.5566 9.30942 10.923C9.30942 11.3085 9.22466 11.6394 9.05513 11.9156C8.8856 12.1917 8.63813 12.4037 8.31274 12.5513C7.99009 12.699 7.5977 12.7728 7.1356 12.7728Z"
          fill="white"
        />
        <path
          d="M11.9672 15H10.6916L10.6999 14.1837H11.9672C12.3364 14.1837 12.6454 14.1031 12.8942 13.9417C13.1458 13.7804 13.3344 13.5494 13.4602 13.2486C13.5887 12.9478 13.653 12.5896 13.653 12.174V11.85C13.653 11.5273 13.6161 11.2416 13.5422 10.9927C13.4711 10.7439 13.3645 10.5347 13.2223 10.3652C13.0829 10.1957 12.9106 10.0671 12.7055 9.97964C12.5032 9.89214 12.2694 9.84839 12.0041 9.84839H10.667V9.02808H12.0041C12.4006 9.02808 12.7629 9.09507 13.0911 9.22905C13.4192 9.3603 13.7022 9.55034 13.9401 9.79917C14.1807 10.048 14.3653 10.346 14.4938 10.6933C14.6223 11.0406 14.6866 11.4289 14.6866 11.8582V12.174C14.6866 12.6033 14.6223 12.9916 14.4938 13.3388C14.3653 13.6861 14.1807 13.9841 13.9401 14.233C13.6995 14.4791 13.4124 14.6691 13.0788 14.8031C12.7479 14.9343 12.3774 15 11.9672 15ZM11.2618 9.02808V15H10.2323V9.02808H11.2618Z"
          fill="white"
        />
        <path
          d="M16.7497 9.02808V15H15.7202V9.02808H16.7497ZM19.186 11.6408V12.457H16.4872V11.6408H19.186ZM19.5264 9.02808V9.84839H16.4872V9.02808H19.5264Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8877_51826">
          <rect width="1.5rem" height="1.5rem" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PDFdownload = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5394 16.0005H5.46056C1.63583 16.0005 0 14.4005 0 10.6595V10.5605C0 7.17763 1.36319 5.54715 4.41675 5.26525C4.72833 5.24239 5.02434 5.47096 5.0555 5.78334C5.08666 6.09572 4.85297 6.37763 4.5258 6.4081C2.07984 6.62906 1.16845 7.75668 1.16845 10.5681V10.6672C1.16845 13.7681 2.29017 14.8652 5.46056 14.8652H10.5394C13.7098 14.8652 14.8315 13.7681 14.8315 10.6672V10.5681C14.8315 7.74144 13.9046 6.61382 11.4119 6.4081C11.0925 6.37763 10.851 6.10334 10.8822 5.79096C10.9133 5.47858 11.186 5.24239 11.5131 5.27287C14.6134 5.53191 16 7.17001 16 10.5757V10.6748C16 14.4005 14.3642 16.0005 10.5394 16.0005Z"
        fill="#4A154B"
      />
      <path
        d="M8 10.9562C7.68062 10.9562 7.41577 10.6971 7.41577 10.3848V0.571429C7.41577 0.259048 7.68062 0 8 0C8.31937 0 8.58422 0.259048 8.58422 0.571429V10.3848C8.58422 10.7048 8.31937 10.9562 8 10.9562Z"
        fill="#4A154B"
      />
      <path
        d="M8.00041 11.8095C7.85241 11.8095 7.70441 11.7562 7.58756 11.6419L4.97802 9.08954C4.75212 8.86859 4.75212 8.50288 4.97802 8.28193C5.20392 8.06097 5.57782 8.06097 5.80373 8.28193L8.00041 10.4305L10.1971 8.28193C10.423 8.06097 10.7969 8.06097 11.0228 8.28193C11.2487 8.50288 11.2487 8.86859 11.0228 9.08954L8.41327 11.6419C8.29642 11.7562 8.14842 11.8095 8.00041 11.8095Z"
        fill="#4A154B"
      />
    </svg>
  );
};

export const FileUploadPreview = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="#888"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 13H12"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 17H16"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const FeedbackIconGrey = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V11.5"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.8645 13.7553L20.7445 15.5153C20.8645 15.7603 21.1845 15.9953 21.4545 16.0403L23.0495 16.3053C24.0695 16.4753 24.3095 17.2153 23.5745 17.9453L22.3345 19.1853C22.1245 19.3953 22.0095 19.8003 22.0745 20.0903L22.4295 21.6253C22.7095 22.8403 22.0645 23.3103 20.9895 22.6753L19.4945 21.7903C19.2245 21.6303 18.7795 21.6303 18.5045 21.7903L17.0095 22.6753C15.9395 23.3103 15.2895 22.8353 15.5695 21.6253L15.9245 20.0903C15.9895 19.8003 15.8745 19.3953 15.6645 19.1853L14.4245 17.9453C13.6945 17.2153 13.9295 16.4753 14.9495 16.3053L16.5445 16.0403C16.8095 15.9953 17.1295 15.7603 17.2495 15.5153L18.1295 13.7553C18.6095 12.8003 19.3895 12.8003 19.8645 13.7553Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Alerts = () => {
  return (
    <svg
      width="2rem"
      height="2.063rem"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="1" width="2rem" height="2rem" rx="1rem" fill="#F5F3DD" />
      <path
        d="M23.32 19.94L18.52 11.3C17.875 10.1375 16.9825 9.5 16 9.5C15.0175 9.5 14.125 10.1375 13.48 11.3L8.68001 19.94C8.07251 21.0425 8.00501 22.1 8.49251 22.9325C8.98001 23.765 9.94001 24.2225 11.2 24.2225H20.8C22.06 24.2225 23.02 23.765 23.5075 22.9325C23.995 22.1 23.9275 21.035 23.32 19.94ZM15.4375 14.75C15.4375 14.4425 15.6925 14.1875 16 14.1875C16.3075 14.1875 16.5625 14.4425 16.5625 14.75V18.5C16.5625 18.8075 16.3075 19.0625 16 19.0625C15.6925 19.0625 15.4375 18.8075 15.4375 18.5V14.75ZM16.5325 21.2825C16.495 21.3125 16.4575 21.3425 16.42 21.3725C16.375 21.4025 16.33 21.425 16.285 21.44C16.24 21.4625 16.195 21.4775 16.1425 21.485C16.0975 21.4925 16.045 21.5 16 21.5C15.955 21.5 15.9025 21.4925 15.85 21.485C15.805 21.4775 15.76 21.4625 15.715 21.44C15.67 21.425 15.625 21.4025 15.58 21.3725C15.5425 21.3425 15.505 21.3125 15.4675 21.2825C15.3325 21.14 15.25 20.945 15.25 20.75C15.25 20.555 15.3325 20.36 15.4675 20.2175C15.505 20.1875 15.5425 20.1575 15.58 20.1275C15.625 20.0975 15.67 20.075 15.715 20.06C15.76 20.0375 15.805 20.0225 15.85 20.015C15.9475 19.9925 16.0525 19.9925 16.1425 20.015C16.195 20.0225 16.24 20.0375 16.285 20.06C16.33 20.075 16.375 20.0975 16.42 20.1275C16.4575 20.1575 16.495 20.1875 16.5325 20.2175C16.6675 20.36 16.75 20.555 16.75 20.75C16.75 20.945 16.6675 21.14 16.5325 21.2825Z"
        fill="#ECB22E"
      />
    </svg>
  );
};
export const MyLearing = () => {
  return (
    <svg
      width="11rem"
      height="9.25rem"
      viewBox="0 0 176 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.1169 41.4012C33.1169 34.5013 27.528 28.9815 20.6972 28.9815C13.7974 28.9815 8.27753 34.5703 8.27753 41.4012C8.27753 45.7481 10.5545 49.612 13.9354 51.8199V59.7547L27.5281 58.3747V51.8199C30.909 49.612 33.1169 45.7481 33.1169 41.4012Z"
        fill="#FAC53D"
      />
      <path
        d="M24.9056 62.7881L23.8707 63.6851H17.1088L16.1428 62.7881C14.1419 60.9252 12.9689 58.3722 12.9689 55.6123V55.3363H28.3556C28.3556 58.2342 27.1136 60.9941 24.9056 62.7881Z"
        fill="white"
      />
      <path
        d="M28.3581 56.5095H12.9714C12.8334 56.5095 12.6954 56.3715 12.6954 56.2335V55.6125C12.6954 55.4745 12.8334 55.3365 12.9714 55.3365H28.3581C28.496 55.3365 28.634 55.4745 28.634 55.6125V56.2335C28.634 56.3715 28.496 56.5095 28.3581 56.5095Z"
        fill="#4A154B"
      />
      <path
        d="M28.3581 58.7883H12.9714C12.8334 58.7883 12.6954 58.6503 12.6954 58.5123V57.8913C12.6954 57.7533 12.8334 57.6153 12.9714 57.6153H28.3581C28.496 57.6153 28.634 57.7533 28.634 57.8913V58.5123C28.634 58.7193 28.496 58.7883 28.3581 58.7883Z"
        fill="#4A154B"
      />
      <path
        d="M22.9072 65.7561H17.8703C17.3183 65.7561 16.9044 65.3421 16.9044 64.7901V63.5482H23.8732V64.7901C23.8732 65.2731 23.4592 65.7561 22.9072 65.7561Z"
        fill="#4A154B"
      />
      <path
        d="M107.118 91.8191C117.882 95.2001 134.925 88.9212 141.893 82.6424C147.137 77.9505 147.689 69.8777 147.068 63.3918C145.481 48.0742 137.547 34.1365 131.406 20.2679C127.68 11.7811 117.468 5.15724 108.429 3.57028C101.529 2.39731 94.2156 4.81226 89.1098 9.57314C84.0039 14.334 81.1059 21.2339 80.761 28.2027C80.209 41.1054 85.3838 55.94 91.1797 67.2558C95.1816 75.1906 97.2516 88.7832 107.118 91.8191Z"
        fill="#EF9E8F"
      />
      <path
        d="M80.9699 75.4653L55.7166 103.893L42.0549 90.921C40.1919 89.196 37.294 89.127 35.431 90.852L27.7032 98.0278C26.2543 99.4077 25.7713 101.547 26.4613 103.41C30.1872 112.655 42.0549 139.151 54.7506 139.358C70.2062 139.565 89.5947 101.616 89.5947 101.616L80.9699 75.4653Z"
        fill="white"
      />
      <path
        d="M54.8874 140.118C54.8184 140.118 54.8184 140.118 54.7494 140.118C41.7777 139.98 30.117 114.588 25.7011 103.686C24.8041 101.548 25.4251 98.9946 27.0811 97.4076L34.8089 90.2318C37.0168 88.2309 40.3978 88.2309 42.5367 90.3008L55.5774 102.721L81.1758 73.8792L90.3525 101.617L90.2145 101.893C89.5246 103.548 70.619 140.118 54.8874 140.118ZM38.7418 90.4388C37.7758 90.4388 36.7408 90.7838 35.9819 91.5428L28.254 98.7186C27.0121 99.8916 26.5981 101.686 27.2191 103.204C30.531 111.483 42.4677 138.462 54.8184 138.6C54.8874 138.6 54.8874 138.6 54.9564 138.6C69.0321 138.6 87.0406 105.066 88.8346 101.617L80.6928 77.0531L55.7844 105.066L41.5017 91.5428C40.7427 90.7838 39.7768 90.4388 38.7418 90.4388Z"
        fill="#4A154B"
      />
      <path
        d="M126.784 68.8431L116.158 67.9462L90.146 70.6371C84.0051 71.2581 79.0373 75.95 77.9333 82.0218L74.2764 102.583C73.5174 106.861 74.9664 111.277 78.1403 114.244L80.6932 116.659L81.2452 147.156H154.797L146.863 85.4717C144.31 76.295 136.306 69.6711 126.784 68.8431Z"
        fill="white"
      />
      <path
        d="M152.867 131.768L154.868 147.155H103.189L152.867 131.768Z"
        fill="#4A154B"
      />
      <path
        d="M155.762 147.983H80.4852L79.9332 116.727C79.9332 116.313 80.2782 115.899 80.6922 115.899C81.1062 115.899 81.5202 116.244 81.5202 116.658L82.0722 146.396H153.968L146.172 85.6775C143.688 76.8457 135.822 70.4288 126.714 69.6009L116.157 68.7039L90.214 71.3948C86.8331 71.7398 83.7971 73.3958 81.5892 75.9487L78.6222 79.3296C78.3462 79.6746 77.8633 79.6746 77.5183 79.3986C77.1733 79.1226 77.1733 78.6396 77.4493 78.2947L80.4162 74.9827C82.8311 72.0848 86.2811 70.2908 90.076 69.8768L116.157 67.1169L126.852 68.0139C136.65 68.8419 144.999 75.8107 147.69 85.2635V85.4015L155.762 147.983Z"
        fill="#4A154B"
      />
      <path
        d="M116.16 67.9458L128.442 68.9808C137.895 69.8088 146.588 74.5006 152.315 82.0215C161.423 93.8202 173.843 112.105 174.74 125.49C175.775 140.394 139.482 143.016 126.303 144.465C122.922 144.81 119.679 142.878 118.506 139.704C117.402 136.737 116.643 132.39 117.816 126.387C118.368 123.627 120.438 121.419 123.198 120.799L138.378 117.28C138.378 117.28 123.129 101.686 122.922 94.2341C122.784 86.7823 116.16 67.9458 116.16 67.9458Z"
        fill="white"
      />
      <path
        d="M125.545 145.292C122.164 145.292 119.059 143.222 117.817 139.979C116.368 136.046 116.092 131.423 117.058 126.249C117.61 123.144 119.956 120.729 122.992 120.039L138.172 116.52C138.586 116.451 139 116.658 139.138 117.141C139.207 117.555 139 117.969 138.517 118.107L123.337 121.626C120.922 122.178 119.059 124.11 118.576 126.594C117.679 131.492 117.886 135.839 119.266 139.496C120.301 142.325 123.199 144.05 126.235 143.774C127.063 143.705 128.029 143.567 129.064 143.498C136.654 142.739 148.108 141.566 157.698 138.875C168.945 135.701 174.396 131.285 173.982 125.697C173.085 112.725 161.355 95.1303 151.695 82.6416C146.038 75.3278 137.551 70.7049 128.374 69.9459L116.092 68.9109C115.678 68.8419 115.333 68.4969 115.402 68.0829C115.471 67.669 115.816 67.324 116.23 67.393L128.512 68.4279C138.172 69.2559 147.073 74.0858 153.006 81.7446C162.804 94.4403 174.672 112.311 175.638 125.697C176.673 140.393 144.658 143.636 129.271 145.223C128.236 145.292 127.339 145.43 126.511 145.499C126.097 145.292 125.821 145.292 125.545 145.292Z"
        fill="#4A154B"
      />
      <path
        d="M122.921 126.869L108.569 127.628L92.6995 136.046C91.8715 136.46 91.5955 137.426 92.0095 138.254C92.4235 139.013 93.3205 139.427 94.1485 139.082L104.498 134.873C104.705 134.804 104.774 135.011 104.636 135.149L93.9415 142.394C93.1825 142.877 92.9755 143.912 93.5275 144.671C94.0105 145.361 94.9765 145.568 95.6665 145.154L107.741 137.84C107.879 137.771 108.017 137.909 107.879 138.047L103.187 142.325C102.152 143.291 102.566 145.085 104.015 145.361C104.429 145.43 104.912 145.361 105.326 145.154L110.225 142.187L123.266 142.256C127.544 142.256 130.994 138.806 130.994 134.528C130.994 130.181 127.337 126.662 122.921 126.869Z"
        fill="white"
      />
      <path
        d="M104.36 146.188C104.153 146.188 104.015 146.188 103.808 146.119C102.842 145.912 102.152 145.222 101.876 144.256C101.669 143.429 101.876 142.532 102.428 141.911L96.011 145.774C94.907 146.395 93.527 146.119 92.768 145.084C92.423 144.532 92.285 143.912 92.354 143.291C92.492 142.67 92.837 142.118 93.389 141.704L99.1159 137.84L94.355 139.772C93.182 140.255 91.8021 139.703 91.1811 138.599C90.6291 137.426 91.0431 135.977 92.2161 135.356L108.293 126.869H108.5L122.851 126.11C125.197 126.041 127.405 126.869 129.061 128.456C130.717 130.043 131.683 132.251 131.683 134.597C131.683 136.874 130.786 139.013 129.199 140.6C127.612 142.187 125.404 143.084 123.127 143.084L110.363 143.015L105.602 145.843C105.257 146.05 104.843 146.188 104.36 146.188ZM107.81 137.012C108.086 137.012 108.362 137.15 108.5 137.357C108.776 137.702 108.707 138.254 108.362 138.599L103.67 142.877C103.394 143.153 103.256 143.498 103.394 143.843C103.463 144.188 103.739 144.464 104.153 144.533C104.429 144.602 104.636 144.532 104.843 144.395L109.949 141.29L123.196 141.359C123.196 141.359 123.196 141.359 123.265 141.359C125.128 141.359 126.853 140.669 128.164 139.358C129.475 138.047 130.234 136.322 130.234 134.459C130.234 132.527 129.475 130.802 128.095 129.491C126.715 128.18 124.921 127.49 122.989 127.559L108.845 128.318L93.113 136.667C92.699 136.874 92.492 137.426 92.699 137.84C92.906 138.254 93.389 138.461 93.803 138.254L104.153 134.045C104.636 133.838 105.119 134.045 105.326 134.459C105.533 134.873 105.395 135.425 105.05 135.701L94.355 142.946C94.148 143.084 94.01 143.291 94.01 143.498C93.941 143.705 94.01 143.912 94.148 144.119C94.424 144.464 94.907 144.601 95.252 144.325L107.327 137.15C107.465 137.081 107.603 137.012 107.81 137.012Z"
        fill="#4A154B"
      />
      <path
        d="M117.263 47.2465L120.988 66.2211C121.264 67.532 122.299 68.498 123.61 68.636L130.924 69.395C131.269 69.464 131.407 69.878 131.2 70.085L107.81 107.413L95.6661 71.1199C95.3211 70.6369 95.5971 70.016 96.1491 70.016L100.22 69.602C101.324 69.464 102.221 68.567 102.221 67.394V48.2125L117.263 47.2465Z"
        fill="white"
      />
      <path
        d="M103.394 94.2338C107.396 95.3377 111.466 95.6137 115.537 95.0618L113.398 98.4427C112.708 98.5117 112.087 98.5117 111.397 98.5117C109.121 98.5117 106.775 98.3047 104.567 97.8217L103.394 94.2338Z"
        fill="#4A154B"
      />
      <path
        d="M128.025 75.1202L124.713 80.4331C120.504 82.2271 115.95 83.124 111.465 83.124C107.187 83.124 102.978 82.2961 98.9074 80.7091L97.5275 76.6382C107.256 81.6061 118.779 81.0541 128.025 75.1202Z"
        fill="#4A154B"
      />
      <path
        d="M121.194 86.092L118.71 90.0249C116.295 90.5769 113.88 90.7839 111.465 90.7839C108.222 90.7839 104.979 90.3009 101.806 89.4039L100.564 85.609C107.187 88.2309 114.501 88.3 121.194 86.092Z"
        fill="#4A154B"
      />
      <path
        d="M106.153 102.513C107.602 102.789 109.12 102.927 110.569 102.927L108.637 105.963C108.154 105.894 107.74 105.894 107.257 105.825L106.153 102.513Z"
        fill="#4A154B"
      />
      <path
        d="M107.603 109.275L94.9764 71.4643C94.7004 71.0503 94.7004 70.5673 94.9074 70.0843C95.1144 69.6013 95.5974 69.2563 96.1494 69.1873L100.22 68.7733C100.91 68.7043 101.462 68.0833 101.462 67.3934V47.4529L117.953 46.4179L121.817 66.0824C122.024 67.0484 122.783 67.7384 123.749 67.8074L131.063 68.5663C131.546 68.6353 131.96 68.9113 132.098 69.3943C132.236 69.8083 132.167 70.2223 131.891 70.5673L107.603 109.275ZM96.3564 70.7743L108.017 105.618L130.304 70.0843L123.611 69.3943C121.955 69.2563 120.644 68.0143 120.299 66.3584L116.711 48.0738L103.118 48.9018V67.3934C103.118 68.9113 101.945 70.2223 100.427 70.3603L96.3564 70.7743Z"
        fill="#4A154B"
      />
      <path
        d="M125.076 40.3252C127.729 39.3706 129.107 36.4457 128.152 33.7922C127.198 31.1387 124.273 29.7614 121.619 30.7159C118.966 31.6704 117.588 34.5954 118.543 37.2489C119.497 39.9024 122.422 41.2797 125.076 40.3252Z"
        fill="white"
      />
      <path
        d="M123.267 41.3805C120.3 41.3805 117.747 39.1035 117.402 36.0676C117.264 34.4806 117.747 32.9627 118.713 31.7897C119.679 30.5477 121.128 29.8578 122.646 29.6508C125.889 29.3058 128.718 31.7207 129.063 34.8946C129.201 36.4816 128.718 37.9996 127.752 39.1725C126.786 40.4145 125.337 41.1045 123.819 41.3115C123.681 41.3115 123.474 41.3805 123.267 41.3805ZM123.336 31.1687C123.198 31.1687 123.06 31.1687 122.922 31.1687C121.749 31.3067 120.783 31.8587 120.024 32.6867C119.265 33.5837 118.92 34.6876 119.058 35.8606C119.265 38.2066 121.404 39.9315 123.75 39.7245C124.923 39.5865 125.889 39.0345 126.648 38.2066C127.407 37.3096 127.752 36.2056 127.614 35.0326C127.338 32.8247 125.475 31.1687 123.336 31.1687Z"
        fill="#4A154B"
      />
      <path
        d="M121.888 22.8194C121.888 22.8194 130.168 55.6626 106.709 59.9405C83.2493 64.2184 88.7692 20.1975 88.7692 20.1975C88.7692 20.1975 103.328 -0.157023 121.888 22.8194Z"
        fill="white"
      />
      <path
        d="M103.601 61.0453C100.151 61.0453 97.1839 59.8723 94.7689 57.5953C84.5572 47.9356 87.8001 21.2332 87.9381 20.1292C88.0071 19.7152 88.3521 19.3703 88.8351 19.4393C89.2491 19.5083 89.5941 19.8532 89.5251 20.3362C89.5251 20.6122 86.2821 47.3836 95.8729 56.4914C98.6328 59.1133 102.221 60.0103 106.568 59.1823C115.675 57.5263 120.988 51.2475 122.23 40.4147C122.299 40.0008 122.644 39.6558 123.127 39.7248C123.541 39.7938 123.886 40.1388 123.817 40.6217C122.506 52.0065 116.641 58.9753 106.844 60.7003C105.74 60.9763 104.636 61.0453 103.601 61.0453Z"
        fill="#4A154B"
      />
      <path
        d="M123.61 3.6383C122.437 5.15627 121.747 7.08822 121.678 9.02018C121.609 9.71016 121.54 10.7451 121.816 11.3661C122.299 12.2631 122.989 13.1601 123.679 13.8501C124.162 14.264 124.645 14.609 125.197 15.023C125.818 15.506 126.232 15.92 127.06 16.265C130.165 17.714 134.097 17.162 136.65 14.885C139.203 12.6081 140.169 8.74418 138.927 5.50126C137.823 2.60333 134.925 0.395385 131.82 0.0503936C128.716 -0.294598 125.473 1.15436 123.61 3.6383Z"
        fill="#EF9E8F"
      />
      <path
        d="M100.632 49.0401C100.425 49.0401 100.149 48.9711 100.011 48.8331C99.7349 48.6261 99.5969 48.2811 99.5969 47.9361L99.6659 43.9342C99.6659 43.5202 100.011 43.1752 100.425 43.1752C100.839 43.1752 101.184 43.5202 101.184 44.0032L101.115 47.3151L102.702 46.8322C103.116 46.6942 103.53 46.9701 103.668 47.3841C103.806 47.7981 103.53 48.2121 103.116 48.3501L100.839 49.0401C100.839 49.0401 100.77 49.0401 100.632 49.0401ZM101.184 47.9361C101.184 47.9361 101.184 48.0051 101.184 47.9361V47.9361Z"
        fill="#4A154B"
      />
      <path
        d="M90.5597 34.2738C90.2837 34.2738 90.0077 34.1358 89.8697 33.8598C89.6627 33.5148 89.8007 33.0318 90.1457 32.7558C93.1126 31.0309 95.7346 32.6868 95.8036 32.7558C96.1485 32.9628 96.2866 33.4458 96.0106 33.8598C95.8036 34.2048 95.3206 34.3428 94.9066 34.0668C94.8376 33.9978 92.9746 32.8938 90.9047 34.0668C90.8357 34.2738 90.6977 34.2738 90.5597 34.2738Z"
        fill="#4A154B"
      />
      <path
        d="M111.19 34.2735C111.052 34.2735 110.845 34.2045 110.707 34.1355C110.638 34.0665 108.775 32.8936 106.705 33.9975C106.291 34.2045 105.877 34.0665 105.67 33.6525C105.463 33.2385 105.601 32.8246 106.015 32.6176C109.051 31.0306 111.604 32.7556 111.673 32.8935C112.018 33.1695 112.087 33.6525 111.88 33.9975C111.673 34.1355 111.466 34.2735 111.19 34.2735Z"
        fill="#4A154B"
      />
      <path
        d="M91.9404 37.6555C91.9404 38.3455 92.4234 38.8975 92.9754 38.8975C93.5274 38.8975 94.0104 38.3455 94.0104 37.6555C94.0104 36.9656 93.5274 36.4136 92.9754 36.4136C92.4234 36.4136 91.9404 37.0346 91.9404 37.6555Z"
        fill="#4A154B"
      />
      <path
        d="M107.811 39.2423C108.383 39.2423 108.846 38.6862 108.846 38.0003C108.846 37.3144 108.383 36.7584 107.811 36.7584C107.24 36.7584 106.776 37.3144 106.776 38.0003C106.776 38.6862 107.24 39.2423 107.811 39.2423Z"
        fill="#4A154B"
      />
      <path
        d="M107.298 52.8757C108.169 52.1956 108.362 50.9869 107.729 50.1759C107.095 49.3649 105.876 49.2588 105.005 49.9389C104.134 50.619 103.941 51.8277 104.574 52.6387C105.207 53.4496 106.427 53.5557 107.298 52.8757Z"
        fill="#EF9E8F"
      />
      <path
        d="M104.017 53.2485C103.603 53.2485 103.258 52.9035 103.258 52.4895C103.258 52.0755 103.603 51.6615 104.017 51.6615C104.983 51.5925 105.673 51.3855 106.087 50.9025C106.639 50.2815 106.57 49.5225 106.57 49.4535C106.57 49.0396 106.846 48.6256 107.26 48.6256C107.674 48.6256 108.088 48.9016 108.088 49.3156C108.088 49.4536 108.157 50.7645 107.191 51.8685C106.57 52.6965 105.466 53.1795 104.017 53.2485C104.086 53.2485 104.017 53.2485 104.017 53.2485Z"
        fill="#4A154B"
      />
      <path
        d="M0.863315 73.6014C1.76029 72.5664 3.27826 72.4974 4.24424 73.4634L13.145 81.9502L10.4541 73.1874C11.9031 71.3245 13.766 73.1874 13.766 73.1874L18.5269 81.2602L17.7679 74.2914C18.6649 72.2214 20.8728 74.4984 20.8728 74.4984L24.2538 81.7432L24.7367 79.8803C24.7367 79.8803 26.4617 77.7413 27.7727 76.9823C28.1177 76.7753 28.5316 76.9133 28.7386 77.1893C29.0836 77.7413 29.4976 78.6383 29.2906 79.8803C28.9456 81.8122 28.4627 81.5362 28.4627 81.5362L28.3937 84.9861H28.8076L32.3955 81.1222L34.1895 78.0173C34.9485 76.6373 36.3975 75.8094 37.9844 75.8094C38.1914 75.8094 38.2604 75.9474 38.2604 76.1544L37.0184 83.8132L38.2604 88.85L38.3984 88.9881C40.8823 92.645 40.1924 97.6818 36.8114 100.511C33.9825 102.857 30.0496 103.133 26.9447 101.339L22.1148 98.5098C19.9069 97.1988 17.9059 95.5429 16.3189 93.5419L0.863315 74.3604C0.65632 74.1534 0.65632 73.8084 0.863315 73.6014Z"
        fill="white"
      />
      <path
        d="M31.2218 103.064C29.5658 103.064 27.9098 102.65 26.4609 101.753L21.631 98.9245C19.354 97.5445 17.2841 95.8196 15.6281 93.7496L0.310493 74.8441C-0.103497 74.2921 -0.103497 73.5331 0.310493 73.0501C0.862479 72.3601 1.69047 72.0151 2.51845 71.9461C3.41543 71.8771 4.2434 72.2221 4.86439 72.8431L13.5582 81.1229C13.9032 81.3989 13.9032 81.9509 13.5582 82.2269C13.2822 82.5719 12.7302 82.5719 12.4542 82.2269L3.76041 73.9471C3.41542 73.6711 3.00143 73.4641 2.58744 73.5331C2.17345 73.5331 1.82846 73.7401 1.55246 73.9471L16.8011 92.7146C18.3881 94.6466 20.251 96.2336 22.39 97.4755L27.2198 100.304C30.0488 101.96 33.7057 101.684 36.1896 99.5455C39.2945 96.9235 39.9845 92.4386 37.6386 89.0577L37.4316 88.7817L36.1206 83.4689L37.2936 76.293C36.2586 76.5 35.2926 77.121 34.7407 78.018L32.9467 81.1919L29.2898 85.1248C29.0138 85.4698 28.4618 85.4698 28.1858 85.1938C27.8408 84.9178 27.8408 84.3658 28.1168 84.0899L31.7047 80.2949L33.4297 77.259C34.3267 75.6721 36.0516 74.7061 37.8456 74.7061C38.1906 74.7061 38.4666 74.8441 38.6736 75.0511C38.8806 75.2581 38.9496 75.6031 38.9496 75.8791V75.948L37.7076 83.3999L38.8806 88.0917V88.1608C41.6405 92.2317 40.8815 97.6135 37.0866 100.718C35.4997 102.305 33.3607 103.064 31.2218 103.064Z"
        fill="#4A154B"
      />
      <path
        d="M34.9455 90.0249C34.8765 90.0249 34.8075 90.0249 34.7385 90.0249L27.3557 87.886V81.4691L27.9766 80.5722C28.5976 79.6752 28.5976 78.4332 28.0456 77.5362L25.3547 80.2272L23.4227 87.541C23.2847 87.955 22.8708 88.231 22.4568 88.093C22.0428 87.955 21.7668 87.541 21.9048 87.127L23.9057 79.3992L27.1486 76.1563C27.4246 75.8803 27.7697 75.7423 28.1146 75.8113C28.4596 75.8113 28.8046 76.0183 29.0116 76.2943L29.0806 76.3633C30.2536 77.8812 30.3226 79.9512 29.2186 81.5381L28.8736 82.0211V86.782L35.0835 88.576C35.4974 88.714 35.7735 89.128 35.6355 89.5419C35.5665 89.7489 35.2905 90.0249 34.9455 90.0249Z"
        fill="#4A154B"
      />
      <path
        d="M19.0745 87.1273C18.6605 87.1273 18.3155 86.8514 18.3155 86.4374L17.0046 74.0867C16.9356 73.5347 17.2115 72.9827 17.7635 72.7757C19.1435 72.1547 20.7305 72.7067 21.5584 73.9487L21.6274 74.0867L24.8014 81.9525C24.9394 82.3665 24.8014 82.7804 24.3874 82.9874C23.9734 83.1254 23.5594 82.9874 23.3524 82.5735L20.1785 74.7766C19.8335 74.2937 19.2125 74.0177 18.5915 74.2246L19.9025 86.3684C19.9715 86.7823 19.6265 87.1964 19.2125 87.2654C19.1435 87.1274 19.1435 87.1273 19.0745 87.1273Z"
        fill="#4A154B"
      />
      <path
        d="M14.3159 86.5052C13.9709 86.5052 13.6949 86.2982 13.5569 85.9532L9.69299 73.3955C9.486 72.7745 9.83099 72.0845 10.452 71.8085L10.728 71.7396C11.9699 71.2566 13.4189 71.5325 14.3159 72.5675L14.3849 72.6365L14.4539 72.7055L19.2148 80.7093C19.4218 81.0543 19.2838 81.5373 18.9388 81.8133C18.5938 82.0203 18.1108 81.8823 17.8348 81.5373L13.1429 73.6715C12.6599 73.1885 11.9699 73.0505 11.3489 73.3265L15.1439 85.6082C15.2819 86.0222 15.0059 86.4362 14.5919 86.5742C14.5229 86.5052 14.3849 86.5052 14.3159 86.5052Z"
        fill="#4A154B"
      />
      <path
        d="M107.81 114.242C107.603 114.242 107.396 114.173 107.258 114.035C106.913 113.759 106.913 113.207 107.258 112.931L127.543 91.8864L125.128 84.2276L133.822 82.2956L133.615 70.1519C133.615 69.7379 133.96 69.3929 134.374 69.3239C134.788 69.3239 135.133 69.6689 135.202 70.0829L135.409 83.5376L127.129 85.4005L129.337 92.3004L108.431 114.035C108.224 114.173 108.017 114.242 107.81 114.242Z"
        fill="#4A154B"
      />
      <path
        d="M106.636 126.8C106.222 126.8 105.877 126.455 105.877 126.041V116.037L90.9734 87.3334L94.3543 81.1235L88.0754 80.2266L88.1444 70.8428C88.1444 70.4288 88.4894 70.0838 88.9034 70.0838C89.3174 70.0838 89.6624 70.4288 89.6624 70.8428L89.5934 78.8466L96.7692 79.8816L92.6983 87.3334L107.395 115.623V126.041C107.395 126.455 107.05 126.8 106.636 126.8Z"
        fill="#4A154B"
      />
      <path
        d="M108.777 44.8991C104.292 44.8991 100.566 41.2422 100.566 36.6883C100.566 32.2034 104.223 28.4775 108.777 28.4775C113.262 28.4775 116.988 32.1344 116.988 36.6883C116.919 41.2422 113.262 44.8991 108.777 44.8991ZM108.777 30.1335C105.12 30.1335 102.153 33.1004 102.153 36.7573C102.153 40.4142 105.12 43.3812 108.777 43.3812C112.434 43.3812 115.401 40.4142 115.401 36.7573C115.401 33.1004 112.434 30.1335 108.777 30.1335Z"
        fill="#4A154B"
      />
      <path
        d="M115.19 33.9303C114.845 33.9303 114.5 33.7234 114.431 33.3784C114.293 32.9644 114.569 32.5504 114.983 32.4124L124.781 29.7214C125.195 29.5834 125.609 29.8595 125.747 30.2734C125.885 30.6874 125.609 31.1014 125.195 31.2394L115.397 33.9303C115.328 33.8613 115.259 33.9303 115.19 33.9303Z"
        fill="#4A154B"
      />
      <path
        d="M98.286 18.0594C96.2851 25.1662 90.3512 31.031 83.1754 32.825C82.6924 27.1671 83.9344 21.4403 86.3493 16.3344C87.5223 13.8505 88.9712 11.5045 91.0412 9.71056C94.3531 6.81263 98.976 5.84665 103.323 5.84665C109.602 5.91565 115.95 7.8476 121.124 11.5045C125.54 14.5404 128.576 18.6113 130.784 23.5102C131.129 24.2692 131.681 24.8212 132.095 25.5112C132.509 26.2702 132.578 27.1671 132.44 27.9951C132.233 29.0301 131.819 29.9961 130.715 30.3411C129.611 30.6171 128.438 30.5481 127.265 30.6861C125.816 30.8931 124.298 30.962 122.849 30.962C116.916 30.893 111.051 29.0301 106.083 25.7182C103.047 23.7172 100.356 21.0953 98.286 18.0594Z"
        fill="#EF9E8F"
      />
      <path
        d="M92.9756 44.8988C88.4907 44.8988 84.7648 41.2419 84.7648 36.688C84.7648 32.2031 88.4217 28.4772 92.9756 28.4772C97.5295 28.4772 101.186 32.1341 101.186 36.688C101.186 41.2419 97.4605 44.8988 92.9756 44.8988ZM92.9756 30.1331C89.3187 30.1331 86.3517 33.1001 86.3517 36.757C86.3517 40.4139 89.3187 43.3808 92.9756 43.3808C96.6325 43.3808 99.5994 40.4139 99.5994 36.757C99.5994 33.1001 96.6325 30.1331 92.9756 30.1331Z"
        fill="#4A154B"
      />
      <path
        d="M126.645 47.6612H124.368C123.609 47.6612 122.988 47.0402 122.988 46.2812V39.1744C122.988 38.7604 123.333 38.4154 123.747 38.4154C124.161 38.4154 124.506 38.7604 124.506 39.1744V46.0742H126.231L124.782 42.2793C124.644 41.8653 124.851 41.4513 125.265 41.2443C125.679 41.1063 126.093 41.3133 126.3 41.7273L127.818 45.8672C127.956 46.2812 127.887 46.7642 127.68 47.1092C127.542 47.4542 127.128 47.6612 126.645 47.6612Z"
        fill="#4A154B"
      />
    </svg>
  );
};

export const Expired = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6V9.33333"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00028 14.2734H3.96028C1.64695 14.2734 0.680281 12.6201 1.80028 10.6001L3.88028 6.85339L5.84028 3.33339C7.02695 1.19339 8.97361 1.19339 10.1603 3.33339L12.1203 6.86006L14.2003 10.6067C15.3203 12.6267 14.3469 14.2801 12.0403 14.2801H8.00028V14.2734Z"
        stroke="#E01E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99609 11.3334H8.00208"
        stroke="#E01E1E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDelayed = () => {
  return (
    <svg
      width="0.625rem"
      height="1rem"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15986 1.3335H2.83986C0.333196 1.3335 0.139862 3.58683 1.4932 4.8135L8.50653 11.1868C9.85986 12.4135 9.66653 14.6668 7.15986 14.6668H2.83986C0.333196 14.6668 0.139862 12.4135 1.4932 11.1868L8.50653 4.8135C9.85986 3.58683 9.66653 1.3335 7.15986 1.3335Z"
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconExpired = () => {
  return (
    <svg
      width="0.938rem"
      height="0.938rem"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.66602 5.27197V8.60531"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.6663 13.545H3.6263C1.31296 13.545 0.346296 11.8917 1.4663 9.87167L3.5463 6.125L5.5063 2.605C6.69296 0.465 8.63963 0.465 9.8263 2.605L11.7863 6.13167L13.8663 9.87833C14.9863 11.8983 14.013 13.5517 11.7063 13.5517H7.6663V13.545Z"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.66211 10.6055H7.6681"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconListDoc = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M8.75116 1.55946L0.817953 6.15172L1.19373 14.7864L9.12308 10.2012C9.33517 10.0814 9.57795 10.0194 9.82701 10.0216C10.0761 10.0237 10.3226 10.0899 10.5419 10.2134L19.2215 14.9906L18.9021 7.19217C18.8925 6.95204 18.8188 6.71617 18.6884 6.50795C18.558 6.29973 18.3753 6.12639 18.1585 6.00512L10.1912 1.62001C9.97404 1.48466 9.72569 1.40761 9.47228 1.39696C9.21888 1.38631 8.96978 1.44244 8.75116 1.55946Z"
          fill="#E3828D"
        />
      </g>
      <g>
        <circle cx="10" cy="13" r="4" fill="#9269F7" />
      </g>
    </svg>
  );
};
export const IconPhoto = () => {
  return (
    <svg
      width="1.375rem"
      height="1.375rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.67004 18.9501L7.60004 15.6401C8.39004 15.1101 9.53004 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconAudio = () => {
  return (
    <svg
      width="1.375rem"
      height="1.375rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.62 17.3C10.7908 17.3 11.74 16.3509 11.74 15.1801C11.74 14.0092 10.7908 13.0601 9.62 13.0601C8.44915 13.0601 7.5 14.0092 7.5 15.1801C7.5 16.3509 8.44915 17.3 9.62 17.3Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.74 15.18V7.77002"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.13 6.7701L15.47 7.55006C16.04 7.74006 16.5 8.38006 16.5 8.98006V9.60005C16.5 10.4101 15.87 10.8601 15.11 10.6001L12.77 9.82008C12.2 9.63008 11.74 8.99009 11.74 8.39009V7.7701C11.74 6.9701 12.36 6.5101 13.13 6.7701Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconVideo = () => {
  return (
    <svg
      width="1.375rem"
      height="1.375rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.1001 12V10.52C9.1001 8.60999 10.4501 7.83999 12.1001 8.78999L13.3801 9.52999L14.6601 10.27C16.3101 11.22 16.3101 12.78 14.6601 13.73L13.3801 14.47L12.1001 15.21C10.4501 16.16 9.1001 15.38 9.1001 13.48V12Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconDocument = () => {
  return (
    <svg
      width="1.375rem"
      height="1.375rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 9H8.25"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 15H8.25"
        stroke="#F15845"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const IconVideoPlay = () => {
  return (
    <svg
      height="2rem"
      width="2rem"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z"
        fill="rgba(0,0,0,0.6)"
      ></path>
      <path
        class="Nci3Ge"
        d="M13 10.92v10.16a1 1 0 0 0 1.573.819l7.257-5.08a1 1 0 0 0 0-1.638l-7.256-5.08a1 1 0 0 0-1.574.82Z"
        fill="#FFF"
      ></path>
    </svg>
  );
};
export const IconLink = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM16.37 14.63L14.15 16.85C13.61 17.39 12.91 17.65 12.21 17.65C11.51 17.65 10.8 17.38 10.27 16.85C9.2 15.78 9.2 14.03 10.27 12.96L11.68 11.55C11.97 11.26 12.45 11.26 12.74 11.55C13.03 11.84 13.03 12.32 12.74 12.61L11.33 14.02C10.84 14.51 10.84 15.3 11.33 15.79C11.82 16.28 12.61 16.28 13.1 15.79L15.32 13.57C15.93 12.96 16.27 12.14 16.27 11.27C16.27 10.4 15.93 9.59 15.32 8.97C14.09 7.74 11.95 7.74 10.72 8.97L8.29 11.4C7.25 12.44 7.25 14.14 8.29 15.19C8.58 15.48 8.58 15.96 8.29 16.25C8 16.54 7.52 16.54 7.23 16.25C5.6 14.62 5.6 11.97 7.23 10.34L9.65 7.92C10.55 7.02 11.74 6.53 13.01 6.53C14.28 6.53 15.47 7.02 16.37 7.92C17.27 8.82 17.76 10.01 17.76 11.28C17.76 12.55 17.27 13.74 16.37 14.63Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};
export const IconDropDown = () => {
  return (
    <svg
      width="0.75rem"
      height="0.9375rem"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8745 4.43717C10.7071 4.24798 10.4358 4.24798 10.2684 4.43717L6 9.26208L1.73162 4.43717C1.56425 4.24798 1.29289 4.24798 1.12552 4.43717C0.958158 4.62636 0.958158 4.9331 1.12552 5.12228L5.69695 10.2897C5.77733 10.3806 5.88633 10.4316 6 10.4316C6.11366 10.4316 6.22267 10.3806 6.30305 10.2897L10.8745 5.12228C11.0418 4.9331 11.0418 4.62636 10.8745 4.43717Z"
        fill="#232323"
      />
    </svg>
  );
};
export const tickCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.5938 2.35254C7.08375 2.35254 2.59375 6.84254 2.59375 12.3525C2.59375 17.8625 7.08375 22.3525 12.5938 22.3525C18.1038 22.3525 22.5938 17.8625 22.5938 12.3525C22.5938 6.84254 18.1038 2.35254 12.5938 2.35254ZM17.3738 10.0525L11.7037 15.7225C11.5637 15.8625 11.3737 15.9425 11.1737 15.9425C10.9738 15.9425 10.7838 15.8625 10.6438 15.7225L7.81375 12.8925C7.52375 12.6025 7.52375 12.1225 7.81375 11.8325C8.10375 11.5425 8.58375 11.5425 8.87375 11.8325L11.1737 14.1325L16.3138 8.99254C16.6038 8.70254 17.0838 8.70254 17.3738 8.99254C17.6638 9.28254 17.6638 9.75254 17.3738 10.0525Z"
        fill="#2EB67D"
      />
    </svg>
  );
};

export const MinusBorder = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12H18"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TickNormal = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 12L10.58 14.83L16.25 9.17004"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SpinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-100"
        cx="12"
        cy="12"
        r="10"
        stroke="#F15845"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="#D9D9D9"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};
export const TickFill = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z"
        fill="#2EB67D"
      />
    </svg>
  );
};
export const CrossIconXl = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7456 3.62673C16.0227 3.31885 15.9977 2.84463 15.6898 2.56754C15.3819 2.29044 14.9077 2.3154 14.6306 2.62328L9.00031 8.8792L3.36998 2.62328C3.09288 2.3154 2.61867 2.29044 2.31078 2.56754C2.0029 2.84463 1.97794 3.31885 2.25504 3.62673L7.99128 10.0003L2.25504 16.3739C1.97794 16.6818 2.0029 17.156 2.31078 17.4331C2.61867 17.7102 3.09288 17.6853 3.36998 17.3774L9.00031 11.1215L14.6306 17.3774C14.9077 17.6853 15.3819 17.7102 15.6898 17.4331C15.9977 17.156 16.0227 16.6818 15.7456 16.3739L10.0093 10.0003L15.7456 3.62673Z"
        fill="#232323"
      />
    </svg>
  );
};
export const CrossIconRounded = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#F3D1CB" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4476 5.2598C11.6429 5.06454 11.6429 4.74796 11.4476 4.5527C11.2523 4.35743 10.9358 4.35743 10.7405 4.5527L8.00015 7.29304L5.2598 4.5527C5.06454 4.35743 4.74796 4.35743 4.5527 4.5527C4.35743 4.74796 4.35743 5.06454 4.5527 5.2598L7.29304 8.00015L4.5527 10.7405C4.35743 10.9358 4.35743 11.2523 4.5527 11.4476C4.74796 11.6429 5.06454 11.6429 5.2598 11.4476L8.00015 8.70726L10.7405 11.4476C10.9358 11.6429 11.2523 11.6429 11.4476 11.4476C11.6429 11.2523 11.6429 10.9358 11.4476 10.7405L8.70726 8.00015L11.4476 5.2598Z"
        fill="#E01E1E"
      />
    </svg>
  );
};

export const InfoCircleRedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM7.4 4.8C7.4 4.472 7.672 4.2 8 4.2C8.328 4.2 8.6 4.472 8.6 4.8V8.8C8.6 9.128 8.328 9.4 8 9.4C7.672 9.4 7.4 9.128 7.4 8.8V4.8ZM8.736 11.504C8.696 11.608 8.64 11.688 8.568 11.768C8.488 11.84 8.4 11.896 8.304 11.936C8.208 11.976 8.104 12 8 12C7.896 12 7.792 11.976 7.696 11.936C7.6 11.896 7.512 11.84 7.432 11.768C7.36 11.688 7.304 11.608 7.264 11.504C7.224 11.408 7.2 11.304 7.2 11.2C7.2 11.096 7.224 10.992 7.264 10.896C7.304 10.8 7.36 10.712 7.432 10.632C7.512 10.56 7.6 10.504 7.696 10.464C7.888 10.384 8.112 10.384 8.304 10.464C8.4 10.504 8.488 10.56 8.568 10.632C8.64 10.712 8.696 10.8 8.736 10.896C8.776 10.992 8.8 11.096 8.8 11.2C8.8 11.304 8.776 11.408 8.736 11.504Z"
        fill="#F15845"
      />
    </svg>
  );
};
export const InfoCirclewhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M8.82049 14.6673C12.7512 14.6673 15.9672 11.6673 15.9672 8.00065C15.9672 4.33398 12.7512 1.33398 8.82049 1.33398C4.88983 1.33398 1.67383 4.33398 1.67383 8.00065C1.67383 11.6673 4.88983 14.6673 8.82049 14.6673Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.82031 5.33301V8.66634"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.81641 10.666H8.82283"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CircleCrossIcon = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16998 14.83L14.83 9.17004"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 14.83L9.16998 9.17004"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CircleTickIcon = () => {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.75 12L10.58 14.83L16.25 9.17004"
        stroke="#888888"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TickGreen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7181 2.75881C20.0815 3.116 20.0954 3.70942 19.749 4.08425L7.62069 17.2093C7.44902 17.395 7.21101 17.5001 6.96217 17.5C6.71332 17.4999 6.4754 17.3946 6.30389 17.2087L0.250417 10.6462C-0.0956292 10.271 -0.0812559 9.6776 0.28252 9.32074C0.646297 8.96388 1.22172 8.9787 1.56777 9.35385L6.96217 13.3333L18.4328 2.79075C18.7791 2.41592 19.3546 2.40162 19.7181 2.75881Z"
        fill="#2EB67D"
      />
    </svg>
  );
};
export const CrossRed = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4058 3.65533C17.6986 3.36244 17.6986 2.88756 17.4058 2.59467C17.1129 2.30178 16.638 2.30178 16.3451 2.59467L10.0001 8.93967L3.65509 2.59467C3.36219 2.30178 2.88732 2.30178 2.59443 2.59467C2.30153 2.88756 2.30153 3.36244 2.59443 3.65533L8.93943 10.0003L2.59443 16.3453C2.30153 16.6382 2.30153 17.1131 2.59443 17.406C2.88732 17.6989 3.36219 17.6989 3.65509 17.406L10.0001 11.061L16.3451 17.406C16.638 17.6989 17.1129 17.6989 17.4058 17.406C17.6986 17.1131 17.6986 16.6382 17.4058 16.3453L11.0607 10.0003L17.4058 3.65533Z"
        fill="#E01E1E"
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM9.25 6C9.25 5.59 9.59 5.25 10 5.25C10.41 5.25 10.75 5.59 10.75 6V11C10.75 11.41 10.41 11.75 10 11.75C9.59 11.75 9.25 11.41 9.25 11V6ZM10.92 14.38C10.87 14.51 10.8 14.61 10.71 14.71C10.61 14.8 10.5 14.87 10.38 14.92C10.26 14.97 10.13 15 10 15C9.87 15 9.74 14.97 9.62 14.92C9.5 14.87 9.39 14.8 9.29 14.71C9.2 14.61 9.13 14.51 9.08 14.38C9.03 14.26 9 14.13 9 14C9 13.87 9.03 13.74 9.08 13.62C9.13 13.5 9.2 13.39 9.29 13.29C9.39 13.2 9.5 13.13 9.62 13.08C9.86 12.98 10.14 12.98 10.38 13.08C10.5 13.13 10.61 13.2 10.71 13.29C10.8 13.39 10.87 13.5 10.92 13.62C10.97 13.74 11 13.87 11 14C11 14.13 10.97 14.26 10.92 14.38Z"
        fill="#F15845"
      />
    </svg>
  );
};

export const PreviewIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons/Preview">
        <path
          id="Vector (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0001 7.6416C8.69527 7.6416 7.64175 8.69511 7.64175 9.99993C7.64175 11.3048 8.69527 12.3583 10.0001 12.3583C11.3049 12.3583 12.3584 11.3048 12.3584 9.99993C12.3584 8.69511 11.3049 7.6416 10.0001 7.6416ZM6.39175 9.99993C6.39175 8.00476 8.00491 6.3916 10.0001 6.3916C11.9953 6.3916 13.6084 8.00476 13.6084 9.99993C13.6084 11.9951 11.9953 13.6083 10.0001 13.6083C8.00491 13.6083 6.39175 11.9951 6.39175 9.99993Z"
          fill="#4A154B"
        />
        <path
          id="Vector (Stroke)_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.88127 7.49708C3.8737 4.36511 6.79337 2.47461 10 2.47461C13.2068 2.47461 16.1266 4.36527 18.119 7.49749C18.5732 8.20944 18.7792 9.12141 18.7792 9.99544C18.7792 10.8696 18.5731 11.7818 18.1188 12.4938C16.1263 15.6258 13.2067 17.5163 10 17.5163C6.79323 17.5163 3.87344 15.6256 1.88101 12.4934L2.40836 12.1579L1.88153 12.4942C1.42702 11.7821 1.22086 10.8698 1.22086 9.99544C1.22086 9.12124 1.42694 8.20909 1.88127 7.49708ZM10 3.72461C7.32348 3.72461 4.75993 5.30061 2.9357 8.1684L2.93518 8.16921C2.63969 8.63215 2.47086 9.29481 2.47086 9.99544C2.47086 10.6961 2.63969 11.3587 2.93518 11.8217L2.93571 11.8225C4.75993 14.6903 7.32348 16.2663 10 16.2663C12.6766 16.2663 15.2401 14.6903 17.0643 11.8225L17.0649 11.8217C17.3603 11.3587 17.5292 10.6961 17.5292 9.99544C17.5292 9.29481 17.3603 8.63215 17.0649 8.16921L17.0643 8.1684C15.2401 5.30061 12.6766 3.72461 10 3.72461Z"
          fill="#4A154B"
        />
      </g>
    </svg>
  );
};
export const FilterIcon2 = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.9995 2.5H14.9994C15.8327 2.5 16.5145 3.18181 16.5145 4.01513V5.68177C16.5145 6.28782 16.1357 7.04538 15.7569 7.42417L12.4994 10.3029C12.0448 10.6817 11.7418 11.4393 11.7418 12.0453V15.3028C11.7418 15.7574 11.4388 16.3634 11.06 16.5907L9.99943 17.2725C9.01459 17.8786 7.65098 17.1967 7.65098 15.9846V11.9696C7.65098 11.4393 7.34795 10.7574 7.04493 10.3787L4.16618 7.34841C3.7874 6.96963 3.48438 6.28782 3.48438 5.83328V4.09088C3.48438 3.18181 4.16618 2.5 4.9995 2.5Z"
        stroke="#888888"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AssignContentIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.41003 22C3.41003 18.13 7.26003 15 12 15C12.96 15 13.89 15.13 14.76 15.37"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 18C22 18.75 21.79 19.46 21.42 20.06C21.21 20.42 20.94 20.74 20.63 21C19.93 21.63 19.01 22 18 22C16.54 22 15.27 21.22 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.74 14.58 15.61 15.5 14.88C16.19 14.33 17.06 14 18 14C20.21 14 22 15.79 22 18Z"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4399 18L17.4299 18.99L19.5599 17.02"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const RestoretIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.88683 1.56149C10.301 1.56149 10.6368 1.89728 10.6368 2.31149V10.3463L11.8175 9.16561C12.1104 8.87272 12.5853 8.87271 12.8782 9.16561C13.1711 9.4585 13.1711 9.93337 12.8782 10.2263L10.4166 12.6878C10.276 12.8285 10.0852 12.9075 9.8863 12.9075C9.68739 12.9075 9.49662 12.8285 9.35597 12.6878L6.89442 10.2263C6.60153 9.93337 6.60154 9.4585 6.89443 9.16561C7.18733 8.87271 7.6622 8.87272 7.95509 9.16561L9.13683 10.3474V2.31149C9.13683 1.89728 9.47262 1.56149 9.88683 1.56149ZM3.05905 10.1767C3.05905 9.7625 2.72327 9.42672 2.30905 9.42672C1.89484 9.42672 1.55905 9.7625 1.55905 10.1767C1.55905 12.4711 2.33908 14.5863 3.80855 16.1333C5.28367 17.6862 7.4091 18.6192 10.0014 18.6192C12.5937 18.6192 14.7191 17.6862 16.1942 16.1333C17.6637 14.5863 18.4437 12.4711 18.4437 10.1767C18.4437 9.7625 18.1079 9.42672 17.6937 9.42672C17.2795 9.42672 16.9437 9.7625 16.9437 10.1767C16.9437 12.1324 16.2814 13.8635 15.1067 15.1002C13.9376 16.331 12.2168 17.1192 10.0014 17.1192C7.78597 17.1192 6.06523 16.331 4.89611 15.1002C3.72133 13.8635 3.05905 12.1324 3.05905 10.1767Z"
        fill="currentcolor"
      />
    </svg>
  );
};
export const ArchiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.3327 8.33317V12.4998C18.3327 16.6665 16.666 18.3332 12.4993 18.3332H7.49935C3.33268 18.3332 1.66602 16.6665 1.66602 12.4998V7.49984C1.66602 3.33317 3.33268 1.6665 7.49935 1.6665H11.666"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3327 8.33317H14.9993C12.4993 8.33317 11.666 7.49984 11.666 4.99984V1.6665L18.3327 8.33317Z"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83398 10.8335H10.834"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83398 14.1665H9.16732"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeleteIcon2 = () => {
  return (
    <svg
      width="1.25rem"
      height="1.25rem"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.0835 4.1415L7.26683 3.04984C7.40016 2.25817 7.50016 1.6665 8.9085 1.6665H11.0918C12.5002 1.6665 12.6085 2.2915 12.7335 3.05817L12.9168 4.1415"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7078 7.6167L15.1661 16.0084C15.0745 17.3167 14.9995 18.3334 12.6745 18.3334H7.32447C4.99947 18.3334 4.92447 17.3167 4.8328 16.0084L4.29114 7.6167"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.6084 13.75H11.3834"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.9165 10.4165H12.0832"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LogoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.9526 5.97729C12.4945 4.43386 9.46482 4.43386 7.12109 5.74864C8.43587 4.31953 10.2651 3.51924 12.1515 3.40491C13.0662 3.5764 13.9808 3.91938 14.8382 4.43386C17.0105 5.8058 18.2681 8.09236 18.4396 10.5504C17.8679 8.72117 16.7247 7.06341 15.0097 5.97729H14.9526Z"
        fill="#1FA2F4"
      />
      <path
        d="M19.4692 19.5248C17.297 21.4684 14.4388 22.383 11.6377 22.1543C9.46551 22.3258 7.23611 21.8114 5.23536 20.5537C2.1485 18.6673 0.376414 15.409 0.0905937 11.9791C-0.252391 16.0378 1.63402 20.1536 5.23536 22.383C10.0371 25.4127 16.2109 24.0408 19.4692 19.4676V19.5248Z"
        fill="url(#paint0_linear_25376_23857)"
      />
      <path
        d="M18.0391 1.63288C16.0384 0.375273 13.809 -0.139204 11.6367 0.0322882C13.2945 0.146616 14.8951 0.661093 16.3813 1.63288C19.9827 3.86228 21.8691 7.9781 21.5261 12.0367C21.6976 14.2662 21.2403 16.6099 19.9827 18.725C19.8112 19.0108 19.6397 19.2966 19.4682 19.5252C20.3257 18.7821 21.0688 17.8675 21.6404 16.8385C24.7273 11.5794 23.1267 4.77691 18.0391 1.63288Z"
        fill="url(#paint1_linear_25376_23857)"
      />
      <path
        d="M21.5247 12.0371C21.4103 13.6949 20.8959 15.3526 19.9812 16.8389C18.0948 19.9829 14.9508 21.8693 11.5781 22.1552C14.3792 22.3838 17.2374 21.4692 19.4096 19.5256C19.5811 19.2398 19.7526 19.0111 19.9241 18.7253C21.1245 16.6674 21.639 14.3237 21.4675 12.0371H21.5247Z"
        fill="#A8C7FD"
      />
      <path
        d="M11.6365 0.0890954C7.69214 -0.196725 3.80499 1.68969 1.57559 5.40536C0.375139 7.46326 -0.139337 9.80699 0.0321548 12.0936C0.146483 10.4358 0.66096 8.77804 1.57559 7.29177C2.20439 6.26282 2.94752 5.34819 3.74782 4.60506C5.63424 1.91835 8.54961 0.374916 11.5793 0.14626L11.6365 0.0890954Z"
        fill="url(#paint2_linear_25376_23857)"
      />
      <path
        d="M16.4394 1.63245C14.9531 0.717829 13.2954 0.203353 11.6948 0.0318604C8.66507 0.260517 5.7497 1.86111 3.86328 4.49066C7.29313 1.46096 12.3807 0.889322 16.4394 3.46171C19.5262 5.34812 21.2983 8.60647 21.5842 12.0363C21.9271 7.97767 20.0407 3.86185 16.4394 1.63245Z"
        fill="#FEB6D7"
      />
      <path
        d="M11.637 22.1546C9.97923 22.0403 8.37864 21.5258 6.89237 20.554C1.80477 17.41 0.204172 10.6075 3.29103 5.34839C3.46253 5.06257 3.63402 4.77675 3.80551 4.5481C2.94805 5.29123 2.20492 6.20586 1.63327 7.23481C0.718649 8.77824 0.261336 10.3788 0.0898438 12.0366C0.375664 15.4664 2.14775 18.6676 5.23461 20.6112C7.23536 21.8688 9.46476 22.3833 11.637 22.2118V22.1546Z"
        fill="url(#paint3_linear_25376_23857)"
      />
      <path
        d="M20.0383 16.8956C18.1518 20.0396 15.0078 21.926 11.6351 22.2118C9.97738 22.0975 8.37678 21.583 6.89051 20.6113C1.80291 17.4101 0.202315 10.6075 3.28918 5.34844C3.46067 5.06262 3.63216 4.7768 3.80365 4.54814C7.2335 1.51845 12.3211 0.946805 16.3798 3.51919C19.4666 5.4056 21.2387 8.66396 21.5245 12.0938C21.4102 13.7516 20.8957 15.4093 19.9811 16.8956H20.0383ZM16.3798 4.54814C15.065 3.69068 13.5787 3.3477 12.0924 3.46202C9.11992 2.94755 6.03305 4.31949 4.37529 7.12053C3.74649 8.20665 3.4035 9.40709 3.28918 10.6075C2.26022 14.0945 3.575 17.9817 6.71902 19.9825C10.4347 22.3262 15.3508 21.0686 17.5802 17.2386C17.7517 16.9528 17.9232 16.6098 18.0375 16.3239C18.3233 15.981 18.6092 15.5808 18.8378 15.1807C21.01 11.5222 19.8668 6.77754 16.3226 4.60531L16.3798 4.54814Z"
        fill="url(#paint4_linear_25376_23857)"
      />
      <path
        d="M12.0923 3.40464C9.1198 2.89016 6.03294 4.2621 4.37518 7.06314C3.74638 8.14926 3.40339 9.34971 3.28906 10.5502C3.46055 9.92135 3.74638 9.29254 4.08936 8.7209C4.83249 7.40613 5.91861 6.43434 7.11906 5.74837C8.43383 4.31927 10.2631 3.51897 12.1495 3.40464H12.0923Z"
        fill="#73A3FD"
      />
      <path
        d="M16.3811 4.54787C15.0663 3.69041 13.58 3.34743 12.0938 3.46176C13.0084 3.63325 13.923 3.97623 14.7805 4.49071C16.9527 5.86265 18.2103 8.14921 18.3818 10.6073C18.9534 12.4365 18.8391 14.4944 18.0388 16.3237C18.3246 15.9807 18.6105 15.5805 18.8391 15.1804C21.0113 11.5219 19.8681 6.77727 16.3239 4.60504L16.3811 4.54787Z"
        fill="url(#paint5_linear_25376_23857)"
      />
      <path
        d="M18.3818 10.55C18.4961 12.0935 18.1531 13.7512 17.2957 15.1803C16.0952 17.1811 14.1517 18.4387 12.0938 18.8388C14.3232 18.9532 16.5525 18.0385 18.096 16.2665C18.8963 14.4372 18.9534 12.3793 18.439 10.55H18.3818Z"
        fill="#F85454"
      />
      <path
        d="M18.0367 16.2665C16.4932 18.0385 14.2638 18.9532 12.0344 18.8388C10.3195 19.1247 8.49027 18.8388 6.83251 17.8099C4.31729 16.2093 3.00251 13.4083 3.23117 10.55C2.20222 14.0371 3.51699 17.9242 6.66102 19.925C10.3767 22.2687 15.2928 21.0111 17.5222 17.1811C17.6937 16.8953 17.8652 16.5523 17.9795 16.2665H18.0367Z"
        fill="#FB6DDE"
      />
      <path
        d="M12.0944 18.8393C10.894 18.7822 9.69355 18.4392 8.60743 17.7532C5.06326 15.5238 3.91998 10.7792 6.09221 7.17785C6.37803 6.66337 6.72102 6.26322 7.12117 5.80591C5.92072 6.49188 4.8346 7.46367 4.09147 8.77844C3.74849 9.35008 3.46266 9.97889 3.29117 10.6077C3.06252 13.4659 4.37729 16.2669 6.89251 17.8675C8.49311 18.8965 10.3224 19.1823 12.0944 18.8965V18.8393Z"
        fill="#5A39CB"
      />
      <defs>
        <linearGradient
          id="paint0_linear_25376_23857"
          x1="-0.423883"
          y1="15.1232"
          x2="16.7825"
          y2="23.069"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5" stop-color="#1772F3" />
          <stop offset="1" stop-color="#20B4F3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_25376_23857"
          x1="19.5825"
          y1="18.9536"
          x2="16.6672"
          y2="0.146617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A237D1" />
          <stop offset="1" stop-color="#8F37CF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_25376_23857"
          x1="0.0321548"
          y1="6.03416"
          x2="11.6365"
          y2="6.03416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FA6F48" />
          <stop offset="1" stop-color="#FDA62F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_25376_23857"
          x1="9.12177"
          y1="21.8688"
          x2="1.17596"
          y2="8.09227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8A5F8" />
          <stop offset="1" stop-color="#FBBBF7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_25376_23857"
          x1="2.48888"
          y1="13.2942"
          x2="20.6099"
          y2="10.6075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCC4FE" />
          <stop offset="1" stop-color="#FEE5FD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_25376_23857"
          x1="17.8673"
          y1="10.8931"
          x2="10.779"
          y2="3.06161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBD7F7" />
          <stop offset="1" stop-color="#FCDAF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const MaximizeIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.5"
        x="0.0966797"
        y="0.0969696"
        width="32"
        height="32"
        rx="6"
        fill="#232323"
      />
      <g clip-path="url(#clip0_28609_8106)">
        <path
          d="M22.4973 9.69698L9.69727 22.497"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.4971 13.697V9.69698H18.4971"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.69727 18.497V22.497H13.6973"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.69727 9.69698L22.4973 22.497"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.69727 13.697V9.69698H13.6973"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.4971 18.497V22.497H18.4971"
          stroke="white"
          stroke-width="1.44"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_28609_8106">
          <rect
            width="19.2"
            height="19.2"
            fill="white"
            transform="translate(6.49707 6.49698)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MinimizeIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.5"
        x="0.0908203"
        y="0.0909119"
        width="30"
        height="30"
        rx="5.625"
        fill="#232323"
      />
      <g clip-path="url(#clip0_28609_3804)">
        <path
          d="M22.4255 7.75758L7.75879 22.4243"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.4251 12.3409V7.75758H17.8418"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.75879 17.8409V22.4242H12.3421"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.75879 7.75758L22.4255 22.4243"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.75879 12.3409V7.75758H12.3421"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.4251 17.8409V22.4242H17.8418"
          stroke="white"
          stroke-width="1.65"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_28609_3804">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(4.0918 4.09091)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
